const photoLib = require("../data/photo-library");
const generationDoneCheckIcon = require("../assets/icon/statuses-and-notifications/yes_icon.svg");

// Иконки чипов на экране «Генерация иллюстраций»
const illIconStyleUrl = require("../assets/ui/style_icon.svg");
const illIconSizeUrl = require("../assets/ui/size_icon.svg");
const illIconResoUrl = require("../assets/ui/reso_icon.svg");
const illIconAttachUrl = require("../assets/ui/attach_icon.svg");

// Миниатюры стилей
const illStyleThumbRealism = require("../assets/ui/styles/real_y_ads.png");
const illStyleThumbYandex3D = require("../assets/ui/styles/3d_y_ads.png");
const illStyleThumbKit = require("../assets/ui/styles/3d_kit.png");
const illStyleThumbGoods = require("../assets/ui/styles/3d_tovary.png");
const illStyleThumbDirect = require("../assets/ui/styles/3d_direct.png");

/**
 * Описание стилей генерации иллюстраций. id используется как ключ состояния,
 * payload — то, что отправляется в n8n.
 * Заметка: для Реалистичного стиля 3D-варианта нет, поэтому стиль Yango в реальности —
 * аналог 3D, а KIT/Товары/Директ — отдельные 3D-стили (всё через kind="3D").
 */
const ILL_STYLE_DEFS = [
  {
    id: "realism",
    shortName: "Реклама: реализм",
    title: "Реалистичный объект",
    thumb: illStyleThumbRealism,
    payload: { kind: "Realism", style: "Yandex" },
  },
  {
    id: "yandex3d",
    shortName: "Реклама: 3D",
    title: "3D Яндекс Реклама",
    thumb: illStyleThumbYandex3D,
    payload: { kind: "3D", style: "Yandex" },
  },
  {
    id: "kit",
    shortName: "KIT",
    title: "Яндекс KIT",
    thumb: illStyleThumbKit,
    payload: { kind: "3D", style: "Kit" },
  },
  {
    id: "goods",
    shortName: "Товары",
    title: "Яндекс Товары",
    thumb: illStyleThumbGoods,
    payload: { kind: "3D", style: "Goods" },
  },
  {
    id: "direct",
    shortName: "Директ",
    title: "Яндекс Директ (СМБ)",
    thumb: illStyleThumbDirect,
    payload: { kind: "3D", style: "Direct" },
  },
];

function assetUrl(mod) {
  if (typeof mod === "string") return mod;
  if (mod && typeof mod.default === "string") return mod.default;
  return "";
}

function getIllStyleDef(styleId) {
  for (let i = 0; i < ILL_STYLE_DEFS.length; i++) {
    if (ILL_STYLE_DEFS[i].id === styleId) return ILL_STYLE_DEFS[i];
  }
  return ILL_STYLE_DEFS[0];
}

const photosTags = {
  industry: photoLib.photosIndustryTags,
};

const images = photoLib.images;

let selectedImages = [];
let selectedPhotosTags = { industry: [] };

// ========================
// Slides library data
// ========================

const SLIDE_THEME_LIGHT = "light";
const SLIDE_THEME_DARK = "dark";
const SLIDE_THEME_OPTIONS = [SLIDE_THEME_LIGHT, SLIDE_THEME_DARK];
const slidesCloudUrls = require("../data/slides-cloud-urls.json");

/** Порядок типов слайдов в фильтрах и в сетке библиотеки (совпадает с внутренними ключами каталогов). */
const SLIDE_TYPE_ORDER = [
  "title",
  "separator",
  "basic",
  "cards",
  "chart",
  "scheme",
  "table",
  "big_number",
  "photo",
  "case",
  "screenshot",
  "final",
];

const SLIDE_TYPE_LABEL_RU = {
  title: "Титульные",
  separator: "Разделительные",
  basic: "Основные слайды",
  cards: "Карточки",
  chart: "Графики",
  scheme: "Схемы",
  table: "Таблицы",
  big_number: "Крупные цифры",
  photo: "Фото",
  case: "Кейсы",
  screenshot: "Скриншоты",
  final: "Финал и QR",
};

function slideTypeLabelRu(type) {
  return SLIDE_TYPE_LABEL_RU[type] || type;
}

function compareSlidesByTypeOrder(a, b) {
  const ia = SLIDE_TYPE_ORDER.indexOf(a.type);
  const ib = SLIDE_TYPE_ORDER.indexOf(b.type);
  const ra = ia === -1 ? SLIDE_TYPE_ORDER.length : ia;
  const rb = ib === -1 ? SLIDE_TYPE_ORDER.length : ib;
  if (ra !== rb) return ra - rb;
  return String(a.id).localeCompare(String(b.id));
}

function buildSlidesDataByTheme() {
  const dataByTheme = SLIDE_THEME_OPTIONS.reduce((acc, theme) => {
    acc[theme] = [];
    return acc;
  }, {});

  const byTheme = slidesCloudUrls && slidesCloudUrls.byTheme ? slidesCloudUrls.byTheme : {};
  Object.keys(byTheme).forEach((theme) => {
    if (!dataByTheme[theme]) dataByTheme[theme] = [];
    byTheme[theme].forEach((item) => {
      if (!item || !item.type || !item.index || !item.previewUrl || !item.pptxUrl) return;
      dataByTheme[theme].push({
        id: item.id || item.type + "_" + item.index,
        name: slideTypeLabelRu(item.type) + " " + item.index,
        type: item.type,
        preview: item.previewUrl,
        pptx: item.pptxUrl,
        tags: {
          type: [item.type],
        },
      });
    });
  });

  Object.keys(dataByTheme).forEach((theme) => {
    dataByTheme[theme].sort(compareSlidesByTypeOrder);
  });

  return dataByTheme;
}

const slidesDataByTheme = buildSlidesDataByTheme();
const discoveredSlideTypes = Array.from(
  new Set(
    SLIDE_THEME_OPTIONS.flatMap((theme) => slidesDataByTheme[theme].map((slide) => slide.type))
  )
);
const allTags = {
  type: SLIDE_TYPE_ORDER.filter((t) => discoveredSlideTypes.includes(t)).concat(
    discoveredSlideTypes
      .filter((t) => !SLIDE_TYPE_ORDER.includes(t))
      .sort((a, b) => a.localeCompare(b))
  ),
};

let selectedSlides = [];
let selectedTagsState = { type: [] };
let selectedSlidesTheme = SLIDE_THEME_LIGHT;

let activeLibraryTab = "slides";

// ========================
// Icons library data (src/assets/icon + src/data/icons-metadata.json)
// ========================

const iconsMetadata = require("../data/icons-metadata.json");

const ICON_FOLDER_TO_CATEGORY_RU = {
  actions: "Действия",
  "navigation-and-transport": "Навигация и транспорт",
  files: "Файлы",
  "statuses-and-notifications": "Статусы и уведомления",
  user: "Пользователь",
  "chats-and-reactions": "Чаты и реакции",
  payments: "Платежи",
  interface: "Интерфейс",
  other: "Другое",
};

/** Порядок чипов «Теги» для вкладки Иконки (русские названия = icon.category). */
const iconsCategories = [
  "Действия",
  "Навигация и транспорт",
  "Файлы",
  "Статусы и уведомления",
  "Пользователь",
  "Чаты и реакции",
  "Платежи",
  "Интерфейс",
  "Другое",
];

function buildIconsData() {
  const ctx = require.context("../assets/icon", true, /\.svg$/);
  return ctx.keys().map((k) => {
    const rel = k.replace(/^\.\//, "");
    const key = rel.replace(/\.svg$/, "");
    const folder = key.split("/")[0];
    const meta = iconsMetadata[key] || { name: key, tags: [] };
    const category = ICON_FOLDER_TO_CATEGORY_RU[folder] || "Другое";
    const tags = Array.isArray(meta.tags) ? meta.tags.slice() : [];
    const tailSlug = key.split("/").pop() || key;
    if (folder && tags.indexOf(folder) === -1) tags.push(folder);
    if (tailSlug && tags.indexOf(tailSlug) === -1) tags.push(tailSlug);
    return {
      id: key.replace(/\//g, "__"),
      content: ctx(k),
      name: meta.name || key,
      tags,
      category,
    };
  });
}

const iconsData = buildIconsData();

const flagsData = require("../data/flags-data.json");
const flagsCloudUrls = require("../data/flags-cloud-urls.json");
const logosData = require("../data/logos-data.json");
const logosCloudUrls = require("../data/logos-cloud-urls.json");
const logosMeta = require("../data/logos-categories.json");

/** Квадрат подложки — белый фон (тёмные/цветные логотипы с прозрачностью) */
const LOGO_LIGHT_TILE_FILES = new Set([
  "advertising/ads_en_black.svg",
  "advertising/ads_ru_black.svg",
  "advertising/urban_ads.png",
  "education/practicum.png",
  "text/ads_en_black_text.svg",
  "text/ads_ru_black_text.svg",
  "text/yandex_en_black_text.svg",
  "text/yandex_en_color_text.svg",
  "text/yandex_ru_black_text.svg",
  "text/yandex_ru_color_text.svg",
]);

/** Конфиг темы (шрифты, цвета). Используется для таблиц и как справочник для дизайна слайдов. */
const slidesTheme = (function () {
  try {
    return require("../data/slides-theme.json");
  } catch {
    return { theme: {}, table: {} };
  }
})();
const flagsCategories = {
  europe: "Европа",
  asia: "Азия",
  "north-america": "Северная Америка",
  "south-america": "Южная Америка",
  africa: "Африка",
  oceania: "Океания",
  "middle-east": "Ближний Восток",
  other: "Другое",
};

const FLAGS_RECENT_KEY = "gorazdo_flags_recent";
const FLAGS_FREQUENT_KEY = "gorazdo_flags_frequent";

/** Флаги для тега «Часто используемые» (фиксированный набор по скриншотам) */
const FLAGS_POPULAR_ISO = [
  "ru",
  "us",
  "gb",
  "fr",
  "id",
  "de",
  "cn",
  "kr",
  "jp",
  "in",
  "ca",
  "ir",
  "sa",
  "ae",
  "il",
  "eg",
  "kz",
  "by",
  "vn",
  "th",
  "eu",
];

let selectedFlags = [];
let selectedFlagsRegion = [];
let selectedFlagsPopular = null;

let selectedLogos = [];
let selectedLogosCategory = [];
let selectedLogosForm = [];

let selectedIcons = [];
let selectedIconsTags = [];
let iconColor = "#4B3CFF";

// ========================
// Text chat (редактура через n8n + Yandex AI)
// ========================

const TEXT_CHAT_MAX_TEXT_LEN = 12000;
/** Ячейки таблицы: отдельный лимит, чтобы тяжёлый context + Yandex не упирались в 504 (шлюз). */
const TEXT_CHAT_MAX_TABLE_CELL_LEN = 5000;
/** Запасной путь через `table.values`: максимум символов на всю таблицу в одном запросе. */
const TEXT_CHAT_TABLE_VALUES_TOTAL_CAP = 40000;
const TEXT_CHAT_HISTORY_MAX = 24;

let textChatMessages = [];
/** @type {null | { shapeId: string, slideIndex: number, start: number, length: number, text: string, fullShapeText: string }} */
let textChatLastSelectionCtx = null;
/** @type {null | { editId: number, viewingOriginal: boolean, items: Array<{ shapeId: string, slideIndex: number, mode: "shape"|"selection", originalText: string, modifiedText: string, selStart?: number, selLen?: number }> }} */
let textChatUndoSession = null;
let textChatNextEditId = 1;
let textChatLatestEditId = 0;
let textChatInFlight = false;

// ========================
// Генерация изображений (n8n, один синхронный POST — без БД и поллинга)
// ========================

/**
 * «Load failed» / «Failed to fetch» — сеть или CORS; в Office WebView часто без деталей.
 */
function formatFetchErrorMessage(err) {
  const raw = String(err && err.message ? err.message : err || "");
  if (/credentials not found/i.test(raw)) {
    return (
      "В n8n у узлов workflow не выбраны учётные данные, откройте импортированный флоу и на каждом узле " +
      "Replicate (Bearer), FAL Topaz / check-upscale / get-upscale (HTTP Header с ключом API) " +
      "привяжите сохранённые credentials, для загрузки в Cloudinary при необходимости проверьте URL и unsigned preset"
    );
  }
  if (/Load failed|Failed to fetch|NetworkError|network|fetch/i.test(raw)) {
    let hint =
      "Не удалось связаться с сервером генерации, для локальной отладки запустите «npm run dev-server» " +
      "(запросы идут через прокси /api/n8n и не упираются в CORS в PowerPoint) ";
    try {
      if (window.location.hostname !== "localhost" && window.location.hostname !== "127.0.0.1") {
        hint =
          "Не удалось связаться с сервером n8n, проверьте интернет, VPN и что в n8n включён доступ CORS для домена надстройки ";
      }
    } catch (_e) {
      /* ignore */
    }
    return hint + "Если флоу на другом URL — смените базовый адрес в коде надстройки";
  }
  return raw || "Ошибка генерации, попробуйте ещё раз";
}

/**
 * В development-сборке (__N8N_USE_LOCAL_PROXY__) запросы с localhost идут на /api/n8n → proxy,
 * чтобы обойти CORS в WebView PowerPoint («Load failed»).
 * В production-сборке всегда прямой URL n8n (нужны CORS на стороне n8n или свой бэкенд).
 */
function getN8nBaseUrl() {
  try {
    if (typeof __N8N_USE_LOCAL_PROXY__ !== "undefined" && __N8N_USE_LOCAL_PROXY__) {
      const h = window.location.hostname;
      if (h === "localhost" || h === "127.0.0.1") {
        return window.location.origin + "/api/n8n";
      }
    }
  } catch (_e) {
    /* ignore */
  }
  return "https://radiosinus.app.n8n.cloud";
}

const N8N_BASE = getN8nBaseUrl();
const N8N_START_URL = N8N_BASE + "/webhook/pic-generate";
/** Второй webhook: опрос результата по taskId (GET ?taskId= или POST — см. N8N_POLL_USE_POST). */
const N8N_POLL_URL = N8N_BASE + "/webhook/pic-generate-status";
/**
 * Иллюстрации (логика как в Illustration AIDSGN TG): отдельный workflow в n8n.
 * Ожидается тот же контракт ответа, что у фото: { success, imageUrl? } или async + taskId + опрос poll URL.
 */
const ILLUSTRATION_N8N_START_URL = N8N_BASE + "/webhook/illustration-generate";
const ILLUSTRATION_N8N_POLL_URL = N8N_BASE + "/webhook/illustration-generate-status";
/** Редактура текста через n8n → Yandex AI Studio (флоу: «PPT Text Edit — Yandex AI Studio v1.json»). */
const N8N_TEXT_EDIT_URL = N8N_BASE + "/webhook/pp-text-edit";
/**
 * Паузы между опросами (каждый запрос = отдельная execution в n8n). Сначала чаще, затем реже — меньше
 * «успехов» в списке за то же ожидание.
 */
const N8N_POLL_INTERVALS_MS = [3500, 5500, 8000, 12000];
const N8N_PHOTO_POLL_INTERVALS_MS = [3500, 5500, 8000, 20000];
/** true — опрос POST JSON { taskId }; false — GET с query taskId (как в path выше). */
const N8N_POLL_USE_POST = false;

/** Максимальное ожидание генерации (включая опрос статуса). */
const N8N_GENERATION_TIMEOUT_MS = 5 * 60 * 1000;
/** Генерация пары тёмный→светлый: два FAL подряд, даём 10 минут. */
const N8N_PHOTO_GENERATE_TIMEOUT_MS = 10 * 60 * 1000;

let generateState = "idle";
let generatedImageUrl = null;
/** @type {string|null} */
let generatedImageUrlLight = null;
/** @type {string|null} */
let generatedImageUrlDark = null;
let generateAbortController = null;
let photoGenerateHomeReady = false;
let illustrationGenerateHomeReady = false;

/**
 * Режим экрана «Генерация фотографий»:
 *  - "generate" — обычная генерация по промпту;
 *  - "edit"     — изменение существующего фото по промпту;
 *  - "upscale"  — улучшение качества существующего фото (запускается автоматически).
 * @type {"generate"|"edit"|"upscale"}
 */
let photoUiMode = "generate";
/** Исходник, который сейчас редактируется/улучшается (URL). */
/** @type {string|null} */
let pendingSourceUrl = null;

let selectedAspect = "horizontal";

/** Референс для генерации фото (PPT) — base64 + mime, как у иллюстраций. */
let picReferenceBase64 = null;
let picReferenceMimeType = null;
/** @type {null | "slide" | "file"} — заполняется при выборе референса (состояние для отладки/UI). */
let _picReferenceSource = null;

/** Экран «Генерация иллюстраций» (отдельное состояние от фото). */
let illGenerateState = "idle";
let illGeneratedImageUrl = null;
let illGenerateAbortController = null;
/** @type {"generate"|"edit"|"upscale"} */
let illUiMode = "generate";
let illPendingSourceUrl = null;
/** Текущий выбранный стиль — id из ILL_STYLE_DEFS. */
let illStyleId = "realism";
/** @type {"1:1"|"16:9"|"9:16"} */
let illAspect = "16:9";
/** 1920 (2K) или 3840 (4K). */
let illMaxSide = 1920;
/** Base64 без префикса data URL — референс со слайда (PNG) или с диска. */
let illReferenceBase64 = null;
let illReferenceMimeType = null;
/** @type {null | "slide" | "file"} */
let _illReferenceSource = null;
/** Флаг: главный экран иллюстраций уже инициализирован один раз (для сохранения state при выходе в меню). */
let _illustrationScreenInitialized = false;
/** Какой поповер сейчас открыт: "style" | "aspect" | "reso" | "attach" | null. */
let illOpenPopover = null;
/** Поповер на экране фото: "aspect" | "attach" | null. */
let picOpenPopover = null;

const HISTORY_KEY = "gorazdo_gen_history";
const ILL_HISTORY_KEY = "gorazdo_illustration_history";

const ILL_REF_MAX_FILE_BYTES = 12 * 1024 * 1024;

function clearPhotoReference() {
  picReferenceBase64 = null;
  picReferenceMimeType = null;
  _picReferenceSource = null;
  const fi = document.getElementById("picRefFileInput");
  if (fi) fi.value = "";
  refreshPicChips();
}

function clearIllReference() {
  illReferenceBase64 = null;
  illReferenceMimeType = null;
  _illReferenceSource = null;
  const fi = document.getElementById("illRefFileInput");
  if (fi) fi.value = "";
}

/**
 * @param {File} file
 * @returns {Promise<{ base64: string, mimeType: string }>}
 */
function readIllustrationRefFromFile(file) {
  return new Promise((resolve, reject) => {
    if (!file) {
      reject(new Error("Файл не выбран"));
      return;
    }
    if (!/^image\//i.test(file.type)) {
      reject(new Error("Нужен файл изображения (PNG, JPEG, WebP или GIF)"));
      return;
    }
    if (file.size > ILL_REF_MAX_FILE_BYTES) {
      reject(new Error("Файл слишком большой (максимум 12 МБ)"));
      return;
    }
    const reader = new FileReader();
    reader.onload = () => {
      const dataUrl = reader.result;
      if (typeof dataUrl !== "string") {
        reject(new Error("Не удалось прочитать файл"));
        return;
      }
      const comma = dataUrl.indexOf(",");
      if (comma === -1) {
        reject(new Error("Не удалось прочитать файл"));
        return;
      }
      resolve({
        base64: dataUrl.slice(comma + 1),
        mimeType: file.type && file.type.length ? file.type : "image/png",
      });
    };
    reader.onerror = () => reject(new Error("Не удалось прочитать файл"));
    reader.readAsDataURL(file);
  });
}

const EDIT_ICON_SVG =
  '<svg viewBox="0 0 24 28" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">' +
  '<path d="M16.6982 6.57324C17.7086 5.81044 19.1018 5.80905 20.1133 6.57031C20.2676 6.68648 20.4322 6.84959 20.7861 7.20215C21.1416 7.55619 21.3057 7.72056 21.4229 7.875C22.1908 8.88786 22.1924 10.2881 21.4268 11.3027C21.31 11.4575 21.1458 11.6225 20.791 11.9775L9.75293 23.0234L4.86816 24L4 23.1309L4.97656 18.2441L16.0273 7.20508C16.3804 6.85242 16.5442 6.6896 16.6982 6.57324ZM6.66309 19.1475L6.11621 21.8818L8.85059 21.335L16.7725 13.4082L14.5918 11.2275L6.66309 19.1475ZM7.89258 7.10742L11 8.12891V8.87012L7.89258 9.89258L6.87012 13H6.12988L5.10742 9.89258L2 8.87012V8.12891L5.10742 7.10742L6.12988 4H6.87012L7.89258 7.10742ZM19.0137 8.03418C18.6547 7.76396 18.1594 7.7644 17.8008 8.03516C17.7965 8.03852 17.7695 8.06103 17.6992 8.12793C17.6128 8.2102 17.5015 8.32098 17.3203 8.50195L16.0176 9.80273L18.1963 11.9834L19.4971 10.6816C19.6791 10.4995 19.7903 10.3877 19.873 10.3008C19.9422 10.2282 19.9634 10.2014 19.9658 10.1982C20.2375 9.8382 20.2373 9.34186 19.9648 8.98242C19.9667 8.98482 19.9494 8.96074 19.8721 8.87988C19.7891 8.7932 19.6775 8.68168 19.4951 8.5C19.3136 8.31923 19.2018 8.2091 19.1152 8.12695C19.0443 8.05964 19.0176 8.03728 19.0137 8.03418Z" fill="currentColor"/>' +
  "</svg>";

const IMPROVE_ICON_SVG =
  '<svg viewBox="0 0 24 28" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">' +
  '<path d="M12 21H14.5996C15.7527 21 16.4978 20.9984 17.0645 20.9521C17.6077 20.9078 17.8093 20.8326 17.9082 20.7822C18.2845 20.5905 18.5905 20.2845 18.7822 19.9082C18.8326 19.8093 18.9078 19.6077 18.9521 19.0645C18.9984 18.4978 19 17.7527 19 16.5996V14H21V16.5996C21 18.8398 21.0004 19.9608 20.5645 20.8164L20.4102 21.0918C20.0259 21.7183 19.4749 22.2289 18.8164 22.5645L18.6523 22.6406C17.816 22.9999 16.6999 23 14.5996 23H7V21H10V7H7V5H12V21ZM7 21H5V19H7V21ZM5 19H3V9H5V19ZM19.8926 6.10742L23 7.12891V7.87012L19.8926 8.89258L18.8701 12H18.1299L17.1074 8.89258L14 7.87012V7.12891L17.1074 6.10742L18.1299 3H18.8701L19.8926 6.10742ZM7 9H5V7H7V9Z" fill="currentColor"/>' +
  "</svg>";

/** Иконка «Удалить фон» (по образцу ui/back_icon.svg), через currentColor. */
const REMOVE_BG_ICON_SVG =
  '<svg viewBox="0 0 24 28" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">' +
  '<path d="M14.5996 5C16.8398 5 17.9608 4.99957 18.8164 5.43555C19.5689 5.81902 20.181 6.43109 20.5645 7.18359C21.0004 8.03924 21 9.1602 21 11.4004V16.5996C21 18.8398 21.0004 19.9608 20.5645 20.8164L20.4102 21.0918C20.0259 21.7183 19.4749 22.2289 18.8164 22.5645L18.6523 22.6406C17.816 22.9999 16.6999 23 14.5996 23H9.40039L7.91602 22.9932C6.72432 22.9744 5.96088 22.9041 5.34766 22.6406L5.18359 22.5645C4.52513 22.2289 3.97413 21.7183 3.58984 21.0918L3.43555 20.8164C2.99957 19.9608 3 18.8398 3 16.5996V11.4004C3 9.1602 2.99958 8.03924 3.43555 7.18359C3.81901 6.43109 4.43109 5.81902 5.18359 5.43555C5.82525 5.10861 6.61607 5.02728 7.91602 5.00684L9.40039 5H14.5996ZM9.40039 7C8.24728 7 7.50222 7.00155 6.93555 7.04785C6.39232 7.09224 6.19068 7.16739 6.0918 7.21777C5.71555 7.40951 5.40951 7.71555 5.21777 8.0918C5.16739 8.19068 5.09224 8.39235 5.04785 8.93555C5.00155 9.50222 5 10.2473 5 11.4004V16.5996C5 17.7527 5.00155 18.4978 5.04785 19.0645C5.09224 19.6077 5.16739 19.8093 5.21777 19.9082C5.40951 20.2844 5.71555 20.5905 6.0918 20.7822C6.19068 20.8326 6.39233 20.9078 6.93555 20.9521C7.50222 20.9984 8.24729 21 9.40039 21H12V7H9.40039ZM16.5 20.9814C16.7083 20.9744 16.8944 20.966 17.0645 20.9521C17.6077 20.9078 17.8093 20.8326 17.9082 20.7822C18.2844 20.5905 18.5905 20.2844 18.7822 19.9082C18.8326 19.8093 18.9078 19.6077 18.9521 19.0645C18.966 18.8944 18.9754 18.7083 18.9824 18.5H16.5V20.9814ZM16.5 11H14V13.5H16.5V16H14V18.5H16.5V16H19V13.5H16.5V11H18.998C18.9972 10.0699 18.9929 9.43377 18.9521 8.93555C18.9374 8.75567 18.9169 8.61364 18.8975 8.5H16.5V11ZM14 8.5H16.5V7.01758C16.0139 7.00124 15.4067 7 14.5996 7H14V8.5Z" fill="currentColor"/>' +
  "</svg>";

const PASTE_ICON_SVG =
  '<svg viewBox="0 0 24 28" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">' +
  '<path d="M14.5996 5C16.8398 5 17.9608 4.99957 18.8164 5.43555C19.5689 5.81902 20.181 6.43109 20.5645 7.18359C21.0004 8.03924 21 9.1602 21 11.4004V16.5996C21 18.8398 21.0004 19.9608 20.5645 20.8164L20.4102 21.0918C20.0259 21.7183 19.4749 22.2289 18.8164 22.5645L18.6523 22.6406C17.816 22.9999 16.6999 23 14.5996 23H9.40039L7.91602 22.9932C6.72432 22.9744 5.96088 22.9041 5.34766 22.6406L5.18359 22.5645C4.52513 22.2289 3.97413 21.7183 3.58984 21.0918L3.43555 20.8164C2.99957 19.9608 3 18.8398 3 16.5996V11.4004C3 9.1602 2.99958 8.03924 3.43555 7.18359C3.81901 6.43109 4.43109 5.81902 5.18359 5.43555C5.82525 5.10861 6.61607 5.02728 7.91602 5.00684L9.40039 5H14.5996ZM9.40039 7C8.24728 7 7.50222 7.00155 6.93555 7.04785C6.39232 7.09224 6.19068 7.16739 6.0918 7.21777C5.71555 7.40951 5.40951 7.71555 5.21777 8.0918C5.16739 8.19068 5.09224 8.39235 5.04785 8.93555C5.00155 9.50222 5 10.2473 5 11.4004V16.5996C5 17.7527 5.00155 18.4978 5.04785 19.0645C5.09224 19.6077 5.16739 19.8093 5.21777 19.9082C5.40951 20.2844 5.71555 20.5905 6.0918 20.7822C6.19068 20.8326 6.39233 20.9078 6.93555 20.9521C7.50222 20.9984 8.24729 21 9.40039 21H14.5996C15.7527 21 16.4978 20.9984 17.0645 20.9521C17.6077 20.9078 17.8093 20.8326 17.9082 20.7822C18.2844 20.5905 18.5905 20.2844 18.7822 19.9082C18.8326 19.8093 18.9078 19.6077 18.9521 19.0645C18.9984 18.4978 19 17.7527 19 16.5996V11.4004C19 10.2473 18.9984 9.50222 18.9521 8.93555C18.9078 8.39235 18.8326 8.19068 18.7822 8.0918C18.5905 7.71555 18.2845 7.40951 17.9082 7.21777C17.8093 7.16739 17.6077 7.09224 17.0645 7.04785C16.4978 7.00155 15.7527 7 14.5996 7H9.40039ZM13 10V13H16V15H13V18H11V15H8V13H11V10H13Z" fill="currentColor"/>' +
  "</svg>";

// ========================
// Utility
// ========================

function getHistory() {
  try {
    return JSON.parse(localStorage.getItem(HISTORY_KEY)) || [];
  } catch {
    return [];
  }
}

function addToHistory(url) {
  const history = getHistory();
  if (!history.includes(url)) {
    history.unshift(url);
    if (history.length > 20) history.pop();
    localStorage.setItem(HISTORY_KEY, JSON.stringify(history));
  }
}

function removeFromHistory(url) {
  const u = String(url || "");
  if (!u) return;
  const history = getHistory().filter((entry) => entry !== u);
  localStorage.setItem(HISTORY_KEY, JSON.stringify(history));
  renderHistory();
}

function getIllHistory() {
  try {
    return JSON.parse(localStorage.getItem(ILL_HISTORY_KEY)) || [];
  } catch {
    return [];
  }
}

function addToIllHistory(url) {
  const history = getIllHistory();
  if (!history.includes(url)) {
    history.unshift(url);
    if (history.length > 20) history.pop();
    localStorage.setItem(ILL_HISTORY_KEY, JSON.stringify(history));
  }
}

function removeFromIllHistory(url) {
  const u = String(url || "");
  if (!u) return;
  const history = getIllHistory().filter((entry) => entry !== u);
  localStorage.setItem(ILL_HISTORY_KEY, JSON.stringify(history));
  renderIllHistory();
}

let historyLayoutGeneration = 0;
let illHistoryLayoutGeneration = 0;

function loadImageAspectRatio(url) {
  return new Promise((resolve) => {
    const img = new Image();
    img.onload = () => {
      const w = img.naturalWidth || 1;
      const h = img.naturalHeight || 1;
      resolve(h / w);
    };
    img.onerror = () => {
      resolve(1);
    };
    img.src = url;
  });
}

/** Жадно кладёт URL в колонку с меньшей суммой h/w (при равной ширине колонок ≈ высота). Порядок urls — от новых к старым. */
function distributeHistoryToBalancedColumns(urls, ratios) {
  const left = [];
  const right = [];
  let leftSum = 0;
  let rightSum = 0;
  urls.forEach((url, i) => {
    const ratio = ratios[i];
    if (leftSum <= rightSum) {
      left.push(url);
      leftSum += ratio;
    } else {
      right.push(url);
      rightSum += ratio;
    }
  });
  return { left, right };
}

function autoResize(el) {
  el.style.height = "0px";
  el.style.height = el.scrollHeight + "px";
}

// ========================
// Gallery helpers
// ========================

const LIBRARY_COUNT_BY_TAB = {
  slides: () => selectedSlides.length,
  photos: () => selectedImages.length,
  icons: () => selectedIcons.length,
  flags: () => selectedFlags.length,
  logos: () => selectedLogos.length,
};

/** Макс. сторона вставляемого логотипа, pt (пропорции от исходного файла). */
const LOGO_INSERT_MAX_PT = 110;

function updateLibraryInsertButton() {
  const btn = document.getElementById("libraryInsertBtn");
  if (!btn) return;
  const getCount = LIBRARY_COUNT_BY_TAB[activeLibraryTab];
  const count = getCount ? getCount() : 0;
  btn.innerText = count > 0 ? "Вставить (" + count + ")" : "Вставить";
  btn.disabled = count === 0;
}

// ========================
// Icons library helpers
// ========================

function updateIconsTagsBadge() {
  const badge = document.getElementById("iconsTagsBadge");
  const clearIcon = document.querySelector(".icons-tags-clear");
  if (!badge) return;
  badge.textContent = selectedIconsTags.length;
  badge.classList.toggle("visible", selectedIconsTags.length > 0);
  if (clearIcon) clearIcon.classList.toggle("visible", selectedIconsTags.length > 0);
}

function renderIconsTags() {
  const container = document.querySelector('.tags-list[data-category="icons"]');
  if (!container) return;
  container.innerHTML = "";
  iconsCategories.forEach((cat) => {
    const chip = document.createElement("button");
    chip.className = "tag-chip";
    chip.textContent = cat;
    chip.dataset.category = cat;
    if (selectedIconsTags.includes(cat)) chip.classList.add("selected");
    chip.onclick = () => {
      const idx = selectedIconsTags.indexOf(cat);
      if (idx === -1) {
        selectedIconsTags.push(cat);
        chip.classList.add("selected");
      } else {
        selectedIconsTags.splice(idx, 1);
        chip.classList.remove("selected");
      }
      updateIconsTagsBadge();
      filterIcons();
    };
    container.appendChild(chip);
  });
}

function getSvgWithColor(svgContent, color) {
  return String(svgContent || "")
    .replace(/fill="#[0-9A-Fa-f]{3,8}"/gi, 'fill="' + color + '"')
    .replace(/fill='#([0-9A-Fa-f]{3,8})'/gi, "fill='" + color + "'")
    .replace(/fill:\s*#[0-9A-Fa-f]{3,8}/gi, "fill:" + color);
}

function setIconPreviewFromSvg(imgEl, svgText, color) {
  const renderedSvg = getSvgWithColor(svgText, color);
  const blob = new Blob([renderedSvg], { type: "image/svg+xml" });
  imgEl.src = URL.createObjectURL(blob);
}

function createIconCard(icon) {
  const card = document.createElement("div");
  card.className = "icon-card";
  card.dataset.iconId = icon.id;

  const wrapper = document.createElement("div");
  wrapper.className = "icon-svg-wrapper";

  const img = document.createElement("img");
  img.alt = icon.name;
  wrapper.appendChild(img);

  const checkbox = document.createElement("div");
  checkbox.className = "selectionCircle";
  checkbox.innerHTML =
    '<svg width="12" height="12" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">' +
    '<circle cx="10" cy="10" r="10" fill="white"/>' +
    "</svg>";

  card.appendChild(wrapper);
  card.appendChild(checkbox);

  card.onclick = () => {
    const idx = selectedIcons.findIndex((i) => i.id === icon.id);
    if (idx === -1) {
      selectedIcons.push(icon);
      card.classList.add("selected");
    } else {
      selectedIcons.splice(idx, 1);
      card.classList.remove("selected");
    }
    updateLibraryInsertButton();
  };

  setIconPreviewFromSvg(img, icon.content, iconColor);

  return card;
}

function filterIcons() {
  const searchInput = document.getElementById("librarySearch");
  const query = (searchInput ? searchInput.value : "").toLowerCase().trim();
  const words = query ? query.split(/\s+/).filter(Boolean) : [];
  const gallery = document.getElementById("iconsGallery");
  if (!gallery) return;

  gallery.innerHTML = "";

  const filtered = iconsData.filter((icon) => {
    const searchStr = (icon.name + " " + icon.tags.join(" ") + " " + icon.category).toLowerCase();
    const matchesSearch = words.length === 0 || words.every((w) => searchStr.includes(w));
    const matchesCategory =
      selectedIconsTags.length === 0 || selectedIconsTags.includes(icon.category);
    return matchesSearch && matchesCategory;
  });

  filtered.forEach((icon) => {
    const card = createIconCard(icon);
    if (selectedIcons.some((i) => i.id === icon.id)) card.classList.add("selected");
    gallery.appendChild(card);
  });
}

function loadIcons() {
  const tagsContainer = document.getElementById("iconsTagsContainer");
  const tagsPanel = document.getElementById("iconsTagsPanel");
  if (tagsContainer) tagsContainer.classList.remove("expanded");
  if (tagsPanel) tagsPanel.classList.remove("expanded");
  renderIconsTags();
  filterIcons();
  updateIconsTagsBadge();
  updateLibraryInsertButton();

  document.querySelectorAll(".icon-color-swatch").forEach((sw) => {
    sw.classList.toggle("active", sw.dataset.color === iconColor);
  });
}

function clearIconsSelection() {
  selectedIcons = [];
  document
    .querySelectorAll("#iconsGallery .icon-card")
    .forEach((c) => c.classList.remove("selected"));
  updateLibraryInsertButton();
}

// ========================
// Flags library helpers
// ========================

function getFlagImageUrl(flag) {
  const byIso = flagsCloudUrls && flagsCloudUrls.byIso ? flagsCloudUrls.byIso : {};
  return byIso[flag.iso] || "";
}

function getLogoImageUrl(logo) {
  const byFile = logosCloudUrls && logosCloudUrls.byFile ? logosCloudUrls.byFile : {};
  return byFile[logo.file] || "";
}

function getFlagsRecent() {
  try {
    return JSON.parse(localStorage.getItem(FLAGS_RECENT_KEY)) || [];
  } catch {
    return [];
  }
}

function getFlagsFrequent() {
  try {
    return JSON.parse(localStorage.getItem(FLAGS_FREQUENT_KEY)) || {};
  } catch {
    return {};
  }
}

function addFlagToRecent(iso) {
  let recent = getFlagsRecent().filter((x) => x !== iso);
  recent.unshift(iso);
  if (recent.length > 20) recent.pop();
  localStorage.setItem(FLAGS_RECENT_KEY, JSON.stringify(recent));
}

function addFlagToFrequent(iso) {
  const freq = getFlagsFrequent();
  freq[iso] = (freq[iso] || 0) + 1;
  localStorage.setItem(FLAGS_FREQUENT_KEY, JSON.stringify(freq));
}

function updateFlagsTagsBadge() {
  const badge = document.getElementById("flagsTagsBadge");
  const clearIcon = document.querySelector(".flags-tags-clear");
  if (!badge) return;
  const total = selectedFlagsRegion.length + (selectedFlagsPopular ? 1 : 0);
  badge.textContent = total;
  badge.classList.toggle("visible", total > 0);
  if (clearIcon) clearIcon.classList.toggle("visible", total > 0);
}

function renderFlagsTags() {
  const regionContainer = document.querySelector(".tags-list-flags-region");
  const popularContainer = document.querySelector(".tags-list-flags-popular");
  if (!regionContainer || !popularContainer) return;

  regionContainer.innerHTML = "";
  Object.entries(flagsCategories).forEach(([slug, label]) => {
    const chip = document.createElement("button");
    chip.className = "tag-chip";
    chip.textContent = label;
    chip.dataset.category = slug;
    if (selectedFlagsRegion.includes(slug)) chip.classList.add("selected");
    chip.onclick = () => {
      const idx = selectedFlagsRegion.indexOf(slug);
      if (idx === -1) {
        selectedFlagsRegion.push(slug);
        chip.classList.add("selected");
      } else {
        selectedFlagsRegion.splice(idx, 1);
        chip.classList.remove("selected");
      }
      selectedFlagsPopular = null;
      document
        .querySelectorAll(".tags-list-flags-popular .tag-chip")
        .forEach((c) => c.classList.remove("selected"));
      updateFlagsTagsBadge();
      filterFlags();
    };
    regionContainer.appendChild(chip);
  });

  popularContainer.innerHTML = "";
  ["Часто используемые", "Недавние"].forEach((label, i) => {
    const key = i === 0 ? "frequent" : "recent";
    const chip = document.createElement("button");
    chip.className = "tag-chip";
    chip.textContent = label;
    chip.dataset.popular = key;
    if (selectedFlagsPopular === key) chip.classList.add("selected");
    chip.onclick = () => {
      selectedFlagsPopular = selectedFlagsPopular === key ? null : key;
      selectedFlagsRegion = [];
      document
        .querySelectorAll(".tags-list-flags-region .tag-chip")
        .forEach((c) => c.classList.remove("selected"));
      document
        .querySelectorAll(".tags-list-flags-popular .tag-chip")
        .forEach((c) => c.classList.toggle("selected", c.dataset.popular === selectedFlagsPopular));
      updateFlagsTagsBadge();
      filterFlags();
    };
    popularContainer.appendChild(chip);
  });
}

function createFlagCard(flag) {
  const card = document.createElement("div");
  card.className = "flag-card";
  card.dataset.flagIso = flag.iso;

  const wrapper = document.createElement("div");
  wrapper.className = "flag-img-wrapper";
  const img = document.createElement("img");
  img.src = getFlagImageUrl(flag);
  img.alt = flag.name;
  img.className = "flag-img";
  img.onerror = () => wrapper.classList.add("flag-img-error");
  wrapper.appendChild(img);

  const label = document.createElement("div");
  label.className = "flag-label";
  label.textContent = flag.name;

  const checkbox = document.createElement("div");
  checkbox.className = "selectionCircle";
  checkbox.innerHTML =
    '<svg width="12" height="12" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="10" cy="10" r="10" fill="white"/></svg>';

  card.appendChild(wrapper);
  card.appendChild(checkbox);
  card.appendChild(label);

  card.onclick = () => {
    const idx = selectedFlags.findIndex((f) => f.iso === flag.iso);
    if (idx === -1) {
      selectedFlags.push(flag);
      card.classList.add("selected");
    } else {
      selectedFlags.splice(idx, 1);
      card.classList.remove("selected");
    }
    updateLibraryInsertButton();
  };

  return card;
}

function filterFlags() {
  const searchInput = document.getElementById("librarySearch");
  const query = (searchInput ? searchInput.value : "").toLowerCase().trim();
  const gallery = document.getElementById("flagsGallery");
  if (!gallery) return;

  gallery.innerHTML = "";

  let filtered = flagsData;

  if (selectedFlagsPopular === "recent") {
    const recent = getFlagsRecent();
    const recentSet = new Set(recent);
    filtered = flagsData
      .filter((f) => recentSet.has(f.iso))
      .sort((a, b) => recent.indexOf(a.iso) - recent.indexOf(b.iso));
  } else if (selectedFlagsPopular === "frequent") {
    const freqSet = new Set(FLAGS_POPULAR_ISO);
    filtered = flagsData.filter((f) => freqSet.has(f.iso));
  } else if (selectedFlagsRegion.length > 0) {
    const regionSet = new Set(selectedFlagsRegion);
    filtered = flagsData.filter((f) => regionSet.has(f.category));
  }

  if (query) {
    const words = query.split(/\s+/).filter(Boolean);
    filtered = filtered.filter((f) => words.every((w) => f.name.toLowerCase().includes(w)));
  }

  filtered.forEach((flag) => {
    const card = createFlagCard(flag);
    if (selectedFlags.some((f) => f.iso === flag.iso)) card.classList.add("selected");
    gallery.appendChild(card);
  });
}

function loadFlags() {
  const tagsContainer = document.getElementById("flagsTagsContainer");
  const tagsPanel = document.getElementById("flagsTagsPanel");
  if (tagsContainer) tagsContainer.classList.remove("expanded");
  if (tagsPanel) tagsPanel.classList.remove("expanded");
  renderFlagsTags();
  filterFlags();
  updateFlagsTagsBadge();
  updateLibraryInsertButton();
}

function clearFlagsSelection() {
  selectedFlags = [];
  document
    .querySelectorAll("#flagsGallery .flag-card")
    .forEach((c) => c.classList.remove("selected"));
  updateLibraryInsertButton();
}

async function insertSelectedFlags() {
  if (selectedFlags.length === 0) return;
  const btn = document.getElementById("libraryInsertBtn");
  if (btn) {
    btn.disabled = true;
    btn.textContent = "Вставка...";
  }
  const toInsert = [...selectedFlags];
  const flagHeightPt = FLAG_INSERT_WIDTH_PT * FLAG_ASPECT_HEIGHT_RATIO;
  const center = getCenterPositionPt(FLAG_INSERT_WIDTH_PT, flagHeightPt);
  try {
    for (let i = 0; i < toInsert.length; i++) {
      const flag = toInsert[i];
      addFlagToRecent(flag.iso);
      addFlagToFrequent(flag.iso);
      const url = getFlagImageUrl(flag);
      await insertImage(
        url,
        i === 0,
        i,
        toInsert.length,
        1,
        FLAG_INSERT_WIDTH_PT,
        center.left,
        center.top
      );
    }
    clearFlagsSelection();
  } catch (err) {
    console.error("Failed to insert flags:", err);
  }
  updateLibraryInsertButton();
}

// ========================
// Logos library helpers
// ========================

function updateLogosTagsBadge() {
  const badge = document.getElementById("logosTagsBadge");
  const clearIcon = document.querySelector(".logos-tags-clear");
  if (!badge) return;
  const total = selectedLogosCategory.length + selectedLogosForm.length;
  badge.textContent = total;
  badge.classList.toggle("visible", total > 0);
  if (clearIcon) clearIcon.classList.toggle("visible", total > 0);
}

function renderLogosTags() {
  const catEl = document.querySelector(".tags-list-logos-category");
  const formEl = document.querySelector(".tags-list-logos-form");
  if (!catEl || !formEl) return;
  const order =
    logosMeta.order && logosMeta.order.length
      ? logosMeta.order
      : Object.keys(logosMeta.labels || {});
  const labels = logosMeta.labels || {};

  catEl.innerHTML = "";
  order.forEach((slug) => {
    const label = labels[slug];
    if (!label) return;
    const chip = document.createElement("button");
    chip.className = "tag-chip";
    chip.type = "button";
    chip.textContent = label;
    chip.dataset.category = slug;
    if (selectedLogosCategory.indexOf(slug) !== -1) chip.classList.add("selected");
    chip.onclick = () => {
      const idx = selectedLogosCategory.indexOf(slug);
      if (idx === -1) {
        selectedLogosCategory.push(slug);
        chip.classList.add("selected");
      } else {
        selectedLogosCategory.splice(idx, 1);
        chip.classList.remove("selected");
      }
      updateLogosTagsBadge();
      filterLogos();
    };
    catEl.appendChild(chip);
  });

  formEl.innerHTML = "";
  const formLabels = logosMeta.form || { round: "Круглые", text: "Текстовые" };
  Object.entries(formLabels).forEach(([key, text]) => {
    const chip = document.createElement("button");
    chip.className = "tag-chip";
    chip.type = "button";
    chip.textContent = text;
    chip.dataset.form = key;
    if (selectedLogosForm.indexOf(key) !== -1) chip.classList.add("selected");
    chip.onclick = () => {
      const idx = selectedLogosForm.indexOf(key);
      if (idx === -1) {
        selectedLogosForm.push(key);
        chip.classList.add("selected");
      } else {
        selectedLogosForm.splice(idx, 1);
        chip.classList.remove("selected");
      }
      updateLogosTagsBadge();
      filterLogos();
    };
    formEl.appendChild(chip);
  });
}

function createLogoCard(logo) {
  const card = document.createElement("div");
  card.className = "logo-card";
  if (LOGO_LIGHT_TILE_FILES.has(logo.file)) {
    card.classList.add("logo-card--light-tile");
  }
  card.dataset.logoId = logo.id;

  const wrapper = document.createElement("div");
  wrapper.className = "logo-img-wrapper";
  const img = document.createElement("img");
  img.src = getLogoImageUrl(logo);
  img.alt = logo.name;
  img.className = "logo-img";
  img.onerror = () => wrapper.classList.add("logo-img-error");
  wrapper.appendChild(img);

  const cap = document.createElement("div");
  cap.className = "logo-label";
  cap.textContent = logo.name;

  const checkbox = document.createElement("div");
  checkbox.className = "selectionCircle";
  checkbox.innerHTML =
    '<svg width="12" height="12" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="10" cy="10" r="10" fill="white"/></svg>';

  card.appendChild(wrapper);
  card.appendChild(checkbox);
  card.appendChild(cap);

  card.onclick = () => {
    const idx = selectedLogos.findIndex((l) => l.id === logo.id);
    if (idx === -1) {
      selectedLogos.push(logo);
      card.classList.add("selected");
    } else {
      selectedLogos.splice(idx, 1);
      card.classList.remove("selected");
    }
    updateLibraryInsertButton();
  };

  return card;
}

/** Сначала круглые (form !== "text"), внутри — по name по-русски; текстовые — внизу, тоже по алфавиту. */
function sortLogosForDisplay(list) {
  const byName = (a, b) =>
    (a.name || "").localeCompare(b.name || "", "ru", { sensitivity: "base" });
  const round = list.filter((l) => l.form !== "text").sort(byName);
  const text = list.filter((l) => l.form === "text").sort(byName);
  return round.concat(text);
}

function filterLogos() {
  const searchInput = document.getElementById("librarySearch");
  const query = (searchInput ? searchInput.value : "").toLowerCase().trim();
  const gallery = document.getElementById("logosGallery");
  if (!gallery) return;

  gallery.innerHTML = "";

  let list = logosData;
  if (selectedLogosCategory.length > 0) {
    const set = new Set(selectedLogosCategory);
    list = list.filter((l) => set.has(l.category));
  }
  if (selectedLogosForm.length > 0) {
    const fset = new Set(selectedLogosForm);
    list = list.filter((l) => fset.has(l.form));
  }

  if (query) {
    const words = query.split(/\s+/).filter(Boolean);
    list = list.filter((l) => {
      const s = (l.name + " " + l.id + " " + (l.type || "")).toLowerCase();
      return words.every((w) => s.indexOf(w) !== -1);
    });
  }

  list = sortLogosForDisplay(list);

  list.forEach((logo) => {
    const card = createLogoCard(logo);
    if (selectedLogos.some((x) => x.id === logo.id)) card.classList.add("selected");
    gallery.appendChild(card);
  });
}

function loadLogos() {
  const tagsContainer = document.getElementById("logosTagsContainer");
  const tagsPanel = document.getElementById("logosTagsPanel");
  if (tagsContainer) tagsContainer.classList.remove("expanded");
  if (tagsPanel) tagsPanel.classList.remove("expanded");
  renderLogosTags();
  filterLogos();
  updateLogosTagsBadge();
  updateLibraryInsertButton();
}

function clearLogosSelection() {
  selectedLogos = [];
  document
    .querySelectorAll("#logosGallery .logo-card")
    .forEach((c) => c.classList.remove("selected"));
  updateLibraryInsertButton();
}

async function insertSelectedLogos() {
  if (selectedLogos.length === 0) return;
  const btn = document.getElementById("libraryInsertBtn");
  if (btn) {
    btn.disabled = true;
    btn.textContent = "Вставка...";
  }
  const toInsert = [...selectedLogos];
  clearLogosSelection();
  try {
    for (let i = 0; i < toInsert.length; i++) {
      const url = getLogoImageUrl(toInsert[i]);
      const dims = await loadImageDimensions(url);
      const base = dims
        ? getImageInsertSizePt(dims.width, dims.height)
        : { widthPt: IMAGE_DEFAULT_SIZE_PT, heightPt: IMAGE_DEFAULT_SIZE_PT };
      const m = Math.max(base.widthPt, base.heightPt, 0.1);
      const w = (LOGO_INSERT_MAX_PT * base.widthPt) / m;
      const h = (LOGO_INSERT_MAX_PT * base.heightPt) / m;
      const center = getCenterPositionPt(w, h);
      await insertImage(url, i === 0, i, toInsert.length, 1, w, center.left, center.top);
    }
  } catch (err) {
    console.error("Failed to insert logos:", err);
  }
  if (btn) {
    btn.disabled = false;
    btn.textContent = "Вставить";
  }
  updateLibraryInsertButton();
}

function svgToPngDataUrl(svgContent, color, size) {
  const svgText = getSvgWithColor(svgContent, color);
  return new Promise((resolve, reject) => {
    const img = new Image();
    img.onload = () => {
      const canvas = document.createElement("canvas");
      canvas.width = size || 96;
      canvas.height = size || 96;
      const ctx = canvas.getContext("2d");
      ctx.drawImage(img, 0, 0);
      resolve(canvas.toDataURL("image/png"));
    };
    img.onerror = reject;
    img.src = "data:image/svg+xml;base64," + btoa(unescape(encodeURIComponent(svgText)));
  });
}

async function insertSelectedIcons() {
  if (selectedIcons.length === 0) return;
  const btn = document.getElementById("libraryInsertBtn");
  if (btn) {
    btn.disabled = true;
    btn.textContent = "Вставка...";
  }
  const toInsert = [...selectedIcons];
  const iconSizePt = IMAGE_DEFAULT_SIZE_PT;
  const center = getCenterPositionPt(iconSizePt, iconSizePt);
  const svgOptions = (i) => ({
    coercionType: Office.CoercionType.XmlSvg,
    imageLeft: center.left + i * INSERT_OFFSET_STEP_PT,
    imageTop: center.top + i * INSERT_OFFSET_STEP_PT,
    imageWidth: iconSizePt,
  });
  const pngFallback = async (i) => {
    const icon = toInsert[i];
    const dataUrl = await svgToPngDataUrl(icon.content, iconColor, 192);
    const base64 = dataUrl.split(",")[1];
    await new Promise((res, rej) => {
      Office.context.document.setSelectedDataAsync(
        base64,
        {
          coercionType: Office.CoercionType.Image,
          imageLeft: center.left + i * INSERT_OFFSET_STEP_PT,
          imageTop: center.top + i * INSERT_OFFSET_STEP_PT,
          imageWidth: iconSizePt,
        },
        (r) => (r.status === Office.AsyncResultStatus.Succeeded ? res() : rej(r.error))
      );
    });
  };
  try {
    for (let i = 0; i < toInsert.length; i++) {
      const icon = toInsert[i];
      const svgText = getSvgWithColor(icon.content, iconColor);
      try {
        await new Promise((res, rej) => {
          Office.context.document.setSelectedDataAsync(svgText, svgOptions(i), (r) =>
            r.status === Office.AsyncResultStatus.Succeeded ? res() : rej(r.error)
          );
        });
      } catch (svgErr) {
        console.warn("XmlSvg insert failed, using PNG fallback:", svgErr);
        await pngFallback(i);
      }
    }
    clearIconsSelection();
  } catch (err) {
    console.error("Failed to insert icons:", err);
  }
  updateLibraryInsertButton();
}

function createImageCard(img) {
  const wrapper = document.createElement("div");
  wrapper.className = "galleryCard";

  const el = document.createElement("img");
  el.src = img.file;
  el.className = "galleryImage";
  el.alt = "";
  el.onerror = function () {
    wrapper.classList.add("galleryCard-loadError");
  };

  const checkbox = document.createElement("div");
  checkbox.className = "selectionCircle";
  checkbox.innerHTML =
    '<svg width="12" height="12" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">' +
    '<circle cx="10" cy="10" r="10" fill="white"/>' +
    "</svg>";

  wrapper.appendChild(el);
  wrapper.appendChild(checkbox);

  wrapper.onclick = () => {
    const index = selectedImages.indexOf(img.file);
    if (index === -1) {
      selectedImages.push(img.file);
      wrapper.classList.add("selected");
    } else {
      selectedImages.splice(index, 1);
      wrapper.classList.remove("selected");
    }
    updateLibraryInsertButton();
  };

  return wrapper;
}

function updatePhotosTagsBadge() {
  const badge = document.getElementById("photosTagsBadge");
  const clearIcon = document.querySelector(".photos-tags-clear");
  if (!badge) return;
  const total = selectedPhotosTags.industry.length;
  badge.textContent = total;
  badge.classList.toggle("visible", total > 0);
  if (clearIcon) clearIcon.classList.toggle("visible", total > 0);
}

function renderPhotosTags() {
  Object.keys(photosTags).forEach((category) => {
    const container = document.querySelector('.tags-list[data-category="' + category + '"]');
    if (!container) return;
    container.innerHTML = "";
    photosTags[category].forEach((tag) => {
      const chip = document.createElement("button");
      chip.className = "tag-chip";
      chip.textContent = tag;
      if (selectedPhotosTags[category].includes(tag)) chip.classList.add("selected");
      chip.onclick = () => {
        const idx = selectedPhotosTags[category].indexOf(tag);
        if (idx === -1) {
          selectedPhotosTags[category].push(tag);
          chip.classList.add("selected");
        } else {
          selectedPhotosTags[category].splice(idx, 1);
          chip.classList.remove("selected");
        }
        updatePhotosTagsBadge();
        filterImages();
      };
      container.appendChild(chip);
    });
  });
}

function loadImages() {
  loadPhotos();
}

function loadPhotos() {
  const tagsContainer = document.getElementById("photosTagsContainer");
  const tagsPanel = document.getElementById("photosTagsPanel");
  if (tagsContainer) tagsContainer.classList.remove("expanded");
  if (tagsPanel) tagsPanel.classList.remove("expanded");
  renderPhotosTags();
  filterImages();
  updatePhotosTagsBadge();
  updateLibraryInsertButton();
}

function filterImages() {
  const searchInput = document.getElementById("librarySearch");
  const query = (searchInput ? searchInput.value : "").toLowerCase().trim();
  const words = query ? query.split(/\s+/).filter(Boolean) : [];
  const gallery = document.getElementById("gallery");
  if (!gallery) return;
  gallery.innerHTML = "";

  const hasIndustry = selectedPhotosTags.industry.length > 0;

  const filtered = images.filter((img) => {
    const searchStr = (img.searchTags || []).join(" ").toLowerCase();
    const matchesSearch = words.length === 0 || words.every((w) => searchStr.includes(w));

    const matchesIndustry =
      !hasIndustry ||
      selectedPhotosTags.industry.some((t) => (img.tags.industry || []).includes(t));

    return matchesSearch && matchesIndustry;
  });

  filtered.forEach((img) => {
    const card = createImageCard(img);
    if (selectedImages.indexOf(img.file) !== -1) card.classList.add("selected");
    gallery.appendChild(card);
  });
}

function clearGallerySelection() {
  document.querySelectorAll("#gallery .galleryCard").forEach((card) => {
    card.classList.remove("selected");
  });
}

// ========================
// Image insertion into slide
// ========================

/** Сдвиг каждого следующего фото/иконки при вставке нескольких подряд (в точках): на столько правее и ниже предыдущего. */
const INSERT_OFFSET_STEP_PT = 15;

/** Размер слайда 67.73×38.1 см = 1920×1080 pt (Full HD) */
const SLIDE_WIDTH_PT = 1920;
const SLIDE_HEIGHT_PT = 1080;

/**
 * Загружает картинку по URL и возвращает base64 (без префикса data URL).
 */
function blobToBase64(blob) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onloadend = () => {
      const result = reader.result;
      if (typeof result === "string") {
        resolve(result.split(",")[1] || "");
      } else {
        reject(new Error("FileReader did not return a string"));
      }
    };
    reader.onerror = () => reject(reader.error);
    reader.readAsDataURL(blob);
  });
}

async function imageUrlToBase64(imageUrl) {
  const response = await fetch(imageUrl);
  if (!response.ok) {
    throw new Error("Failed to fetch image: " + response.status);
  }
  const blob = await response.blob();
  return blobToBase64(blob);
}

/**
 * Возвращает размер вставки в пунктах (PowerPoint по умолчанию: 72pt по большей стороне, пропорционально по другой).
 */
function getImageInsertSizePt(imgWidth, imgHeight) {
  const defaultPt = IMAGE_DEFAULT_SIZE_PT;
  if (!imgWidth || !imgHeight) return { widthPt: defaultPt, heightPt: defaultPt };
  if (imgWidth >= imgHeight) {
    return { widthPt: defaultPt, heightPt: defaultPt * (imgHeight / imgWidth) };
  }
  return { widthPt: defaultPt * (imgWidth / imgHeight), heightPt: defaultPt };
}

/** Доля от меньшей стороны фигуры для радиуса скругления RoundRectangle, если у исходного фото нет adjustments (0.15 ≈ заметное скругление). */
const DEFAULT_ROUND_RECT_ADJUSTMENT = 0.15;

/** Типичный размер слайда 16:9 в точках (API не даёт размеры слайда). Для автоопределения «фото на весь экран». */
const TYPICAL_SLIDE_WIDTH_PT = 960;
const TYPICAL_SLIDE_HEIGHT_PT = 540;
const FULL_SLIDE_THRESHOLD = 0.9;

/**
 * Замена выделенного на слайде фото/плейсхолдера на картинку из надстройки.
 *
 * Сценарий: пользователь выделяет фото (или плашку) на слайде → выбирает фото в надстройке → нажимает «Вставить».
 * Действия: удаляем выделенную фигуру, создаём новую (RoundRectangle или Rectangle) тех же размеров и слоя,
 * заливка — переданная картинка (base64). Скругление сохраняем; картинку не сжимаем и не обрезаем — кадрирование можно менять в PowerPoint.
 *
 * Всё в одном PowerPoint.run, чтобы выделение не терялось.
 *
 * @param {string} base64data — base64-строка картинки (без префикса data URL)
 * @returns {Promise<boolean>} true, если вставка в фигуру прошла успешно; false — вставка по умолчанию (в центр слайда)
 */
async function tryInsertImageIntoSelectedShape(base64data) {
  if (typeof PowerPoint === "undefined") return false;
  if (!base64data || typeof base64data !== "string") return false;
  try {
    return await PowerPoint.run(async (context) => {
      const selectedShapes = context.presentation.getSelectedShapes();
      const countResult = selectedShapes.getCount();
      await context.sync();
      if (countResult.value !== 1) return false;

      const shape = selectedShapes.getItemAt(0);
      const slide = context.presentation.getSelectedSlides().getItemAt(0);
      shape.load("type, width, height, left, top, zOrderPosition");
      const shapesCountResult = slide.shapes.getCount();
      await context.sync();

      const widthPt = shape.width;
      const heightPt = shape.height;
      const left = shape.left;
      const top = shape.top;
      const zOrderPosition = shape.zOrderPosition;
      const shapesCountBefore = shapesCountResult.value;
      const shapeType = shape.type;

      let geometricType;
      let cornerAdjustment = null;

      if (shapeType === "Image") {
        shape.adjustments.load("count");
        await context.sync();
        if (shape.adjustments.count >= 1) {
          const adjResult = shape.adjustments.get(0);
          await context.sync();
          cornerAdjustment = adjResult.value;
        }
        const isFullSlide =
          widthPt >= TYPICAL_SLIDE_WIDTH_PT * FULL_SLIDE_THRESHOLD &&
          heightPt >= TYPICAL_SLIDE_HEIGHT_PT * FULL_SLIDE_THRESHOLD;
        geometricType = isFullSlide ? "Rectangle" : "RoundRectangle";
        if (geometricType === "RoundRectangle" && cornerAdjustment == null) {
          cornerAdjustment = DEFAULT_ROUND_RECT_ADJUSTMENT;
        }
      } else if (shapeType === "Placeholder") {
        shape.placeholderFormat.load("type");
        await context.sync();
        const phType = shape.placeholderFormat.type;
        if (phType !== "Picture" && phType !== "Content") return false;
        const isFullSlide =
          widthPt >= TYPICAL_SLIDE_WIDTH_PT * FULL_SLIDE_THRESHOLD &&
          heightPt >= TYPICAL_SLIDE_HEIGHT_PT * FULL_SLIDE_THRESHOLD;
        geometricType = isFullSlide ? "Rectangle" : "RoundRectangle";
        if (geometricType === "RoundRectangle") cornerAdjustment = DEFAULT_ROUND_RECT_ADJUSTMENT;
      } else if (shapeType === "GeometricShape") {
        const isFullSlide =
          widthPt >= TYPICAL_SLIDE_WIDTH_PT * FULL_SLIDE_THRESHOLD &&
          heightPt >= TYPICAL_SLIDE_HEIGHT_PT * FULL_SLIDE_THRESHOLD;
        geometricType = isFullSlide ? "Rectangle" : "RoundRectangle";
        if (geometricType === "RoundRectangle") cornerAdjustment = DEFAULT_ROUND_RECT_ADJUSTMENT;
      } else {
        return false;
      }

      shape.delete();
      await context.sync();

      const newShape = slide.shapes.addGeometricShape(geometricType, {
        left,
        top,
        width: widthPt,
        height: heightPt,
      });
      newShape.fill.setImage(base64data);
      try {
        newShape.lineFormat.visible = false;
      } catch {
        /* контур недоступен для части типов фигур */
      }
      if (geometricType === "RoundRectangle" && cornerAdjustment != null) {
        try {
          newShape.adjustments.set(0, cornerAdjustment);
        } catch {
          /* adjustments недоступны на части сборок хоста */
        }
      }
      await context.sync();

      const sendBackwardCount = shapesCountBefore - 1 - zOrderPosition;
      for (let i = 0; i < sendBackwardCount; i++) {
        newShape.setZOrder("SendBackward");
        await context.sync();
      }
      return true;
    });
  } catch (e) {
    console.error("tryInsertImageIntoSelectedShape:", e);
    return false;
  }
}

const IMAGE_DEFAULT_SIZE_PT = 72;
const FLAG_INSERT_WIDTH_PT = 60;
const FLAG_ASPECT_HEIGHT_RATIO = 2 / 3;

/** Координаты левого верхнего угла для размещения центра изображения в центре слайда. */
function getCenterPositionPt(imageWidthPt, imageHeightPt) {
  return {
    left: (SLIDE_WIDTH_PT - imageWidthPt) / 2,
    top: (SLIDE_HEIGHT_PT - imageHeightPt) / 2,
  };
}

/**
 * @param {string} imageUrl — URL картинки
 * @param {boolean} preferSelectedShape — пробовать вставку в выделенную фигуру
 * @param {number} [insertIndex] — индекс в серии (0, 1, 2, …); используется только при insertTotal > 1
 * @param {number} [insertTotal] — сколько всего вставляется за раз; при 1 отступ не ставится
 * @param {number} [insertScale] — множитель размера (1 = по умолчанию)
 * @param {number} [imageWidthPt] — ширина в пунктах (приоритет над insertScale)
 * @param {number} [imageLeftPt] — позиция слева (приоритет над центром/смещением)
 * @param {number} [imageTopPt] — позиция сверху
 */
async function insertImage(
  imageUrl,
  preferSelectedShape,
  insertIndex = 0,
  insertTotal = 1,
  insertScale = 1,
  imageWidthPt,
  imageLeftPt,
  imageTopPt
) {
  if (!isOfficeRuntimeReady()) {
    throw new Error(officeRuntimeUnavailableMessage());
  }

  const rawBase64 = await imageUrlToBase64(imageUrl);
  if (!rawBase64 || typeof rawBase64 !== "string") {
    throw new Error("Не удалось загрузить изображение");
  }

  if (preferSelectedShape) {
    const inserted = await tryInsertImageIntoSelectedShape(rawBase64);
    if (inserted) return;
  }

  const options = { coercionType: Office.CoercionType.Image };
  if (imageLeftPt != null && imageTopPt != null) {
    options.imageLeft = imageLeftPt + insertIndex * INSERT_OFFSET_STEP_PT;
    options.imageTop = imageTopPt + insertIndex * INSERT_OFFSET_STEP_PT;
  } else if (insertTotal > 1) {
    options.imageLeft = insertIndex * INSERT_OFFSET_STEP_PT;
    options.imageTop = insertIndex * INSERT_OFFSET_STEP_PT;
  }
  if (imageWidthPt != null) {
    options.imageWidth = imageWidthPt;
  } else if (insertScale > 1) {
    options.imageWidth = IMAGE_DEFAULT_SIZE_PT * insertScale;
  }

  return new Promise((resolve, reject) => {
    Office.context.document.setSelectedDataAsync(rawBase64, options, (result) => {
      if (result.status === Office.AsyncResultStatus.Succeeded) {
        resolve();
      } else {
        reject(new Error(result.error?.message || "setSelectedDataAsync failed"));
      }
    });
  });
}

function loadImageDimensions(url) {
  return new Promise((resolve) => {
    const img = new Image();
    img.onload = () => resolve({ width: img.naturalWidth, height: img.naturalHeight });
    img.onerror = () => resolve(null);
    img.src = url;
  });
}

async function insertSelectedImages() {
  if (selectedImages.length === 0) return;

  const toInsert = [...selectedImages];
  selectedImages = [];
  clearGallerySelection();
  updateLibraryInsertButton();

  for (let i = 0; i < toInsert.length; i++) {
    try {
      const dims = await loadImageDimensions(toInsert[i]);
      const sizePt = dims
        ? getImageInsertSizePt(dims.width, dims.height)
        : { widthPt: IMAGE_DEFAULT_SIZE_PT, heightPt: IMAGE_DEFAULT_SIZE_PT };
      const center = getCenterPositionPt(sizePt.widthPt, sizePt.heightPt);
      await insertImage(
        toInsert[i],
        i === 0,
        i,
        toInsert.length,
        1,
        undefined,
        center.left,
        center.top
      );
    } catch (err) {
      console.error("Failed to insert image:", toInsert[i], err);
    }
  }
}

// ========================
// Navigation
// ========================

function showScreen(screenId) {
  document.querySelectorAll(".screen").forEach((s) => s.classList.remove("active"));
  const target = document.getElementById(screenId);
  if (target) target.classList.add("active");
  if (screenId === "homeScreen") updateHomeGenerationTileStatus();
}

function updateHomeGenerationTileStatus() {
  const rawUrl = assetUrl(generationDoneCheckIcon);
  const checkValue = rawUrl
    ? 'url("' + rawUrl.replace(/\\/g, "\\\\").replace(/"/g, '\\"') + '")'
    : "";
  const photoCard = document.getElementById("generatePhotoBtn");
  const illCard = document.getElementById("generateIllustrationBtn");
  if (photoCard) {
    const isPhotoGenerating = generateState === "generating";
    photoCard.classList.toggle("has-status-loader", isPhotoGenerating);
    photoCard.classList.toggle("has-status-check", !isPhotoGenerating && !!photoGenerateHomeReady);
    if (checkValue) photoCard.style.setProperty("--feature-status-check-icon", checkValue);
  }
  if (illCard) {
    const isIllGenerating = illGenerateState === "generating";
    illCard.classList.toggle("has-status-loader", isIllGenerating);
    illCard.classList.toggle(
      "has-status-check",
      !isIllGenerating && !!illustrationGenerateHomeReady
    );
    if (checkValue) illCard.style.setProperty("--feature-status-check-icon", checkValue);
  }
}

function truncateTextChatChunk(s, maxLen) {
  const t = String(s || "");
  if (t.length <= maxLen) return t;
  return t.slice(0, maxLen) + "\n… [текст обрезан для запроса]";
}

const TEXT_SHAPE_TYPES = {
  GeometricShape: true,
  Placeholder: true,
  TextBox: true,
  Callout: true,
};

/**
 * @param {Array<{ slideIndex: number, id?: string, kind?: string, error: string }> | null} [outWarnings] — сбой только этого блока, не всего слайда
 */
async function pptCollectTextBlocksFromCollection(
  context,
  shapeCollection,
  slideIndex,
  blocks,
  outWarnings
) {
  const countR = shapeCollection.getCount();
  await context.sync();
  const n = countR.value;
  /** Одни и те же ссылки, что и в load — иначе getItemAt() вернёт «новый» объект без id. */
  const shapeRefs = [];
  for (let i = 0; i < n; i++) {
    const sh = shapeCollection.getItemAt(i);
    sh.load("id,type");
    shapeRefs.push(sh);
  }
  await context.sync();
  for (let i = 0; i < n; i++) {
    const shape = shapeRefs[i];
    const sid = (shape && shape.id) != null ? String(shape.id) : "shape" + i;
    try {
      if (shape.type === "Group") {
        await pptCollectTextBlocksFromCollection(
          context,
          shape.group.shapes,
          slideIndex,
          blocks,
          outWarnings
        );
        continue;
      }
      {
        const pt = await pptGetShapeTableIfAny(context, shape);
        if (pt) {
          try {
            await pptAppendTableTextBlocks(context, shape, slideIndex, blocks, pt, outWarnings);
          } catch (e) {
            const msg = e && e.message ? e.message : String(e);
            console.warn("pptAppendTableTextBlocks:", e);
            if (outWarnings) {
              outWarnings.push({
                slideIndex,
                id: sid,
                kind: "table",
                error: msg,
              });
            }
          }
          continue;
        }
      }
      if (!TEXT_SHAPE_TYPES[shape.type]) continue;
      let tf;
      try {
        tf = shape.textFrame;
      } catch (_e) {
        continue;
      }
      tf.load("hasText");
      const tr = tf.textRange;
      tr.load("text");
      await context.sync();
      if (!tf.hasText) continue;
      const raw = tr.text || "";
      if (!String(raw).replace(/\s/g, "")) continue;
      blocks.push({
        id: shape.id,
        slideIndex,
        text: truncateTextChatChunk(raw.replace(/\r/g, "\n"), TEXT_CHAT_MAX_TEXT_LEN),
      });
    } catch (e) {
      const msg = e && e.message ? e.message : String(e);
      console.warn("pptCollectTextBlocks: слайд " + (slideIndex + 1) + " id " + sid, e);
      if (outWarnings) {
        outWarnings.push({ slideIndex, id: sid, kind: "shape", error: msg });
      }
    }
  }
}

/** Находит фигуру по id на слайде (рекурсия по группам). */
async function pptFindShapeByIdOnSlide(context, slide, targetId) {
  const shapes = slide.shapes;
  const countR = shapes.getCount();
  await context.sync();
  const n = countR.value;
  const shapeRefs = [];
  for (let i = 0; i < n; i++) {
    const sh = shapes.getItemAt(i);
    sh.load("id,type");
    shapeRefs.push(sh);
  }
  await context.sync();
  const wantId = pptTextEditShapeIdForLookup(targetId);
  for (let i = 0; i < n; i++) {
    const shape = shapeRefs[i];
    if (shape.id === wantId) return shape;
    if (shape.type === "Group") {
      const found = await pptFindShapeByIdInCollection(context, shape.group.shapes, targetId);
      if (found) return found;
    }
  }
  return null;
}

async function pptFindShapeByIdInCollection(context, shapeCollection, targetId) {
  const countR = shapeCollection.getCount();
  await context.sync();
  const n = countR.value;
  const shapeRefs = [];
  for (let i = 0; i < n; i++) {
    const sh = shapeCollection.getItemAt(i);
    sh.load("id,type");
    shapeRefs.push(sh);
  }
  await context.sync();
  const wantId2 = pptTextEditShapeIdForLookup(targetId);
  for (let i = 0; i < n; i++) {
    const shape = shapeRefs[i];
    if (shape.id === wantId2) return shape;
    if (shape.type === "Group") {
      const found = await pptFindShapeByIdInCollection(context, shape.group.shapes, targetId);
      if (found) return found;
    }
  }
  return null;
}

/**
 * @param {{ includeAllSlides?: boolean }} [opt]
 * @returns full deck only if includeAllSlides: user явно просит правку всей презентации / весь контекст — иначе только currentSlide.
 */
async function pptGatherTextEditContext(opt) {
  const includeAllSlides = opt && opt.includeAllSlides;
  if (typeof PowerPoint === "undefined") {
    return { error: "PowerPoint API недоступен" };
  }
  try {
    return await PowerPoint.run(async (context) => {
      const presentation = context.presentation;
      const slides = presentation.slides;
      const slideCountR = slides.getCount();
      await context.sync();
      const nSlides = slideCountR.value;

      const selectedSlides = presentation.getSelectedSlides();
      const selCountR = selectedSlides.getCount();
      await context.sync();
      if (selCountR.value === 0) {
        return { error: "Не выбран слайд" };
      }
      const currentSlide = selectedSlides.getItemAt(0);
      currentSlide.load("id");
      await context.sync();
      const currentSlideId = currentSlide.id;

      const slideRefs = [];
      for (let i = 0; i < nSlides; i++) {
        const s = slides.getItemAt(i);
        s.load("id");
        slideRefs.push(s);
      }
      await context.sync();

      let currentSlideIndex = 0;
      for (let i = 0; i < nSlides; i++) {
        if (slideRefs[i].id === currentSlideId) {
          currentSlideIndex = i;
          break;
        }
      }

      const blockReadWarnings = [];
      const currentSlideBlocks = [];
      const slideForBlocks = slideRefs[currentSlideIndex];
      await pptCollectTextBlocksFromCollection(
        context,
        slideForBlocks.shapes,
        currentSlideIndex,
        currentSlideBlocks,
        blockReadWarnings
      );

      const allSlides = [];
      /** @type {Array<{ slideIndex: number, error: string }>} */
      const allSlidesReadWarnings = [];
      if (includeAllSlides) {
        for (let si = 0; si < nSlides; si++) {
          const slide = slideRefs[si];
          const blocks = [];
          try {
            await pptCollectTextBlocksFromCollection(
              context,
              slide.shapes,
              si,
              blocks,
              blockReadWarnings
            );
            if (blocks.length) {
              allSlides.push({ slideIndex: si, blocks });
            }
          } catch (e) {
            console.warn("pptGatherTextEditContext: слайд " + (si + 1) + " / " + nSlides, e);
            allSlidesReadWarnings.push({
              slideIndex: si,
              error: e && e.message ? String(e.message) : String(e),
            });
          }
        }
      }

      let selection = null;
      try {
        const selRange = presentation.getSelectedTextRangeOrNullObject();
        selRange.load("isNullObject,text,start,length");
        await context.sync();
        if (!selRange.isNullObject && selRange.text && String(selRange.text).trim().length > 0) {
          const tf = selRange.getParentTextFrame();
          const parentShape = tf.getParentShape();
          parentShape.load("id, type");
          const fullTr = tf.textRange;
          fullTr.load("text");
          await context.sync();
          let inTable = false;
          let tableRow = null;
          let tableCol = null;
          {
            const ptb = await pptGetShapeTableIfAny(context, parentShape);
            if (ptb) {
              const pos = await pptTableCellRowColFromText(context, parentShape, fullTr.text);
              if (pos) {
                inTable = true;
                tableRow = pos.r;
                tableCol = pos.c;
              }
            }
          }
          selection = {
            shapeId: parentShape.id,
            slideIndex: currentSlideIndex,
            text: selRange.text,
            start: selRange.start,
            length: selRange.length,
            fullShapeText: truncateTextChatChunk(
              String(fullTr.text || "").replace(/\r/g, "\n"),
              TEXT_CHAT_MAX_TEXT_LEN
            ),
            inTable: !!inTable,
            tableRow: tableRow,
            tableCol: tableCol,
          };
        }
      } catch (e) {
        console.warn("pptGatherTextEditContext: selection", e);
        selection = null;
      }

      return {
        currentSlideIndex,
        slideCount: nSlides,
        selection,
        currentSlideBlocks,
        allSlides,
        allSlidesReadWarnings: allSlidesReadWarnings.length ? allSlidesReadWarnings : undefined,
        contextBlockReadWarnings: blockReadWarnings.length ? blockReadWarnings : undefined,
        contextScope: includeAllSlides ? "full_presentation" : "current_slide",
      };
    });
  } catch (err) {
    console.error("pptGatherTextEditContext:", err);
    const m =
      err && err.debugInfo && err.debugInfo.message
        ? String(err.debugInfo.message)
        : err && err.message
          ? err.message
          : String(err);
    return { error: m };
  }
}

/** В тексте фигур PowerPoint абзацы задаются \\r; из модели и JSON часто приходит \\n — иначе RichApi.InvalidArgument. */
function pptTextForShapeHost(s) {
  return String(s).replace(/\r\n/g, "\n").replace(/\r/g, "\n").replace(/\n/g, "\r");
}

function pptTextsLooselyEqual(a, b) {
  const x = String(a).replace(/\r\n/g, "\n").replace(/\r/g, "\n");
  const y = String(b).replace(/\r\n/g, "\n").replace(/\r/g, "\n");
  return x === y;
}

/**
 * Актуальные start/length для getSubstring: индексы из момента сбора контекста могут устареть, пока шёл ответ n8n.
 */
function pptResolveSelectionSubstring(fullText, selCtx) {
  const full = String(fullText ?? "");
  const orig = String(selCtx.text ?? "");
  const start0 = Number(selCtx.start);
  const len0 = Number(selCtx.length);
  if (!Number.isFinite(start0) || !Number.isFinite(len0) || len0 <= 0) return null;

  if (start0 >= 0 && start0 + len0 <= full.length) {
    const slice = full.slice(start0, start0 + len0);
    if (!orig || slice === orig || pptTextsLooselyEqual(slice, orig)) {
      return { start: start0, length: len0 };
    }
  }

  if (!orig || orig.length === 0 || orig.length > full.length) return null;

  let best = null;
  for (let i = 0; i <= full.length - orig.length; i++) {
    const slice = full.slice(i, i + orig.length);
    if (slice === orig || pptTextsLooselyEqual(slice, orig)) {
      if (!best || Math.abs(i - start0) < Math.abs(best.start - start0)) {
        best = { start: i, length: orig.length };
      }
    }
  }
  return best;
}

/** id ячейки: <id_фигуры> + суффикс _t_строка_столбец (0-based) — сопоставляем с конца id, чтобы id фигуры мог содержать «_t_» в редких кейсах. */
const PPT_TEXTEDIT_TABLE_ID_SUFFIX_RE = /_t_(\d+)_(\d+)$/;

function pptTextEditTableCellMatch(id) {
  if (!id) return null;
  const s = String(id);
  const m = s.match(PPT_TEXTEDIT_TABLE_ID_SUFFIX_RE);
  if (!m) return null;
  const base = s.slice(0, s.length - m[0].length);
  if (!base) return null;
  return { baseId: base, row: parseInt(m[1], 10), col: parseInt(m[2], 10) };
}

function pptTextEditShapeIdForLookup(id) {
  const c = pptTextEditTableCellMatch(id);
  return c ? c.baseId : id;
}

function pptPlainCell(s) {
  return String(s || "").replace(/\r/g, "\n");
}

/**
 * Размеры сетки: на Mac и в ряде сборок `rowCount`/`columnCount` приходят 0, пока `rows`/`columns` (как в formatSelectedTable) — корректны.
 * @returns {Promise<null | { nR: number, nC: number }>}
 */
async function pptGetTableDimensionsOrNull(context, table) {
  try {
    table.load("rowCount, columnCount");
    await context.sync();
    let nR = table.rowCount | 0;
    let nC = table.columnCount | 0;
    if (nR < 1 || nC < 1) {
      try {
        const rcr = table.rows.getCount();
        const ccr = table.columns.getCount();
        await context.sync();
        nR = typeof rcr.value === "number" ? rcr.value : 0;
        nC = typeof ccr.value === "number" ? ccr.value : 0;
      } catch (_e2) {
        /* PowerPointApi 1.9+; если нет — остаёмся на 0 */
      }
    }
    if (nR < 1 || nC < 1) {
      return null;
    }
    return { nR, nC };
  } catch (_e) {
    return null;
  }
}

/**
 * Таблица на слайде может приходить как `shape.type === "Table"` и как плейсхолдер/другой тип, у которого всё равно есть getTable().
 * @returns {PowerPoint.Table | null}
 */
async function pptGetShapeTableIfAny(context, shape) {
  try {
    const table = shape.getTable();
    const dim = await pptGetTableDimensionsOrNull(context, table);
    if (!dim) {
      return null;
    }
    return table;
  } catch (_e) {
    return null;
  }
}

/**
 * Собирает ячейки таблицы отдельными блоками, чтобы n8n могла править их по id.
 * @param {PowerPoint.Table} [preloaded] — из pptGetShapeTableIfAny, чтобы не дергать getTable дважды
 */
function pptOneTableCellFromRaw(tableShape, slideIndex, r, c, raw) {
  if (!String(raw).replace(/\s/g, "")) {
    return null;
  }
  return {
    id: tableShape.id + "_t_" + r + "_" + c,
    slideIndex,
    text: truncateTextChatChunk(pptPlainCell(raw), TEXT_CHAT_MAX_TABLE_CELL_LEN),
    kind: "tableCell",
  };
}

/**
 * Сначала читаем cell.text; если ни одна ячейка дала контент (так бывает на части хостов/после вёрстки),
 * запасно — `table.values` (с усечениями, чтобы снизить риск 504).
 */
/**
 * @param {Array<{ slideIndex: number, id?: string, kind?: string, error: string }> | null} [outWarnings]
 */
async function pptAppendTableTextBlocks(
  context,
  tableShape,
  slideIndex,
  blocks,
  preloaded,
  outWarnings
) {
  const startIdx = blocks.length;
  const table = preloaded || tableShape.getTable();
  const dim0 = await pptGetTableDimensionsOrNull(context, table);
  if (!dim0) {
    return;
  }
  const nR = dim0.nR;
  const nC = dim0.nC;
  const tableBaseId = (tableShape && tableShape.id) != null ? String(tableShape.id) : "table";

  for (let r = 0; r < nR; r++) {
    for (let c = 0; c < nC; c++) {
      const cell = table.getCellOrNullObject(r, c);
      cell.load("isNullObject");
    }
  }
  await context.sync();
  for (let r = 0; r < nR; r++) {
    for (let c = 0; c < nC; c++) {
      const cell = table.getCellOrNullObject(r, c);
      if (cell.isNullObject) continue;
      cell.load("text");
    }
  }
  await context.sync();
  for (let r = 0; r < nR; r++) {
    for (let c = 0; c < nC; c++) {
      const cellId = tableBaseId + "_t_" + r + "_" + c;
      try {
        const cell = table.getCellOrNullObject(r, c);
        if (cell.isNullObject) continue;
        const item = pptOneTableCellFromRaw(tableShape, slideIndex, r, c, String(cell.text || ""));
        if (item) {
          blocks.push(item);
        }
      } catch (e) {
        const msg = e && e.message ? e.message : String(e);
        console.warn("pptAppendTableTextBlocks cell " + r + "," + c, e);
        if (outWarnings) {
          outWarnings.push({
            slideIndex,
            id: cellId,
            kind: "tableCell",
            error: msg,
          });
        }
      }
    }
  }

  if (blocks.length > startIdx) {
    return;
  }

  // Fallback: some hosts return empty `cell.text` until `values` is loaded, or only expose plain text in values
  let total = 0;
  try {
    table.load("values");
    await context.sync();
  } catch (e) {
    console.warn("pptAppendTableTextBlocks values fallback load:", e);
    return;
  }
  if (!Array.isArray(table.values) || !table.values.length) {
    return;
  }
  for (let r = 0; r < nR; r++) {
    const row = table.values[r];
    if (!Array.isArray(row)) {
      continue;
    }
    for (let c = 0; c < nC; c++) {
      if (c >= row.length) {
        continue;
      }
      if (total >= TEXT_CHAT_TABLE_VALUES_TOTAL_CAP) {
        return;
      }
      const raw0 = String(row[c] != null ? row[c] : "");
      const t = truncateTextChatChunk(pptPlainCell(raw0), TEXT_CHAT_MAX_TABLE_CELL_LEN);
      if (total + t.length > TEXT_CHAT_TABLE_VALUES_TOTAL_CAP) {
        return;
      }
      const cellId2 = tableBaseId + "_t_" + r + "_" + c;
      try {
        const item2 = pptOneTableCellFromRaw(tableShape, slideIndex, r, c, t);
        if (item2) {
          total += item2.text.length;
          blocks.push(item2);
        }
      } catch (e) {
        const msg = e && e.message ? e.message : String(e);
        if (outWarnings) {
          outWarnings.push({ slideIndex, id: cellId2, kind: "tableCell", error: msg });
        }
      }
    }
  }
}

/**
 * Подобрать (row, col) ячейки по совпадению полного текста (выделение внутри ячейки).
 */
async function pptTableCellRowColFromText(context, tableShape, fullCellTextPlain) {
  const want = pptPlainCell(fullCellTextPlain);
  if (!want) return null;
  const table = tableShape.getTable();
  const dimT = await pptGetTableDimensionsOrNull(context, table);
  if (!dimT) return null;
  const nRT = dimT.nR;
  const nCT = dimT.nC;
  for (let r = 0; r < nRT; r++) {
    for (let c = 0; c < nCT; c++) {
      const cell = table.getCellOrNullObject(r, c);
      cell.load("isNullObject, text");
    }
  }
  await context.sync();
  for (let r = 0; r < nRT; r++) {
    for (let c = 0; c < nCT; c++) {
      const cell = table.getCellOrNullObject(r, c);
      if (cell.isNullObject) continue;
      if (pptPlainCell(cell.text) === want) {
        return { r, c };
      }
    }
  }
  for (let r = 0; r < nRT; r++) {
    for (let c = 0; c < nCT; c++) {
      const cell = table.getCellOrNullObject(r, c);
      if (cell.isNullObject) continue;
      if (pptTextsLooselyEqual(pptPlainCell(cell.text), want)) {
        return { r, c };
      }
    }
  }
  return null;
}

/**
 * Полный новый текст ячейки после правки фрагмента (для selection в таблице).
 */
function pptApplyCellSpliceFromSelection(full, selCtx, newTextRaw) {
  const flat = String(full || "")
    .replace(/\r\n/g, "\n")
    .replace(/\r/g, "\n");
  const res = pptResolveSelectionSubstring(flat, selCtx);
  if (!res) return null;
  const a = res.start;
  const b = res.length;
  const mid = String(newTextRaw);
  return pptTextForShapeHost(flat.slice(0, a) + mid + flat.slice(a + b));
}

/**
 * Применяет правки: сначала selectionEdit (поддиапазон), затем полные тексты фигур / ячеек.
 * Один сбой не отменяет остальные. Возвращает { applyFailures }.
 * @param {{ newText: string }} selectionEdit
 * @param {Array<{ id: string, slideIndex: number, newText: string }>} changes
 * @returns {Promise<{ applyFailures: Array<{ slideIndex: number, id?: string, type?: string, error: string }> }>}
 */
async function pptApplyTextEdits(selectionEdit, changes) {
  const selCtx = textChatLastSelectionCtx;
  const out = await PowerPoint.run(async (context) => {
    /** @type {Array<{ slideIndex: number, id?: string, type?: string, error: string }>} */
    const applyFailures = [];
    const slides = context.presentation.slides;

    if (selectionEdit && selCtx && selectionEdit.newText != null) {
      try {
        const slide = slides.getItemAt(selCtx.slideIndex);
        const shape = await pptFindShapeByIdOnSlide(context, slide, selCtx.shapeId);
        if (!shape) {
          applyFailures.push({
            slideIndex: selCtx.slideIndex,
            id: String(selCtx.shapeId),
            type: "selection",
            error: "фигура не найдена",
          });
        } else if (selCtx.inTable && selCtx.tableRow != null && selCtx.tableCol != null) {
          const table = await pptGetShapeTableIfAny(context, shape);
          if (!table) {
            applyFailures.push({
              slideIndex: selCtx.slideIndex,
              type: "selection",
              id: String(selCtx.shapeId),
              error: "таблица не найдена",
            });
          } else {
            const cell = table.getCellOrNullObject(selCtx.tableRow, selCtx.tableCol);
            cell.load("isNullObject, text");
            await context.sync();
            if (cell.isNullObject) {
              applyFailures.push({
                slideIndex: selCtx.slideIndex,
                type: "selection",
                id: String(selCtx.shapeId),
                error: "пустая ячейка",
              });
            } else {
              const next = pptApplyCellSpliceFromSelection(
                cell.text,
                selCtx,
                selectionEdit.newText
              );
              if (!next) {
                applyFailures.push({
                  slideIndex: selCtx.slideIndex,
                  type: "selection",
                  id: String(selCtx.shapeId),
                  error: "не подобралась вставка в ячейке",
                });
              } else {
                cell.text = next;
              }
            }
          }
        } else {
          let tf;
          try {
            tf = shape.textFrame;
          } catch (_e) {
            /* ignore */
          }
          if (tf) {
            const fullRange = tf.textRange;
            fullRange.load("text");
            await context.sync();
            const resolved = pptResolveSelectionSubstring(fullRange.text, selCtx);
            if (!resolved) {
              applyFailures.push({
                slideIndex: selCtx.slideIndex,
                type: "selection",
                id: String(selCtx.shapeId),
                error: "выделение на слайде не найдено (текст мог измениться)",
              });
            } else {
              const sub = fullRange.getSubstring(resolved.start, resolved.length);
              sub.text = pptTextForShapeHost(selectionEdit.newText);
            }
          } else {
            applyFailures.push({
              slideIndex: selCtx.slideIndex,
              type: "selection",
              id: String(selCtx.shapeId),
              error: "нет textFrame",
            });
          }
        }
      } catch (e) {
        const msg = e && e.message ? e.message : String(e);
        applyFailures.push({
          slideIndex: selCtx.slideIndex,
          type: "selection",
          id: selCtx.shapeId != null ? String(selCtx.shapeId) : "selection",
          error: msg,
        });
      }
    }

    const list = Array.isArray(changes) ? changes : [];
    for (let i = 0; i < list.length; i++) {
      const ch = list[i];
      if (!ch || !ch.id || ch.newText == null) continue;
      const si = Number(ch.slideIndex);
      if (Number.isNaN(si) || si < 0) continue;
      let slide;
      try {
        slide = slides.getItemAt(si);
        const shape = await pptFindShapeByIdOnSlide(context, slide, ch.id);
        if (!shape) {
          applyFailures.push({ slideIndex: si, id: String(ch.id), error: "фигура не найдена" });
          continue;
        }
        const tcm = pptTextEditTableCellMatch(ch.id);
        if (tcm) {
          const table = await pptGetShapeTableIfAny(context, shape);
          if (!table) {
            applyFailures.push({ slideIndex: si, id: String(ch.id), error: "таблица недоступна" });
            continue;
          }
          const cell = table.getCellOrNullObject(tcm.row, tcm.col);
          cell.load("isNullObject");
          await context.sync();
          if (cell.isNullObject) {
            applyFailures.push({ slideIndex: si, id: String(ch.id), error: "ячейка пуста (null)" });
            continue;
          }
          try {
            cell.text = pptTextForShapeHost(ch.newText);
          } catch (e) {
            const msg = e && e.message ? e.message : String(e);
            applyFailures.push({ slideIndex: si, id: String(ch.id), error: msg });
          }
        } else {
          try {
            shape.textFrame.textRange.text = pptTextForShapeHost(ch.newText);
          } catch (e) {
            const msg = e && e.message ? e.message : String(e);
            console.warn("pptApplyTextEdits: textFrame", e);
            applyFailures.push({ slideIndex: si, id: String(ch.id), error: msg });
          }
        }
      } catch (e) {
        const msg = e && e.message ? e.message : String(e);
        applyFailures.push({ slideIndex: si, id: ch.id != null ? String(ch.id) : "?", error: msg });
        console.warn("pptApplyTextEdits change", ch, e);
      }
    }
    await context.sync();
    return { applyFailures };
  });
  return out || { applyFailures: [] };
}

/**
 * Восстанавливает набор текстов по элементам сессии отката.
 * @param {"original"|"modified"} which
 */
async function pptApplyUndoSessionItems(which) {
  const session = textChatUndoSession;
  if (!session || !session.items.length) return;
  await PowerPoint.run(async (context) => {
    const slides = context.presentation.slides;
    for (let i = 0; i < session.items.length; i++) {
      const it = session.items[i];
      const slide = slides.getItemAt(it.slideIndex);
      const shape = await pptFindShapeByIdOnSlide(context, slide, it.shapeId);
      if (!shape) continue;
      const text = which === "original" ? it.originalText : it.modifiedText;
      if (it.mode === "selection" && it.selStart != null) {
        if (it.inTable && it.tableRow != null && it.tableCol != null) {
          const tableU = await pptGetShapeTableIfAny(context, shape);
          if (!tableU) continue;
          const cellU = tableU.getCellOrNullObject(it.tableRow, it.tableCol);
          cellU.load("isNullObject, text");
          await context.sync();
          if (cellU.isNullObject) continue;
          const fullC = String(cellU.text || "");
          const fromHostU =
            which === "original"
              ? pptTextForShapeHost(it.modifiedText)
              : pptTextForShapeHost(it.originalText);
          const resolvedU = pptResolveSelectionSubstring(fullC, {
            start: it.selStart,
            length: fromHostU.length,
            text: fromHostU,
          });
          if (!resolvedU) {
            throw new Error(
              "Не удалось найти фрагмент в ячейке для «Оригинал» / «Изменение» (текст мог измениться)."
            );
          }
          const a = resolvedU.start;
          const b = resolvedU.length;
          cellU.text = pptTextForShapeHost(
            String(fullC).slice(0, a) + String(text) + String(fullC).slice(a + b)
          );
        } else {
          const fullRange = shape.textFrame.textRange;
          fullRange.load("text");
          await context.sync();
          const full = fullRange.text || "";
          /** Сейчас на слайде фрагмент «откуда» заменяем: перед показом оригинала там правка, перед показом правки — оригинал. */
          const fromHost =
            which === "original"
              ? pptTextForShapeHost(it.modifiedText)
              : pptTextForShapeHost(it.originalText);
          const resolved = pptResolveSelectionSubstring(full, {
            start: it.selStart,
            length: fromHost.length,
            text: fromHost,
          });
          if (!resolved) {
            throw new Error(
              "Не удалось найти фрагмент для переключения «Оригинал» / «Изменение» (текст слайда мог измениться)."
            );
          }
          const sub = fullRange.getSubstring(resolved.start, resolved.length);
          sub.text = pptTextForShapeHost(text);
        }
      } else {
        const tce = pptTextEditTableCellMatch(it.shapeId);
        if (tce) {
          const tbt = await pptGetShapeTableIfAny(context, shape);
          if (tbt) {
            const tcell = tbt.getCellOrNullObject(tce.row, tce.col);
            tcell.load("isNullObject");
            await context.sync();
            if (!tcell.isNullObject) {
              tcell.text = pptTextForShapeHost(text);
            }
          } else {
            try {
              shape.textFrame.textRange.text = pptTextForShapeHost(text);
            } catch (e) {
              console.warn("pptApplyUndoSessionItems: textFrame", e);
            }
          }
        } else {
          try {
            shape.textFrame.textRange.text = pptTextForShapeHost(text);
          } catch (e) {
            console.warn("pptApplyUndoSessionItems: textFrame", e);
          }
        }
      }
    }
    await context.sync();
  });
}

function buildTextChatHistoryPayload() {
  return textChatMessages
    .filter((m) => m.role === "user" || m.role === "assistant")
    .filter((m) => !m.loading && m.kind !== "system")
    .slice(-TEXT_CHAT_HISTORY_MAX)
    .map((m) => ({ role: m.role, text: m.text }));
}

function setTextChatInputDisabled(disabled) {
  const input = document.getElementById("textChatInput");
  const sendBtn = document.getElementById("textChatSendBtn");
  const clearBtn = document.getElementById("textChatClearBtn");
  if (input) input.disabled = !!disabled;
  if (sendBtn) sendBtn.disabled = !!disabled;
  if (clearBtn) clearBtn.disabled = !!disabled;
}

function renderTextChatMessages() {
  const container = document.getElementById("textChatMessages");
  if (!container) return;
  container.innerHTML = "";
  textChatMessages.forEach((msg) => {
    const el = document.createElement("div");
    el.className = "text-chat-msg " + msg.role;
    const text = document.createElement("div");
    text.className = "text-chat-msg-text";
    text.textContent = msg.text;
    el.appendChild(text);

    if (
      msg.role === "assistant" &&
      msg.editDone &&
      msg.editId === textChatLatestEditId &&
      textChatUndoSession &&
      textChatUndoSession.editId === msg.editId
    ) {
      const row = document.createElement("div");
      row.className = "text-chat-compare-row";
      const btnOrig = document.createElement("button");
      btnOrig.type = "button";
      btnOrig.className = "text-chat-compare-btn";
      btnOrig.textContent = "Оригинал";
      btnOrig.disabled = textChatUndoSession.viewingOriginal;
      btnOrig.onclick = () => textChatToggleEditVersion("original");

      const btnMod = document.createElement("button");
      btnMod.type = "button";
      btnMod.className = "text-chat-compare-btn primary";
      btnMod.textContent = "Изменение";
      btnMod.disabled = !textChatUndoSession.viewingOriginal;
      btnMod.onclick = () => textChatToggleEditVersion("modified");

      row.appendChild(btnOrig);
      row.appendChild(btnMod);
      el.appendChild(row);
    }

    container.appendChild(el);
  });
  container.scrollTop = container.scrollHeight;
}

async function textChatToggleEditVersion(mode) {
  const session = textChatUndoSession;
  if (!session) return;
  const wantOriginal = mode === "original";
  if (wantOriginal && session.viewingOriginal) return;
  if (!wantOriginal && !session.viewingOriginal) return;
  try {
    setTextChatInputDisabled(true);
    await pptApplyUndoSessionItems(wantOriginal ? "original" : "modified");
    session.viewingOriginal = wantOriginal;
    renderTextChatMessages();
  } catch (err) {
    console.error(err);
    textChatMessages.push({
      role: "assistant",
      text: "Не удалось переключить версию текста: " + (err.message || String(err)),
    });
    renderTextChatMessages();
  } finally {
    setTextChatInputDisabled(textChatInFlight);
  }
}

function clearTextChat() {
  textChatMessages = [];
  textChatLastSelectionCtx = null;
  textChatUndoSession = null;
  textChatLatestEditId = 0;
  textChatInFlight = false;
  renderTextChatMessages();
}

/**
 * Перед применением правок заполняем сессию отката (оригинал = текущее состояние до правки).
 */
function textChatPrepareUndoSessionFromResponse(parsed, hadSelectionEdit) {
  const items = [];
  const selCtx = textChatLastSelectionCtx;
  const sel = parsed.selectionEdit;

  if (hadSelectionEdit && sel && sel.newText != null && selCtx) {
    items.push({
      shapeId: selCtx.shapeId,
      slideIndex: selCtx.slideIndex,
      mode: "selection",
      originalText: selCtx.text,
      modifiedText: String(sel.newText),
      selStart: selCtx.start,
      selLen: selCtx.length,
      inTable: !!selCtx.inTable,
      tableRow: selCtx.tableRow,
      tableCol: selCtx.tableCol,
    });
  }

  const changes = Array.isArray(parsed.changes) ? parsed.changes : [];
  for (let i = 0; i < changes.length; i++) {
    const ch = changes[i];
    if (!ch || !ch.id || ch.newText == null) continue;
    const si = Number(ch.slideIndex);
    if (Number.isNaN(si)) continue;
    const block = findBlockInGatheredContext(si, ch.id);
    const orig = block ? block.text : "";
    items.push({
      shapeId: ch.id,
      slideIndex: si,
      mode: "shape",
      originalText: orig,
      modifiedText: String(ch.newText),
    });
  }

  const editId = textChatNextEditId++;
  textChatUndoSession = { editId, viewingOriginal: false, items };
  textChatLatestEditId = editId;
  return editId;
}

/** Оригинальные тексты до правки (из последнего снимка контекста) — для shape-правок без full match. */
function findBlockInGatheredContext(slideIndex, shapeId) {
  const snap = textChatLastGatheredBlocks;
  if (!snap) return null;
  const key = slideIndex + ":" + shapeId;
  return snap[key] || null;
}

/** @type {null | Record<string, { text: string }>} */
let textChatLastGatheredBlocks = null;

/**
 * Ассистент, предшествующий последнему user-сообщению (нужен для «3) вся презентация» после уточнения).
 * Предполагаем хвост чата: …, assistant, user(новый), (loading).
 */
function textChatAssistantTextBeforeCurrentUser() {
  let i = textChatMessages.length - 1;
  while (i >= 0 && textChatMessages[i] && textChatMessages[i].loading) i -= 1;
  if (i < 0) return "";
  if (textChatMessages[i].role !== "user")
    return textChatMessages[i].role === "assistant" ? textChatMessages[i].text || "" : "";
  for (let j = i - 1; j >= 0; j -= 1) {
    const m = textChatMessages[j];
    if (m && m.loading) continue;
    if (m && m.role === "assistant") return m.text || "";
  }
  return "";
}

const TEXTEDIT_FULL_DECK_KEYWORDS = [
  "всю презента",
  "всей презента",
  "вся презента",
  "всей през",
  "всю през",
  "все слайд",
  "всё слай",
  "по всем слайд",
  "на всех слайд",
  "для всех слайд",
  "каждом слайд",
  "каждый слайд",
  "по всему документ", // powerpoint
  "целую презента",
  "вся презент",
  // «…презентацию/презентации всю» (часто в конце) — иначе не срабатывает «вcю презен…» подстрока
  "презентацию всю",
  "презентации всю",
  "презентацией всю",
  "все презента", // «вcё» -> «вcе» при нормализации ё→е
];

/**
 * true — в запросе нужен контекст всех слайдов; иначе только currentSlide.
 */
function textChatWantsFullPresentationContext(userText) {
  const t0 = String(userText || "");
  const t = t0.toLowerCase().replace(/ё/g, "е");
  for (let i = 0; i < TEXTEDIT_FULL_DECK_KEYWORDS.length; i++) {
    const p = String(TEXTEDIT_FULL_DECK_KEYWORDS[i]).toLowerCase().replace(/ё/g, "е");
    if (p && t.includes(p)) {
      return true;
    }
  }
  if (t.includes("контекст") && t.includes("презент") && (t.includes("вс") || t.includes("цел"))) {
    return true;
  }
  if (
    t.includes("учит") &&
    t.includes("презент") &&
    (t.includes("вс") || t.includes("вся") || t.includes("всю") || t.includes("всей"))
  ) {
    return true;
  }
  if (t.includes("согласу") && t.includes("слайд") && (t.includes("друг") || t.includes("остал"))) {
    return true;
  }
  const u = t0.trim();
  if (u.length > 0 && u.length < 5 && /^\s*3[).]?\s*$/i.test(u)) {
    const pre = textChatAssistantTextBeforeCurrentUser();
    if (pre && /3\)/.test(pre) && /(презент|слайд|вся|всю|всей|вс)/.test(pre)) {
      return true;
    }
  }
  if (t.includes("презент") && t.includes("всю") && t.lastIndexOf("всю") > t.indexOf("презент")) {
    return true;
  }
  return false;
}

/**
 * Сводка для чата: какие слайды/блоки не вошли в запрос (чтение) или не записались.
 * @param {{ contextBlockReadWarnings?: Array, allSlidesReadWarnings?: Array } | null} g
 * @param {Array<{ slideIndex: number, id?: string, error: string, type?: string }> | null} applyFailures
 */
function formatPptTextEditUserFooterNote(g, applyFailures) {
  const lines = [];
  if (g) {
    const blockW = g.contextBlockReadWarnings;
    if (Array.isArray(blockW) && blockW.length) {
      const bySlide = new Map();
      for (let i = 0; i < blockW.length; i++) {
        const w = blockW[i];
        if (!w) continue;
        const si = Number(w.slideIndex);
        if (Number.isNaN(si)) continue;
        if (!bySlide.has(si)) bySlide.set(si, []);
        bySlide
          .get(si)
          .push(
            (w.id != null ? String(w.id) : "?") +
              (w.kind ? " " + w.kind : "") +
              ": " +
              (w.error || "ошибка")
          );
      }
      const parts = [];
      Array.from(bySlide.keys())
        .sort((a, c) => a - c)
        .forEach((si) => {
          parts.push("слайд " + (si + 1) + " — " + bySlide.get(si).join("; "));
        });
      if (parts.length) {
        lines.push(
          "В запрос в модель не вошли отдельные фрагменты (слайд, id, причина): " +
            parts.join(" | ") +
            " Остальное слайда(ов) в контексте есть."
        );
      }
    }
    const sw = g.allSlidesReadWarnings;
    if (Array.isArray(sw) && sw.length) {
      const p = sw
        .map((r) => "слайд " + (r.slideIndex + 1) + " (" + (r.error || "") + ")")
        .join(", ");
      lines.push(
        "Слайд целиком не прочитан: " + p + " Остальные слайды в контексте есть, если уместно."
      );
    }
  }
  if (Array.isArray(applyFailures) && applyFailures.length) {
    const bySlide = new Map();
    for (let f = 0; f < applyFailures.length; f++) {
      const a = applyFailures[f];
      if (!a) continue;
      const si = Number(a.slideIndex);
      if (Number.isNaN(si)) continue;
      if (!bySlide.has(si)) bySlide.set(si, []);
      bySlide
        .get(si)
        .push(
          (a.id != null ? String(a.id) : "") +
            (a.type === "selection" ? " выделение" : "") +
            ": " +
            (a.error || "")
        );
    }
    const p2 = [];
    Array.from(bySlide.keys())
      .sort((a, c) => a - c)
      .forEach((si) => {
        p2.push("слайд " + (si + 1) + " — " + bySlide.get(si).join("; "));
      });
    if (p2.length) {
      lines.push("Не применилось (остальные правки применились, если были): " + p2.join(" | "));
    }
  }
  if (!lines.length) return "";
  return "\n\n—\n" + lines.join("\n");
}

function rememberGatheredBlocksFromContext(ctx) {
  const map = Object.create(null);
  if (ctx && Number.isInteger(ctx.currentSlideIndex) && Array.isArray(ctx.currentSlideBlocks)) {
    const si = ctx.currentSlideIndex;
    ctx.currentSlideBlocks.forEach((b) => {
      if (b && b.id) map[si + ":" + b.id] = { text: b.text };
    });
  }
  if (ctx && Array.isArray(ctx.allSlides)) {
    ctx.allSlides.forEach((sl) => {
      (sl.blocks || []).forEach((b) => {
        map[sl.slideIndex + ":" + b.id] = { text: b.text };
      });
    });
  }
  textChatLastGatheredBlocks = map;
}

async function sendTextChatMessage() {
  const input = document.getElementById("textChatInput");
  if (!input || textChatInFlight) return;
  const text = (input.value || "").trim();
  if (!text) return;

  const historyPayload = buildTextChatHistoryPayload();
  textChatMessages.push({ role: "user", text });
  input.value = "";
  textChatInFlight = true;
  setTextChatInputDisabled(true);
  renderTextChatMessages();

  const loadingIdx =
    textChatMessages.push({ role: "assistant", text: "Редактирую слайд…", loading: true }) - 1;
  renderTextChatMessages();

  try {
    const includeAllSlides = textChatWantsFullPresentationContext(text);
    const gathered = await pptGatherTextEditContext({ includeAllSlides: includeAllSlides });
    if (gathered.error) {
      textChatMessages[loadingIdx] = {
        role: "assistant",
        text: "Не могу прочитать слайд: " + gathered.error,
      };
      return;
    }

    textChatLastSelectionCtx = gathered.selection || null;
    rememberGatheredBlocksFromContext(gathered);

    const blocks = gathered.currentSlideBlocks || [];
    const tableCellBlocks = blocks.filter((b) => b && b.kind === "tableCell");
    const textShapeBlocks = blocks.filter((b) => b && b.kind !== "tableCell");
    const body = {
      message: text,
      history: historyPayload,
      context: {
        currentSlideIndex: gathered.currentSlideIndex,
        slideCount: gathered.slideCount,
        contextScope: gathered.contextScope,
        selection: gathered.selection,
        currentSlideBlocks: gathered.currentSlideBlocks,
        allSlides: gathered.allSlides,
        allSlidesReadWarnings: gathered.allSlidesReadWarnings,
        contextBlockReadWarnings: gathered.contextBlockReadWarnings,
        tableCellBlockCount: tableCellBlocks.length,
        textShapeBlockCount: textShapeBlocks.length,
        hasTableCellBlocks: tableCellBlocks.length > 0,
      },
    };

    const res = await fetch(N8N_TEXT_EDIT_URL, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(body),
    });

    const data = await res.json().catch(() => ({}));
    if (!res.ok) {
      throw new Error(data.error || data.message || "HTTP " + res.status);
    }

    if (!data.success) {
      const foot0 = formatPptTextEditUserFooterNote(gathered, null);
      textChatMessages[loadingIdx] = {
        role: "assistant",
        text: (data.chatMessage || data.error || "Запрос не выполнен") + (foot0 || ""),
      };
      return;
    }

    const action = data.action || "edit";
    if (action === "clarify") {
      const foot1 = formatPptTextEditUserFooterNote(gathered, null);
      textChatMessages[loadingIdx] = {
        role: "assistant",
        text: (data.chatMessage || "Уточните, пожалуйста, запрос.") + (foot1 || ""),
      };
      return;
    }

    const parsed = {
      selectionEdit: data.selectionEdit || null,
      changes: data.changes || [],
      chatMessage: data.chatMessage || "Готово.",
    };

    const hadSel =
      parsed.selectionEdit &&
      parsed.selectionEdit.newText != null &&
      textChatLastSelectionCtx &&
      String(textChatLastSelectionCtx.text || "").length > 0;
    const hasChanges =
      Array.isArray(parsed.changes) && parsed.changes.some((c) => c && c.id && c.newText != null);

    if (!hadSel && !hasChanges) {
      const foot2 = formatPptTextEditUserFooterNote(gathered, null);
      textChatMessages[loadingIdx] = {
        role: "assistant",
        text: (parsed.chatMessage || "Нечего применить — уточните запрос.") + (foot2 || ""),
      };
      return;
    }

    const applyRes = await pptApplyTextEdits(
      hadSel ? parsed.selectionEdit : null,
      hasChanges ? parsed.changes : []
    );
    const applyFails = (applyRes && applyRes.applyFailures) || [];
    const footerNote = formatPptTextEditUserFooterNote(gathered, applyFails);

    const editId = textChatPrepareUndoSessionFromResponse(parsed, hadSel);
    const summary = (parsed.chatMessage || "Готово.").trim();
    const summaryLc = summary.toLowerCase();
    const head = summaryLc.startsWith("готово") ? summary : "Готово! " + summary;
    textChatMessages[loadingIdx] = {
      role: "assistant",
      text: head + footerNote,
      editDone: true,
      editId,
    };
  } catch (err) {
    console.error("sendTextChatMessage:", err);
    textChatMessages[loadingIdx] = {
      role: "assistant",
      text: formatFetchErrorMessage(err),
    };
  } finally {
    textChatInFlight = false;
    setTextChatInputDisabled(false);
    renderTextChatMessages();
  }
}

// ========================
// Generate screen — UI helpers
// ========================

function setAspectThemeControlsDisabled(disabled) {
  ["picChipAspect", "picChipAttach"].forEach((id) => {
    const el = document.getElementById(id);
    if (el) el.disabled = !!disabled;
  });
  const refSlideBtn = document.getElementById("picRefFromSlideBtn");
  const refFileBtn = document.getElementById("picRefFromFileBtn");
  const refPreviewClearBtn = document.getElementById("picRefPreviewClearBtn");
  if (refSlideBtn) refSlideBtn.disabled = !!disabled;
  if (refFileBtn) refFileBtn.disabled = !!disabled;
  if (refPreviewClearBtn) {
    refPreviewClearBtn.disabled = !!disabled || !picReferenceBase64;
  }
}

function updatePhotoRefSlideUi() {
  const wrap = document.getElementById("picRefSlidePreviewWrap");
  const img = document.getElementById("picRefSlidePreview");
  const refPreviewClearBtn = document.getElementById("picRefPreviewClearBtn");

  if (wrap && img) {
    if (picReferenceBase64) {
      const mime = picReferenceMimeType || "image/png";
      img.src = "data:" + mime + ";base64," + picReferenceBase64;
      wrap.style.display = "";
    } else {
      img.removeAttribute("src");
      wrap.style.display = "none";
    }
  }
  if (refPreviewClearBtn && generateState !== "generating") {
    refPreviewClearBtn.disabled = !picReferenceBase64;
  }
  refreshPicChips();
}

function showPhotoRefSlideError(message) {
  const hint = document.getElementById("picRefSlideHint");
  if (!hint) return;
  hint.textContent = message;
  hint.classList.add("ill-ref-hint-error");
}

function clearPhotoRefSlideHintError() {
  const hint = document.getElementById("picRefSlideHint");
  if (!hint) return;
  hint.classList.remove("ill-ref-hint-error");
  hint.textContent = "";
}

function updateMainButton() {
  const btn = document.getElementById("generateMainBtn");
  const input = document.getElementById("promptInput");
  if (!btn || !input) return;
  if (generateState === "generating") {
    btn.className = "gen-inline-send-btn generating gen-inline-send-btn--cancel";
    btn.disabled = false;
    btn.setAttribute("aria-label", "Отменить генерацию");
    btn.title = "Отменить генерацию";
    return;
  }
  if (input.value.trim()) {
    btn.className = "gen-inline-send-btn active";
    btn.disabled = false;
    btn.setAttribute("aria-label", "Сгенерировать");
    btn.title = "Сгенерировать";
  } else {
    btn.className = "gen-inline-send-btn disabled";
    btn.disabled = true;
    btn.removeAttribute("aria-label");
    btn.removeAttribute("title");
  }
}

function renderHistory() {
  const section = document.getElementById("historySection");
  const leftCol = document.getElementById("historyColLeft");
  const rightCol = document.getElementById("historyColRight");
  if (!section || !leftCol || !rightCol) return;

  const history = getHistory();

  if (history.length === 0) {
    section.style.display = "none";
    leftCol.innerHTML = "";
    rightCol.innerHTML = "";
    return;
  }

  section.style.display = "block";

  const gen = ++historyLayoutGeneration;

  Promise.all(history.map((url) => loadImageAspectRatio(url)))
    .then((ratios) => {
      if (gen !== historyLayoutGeneration) return;

      const { left, right } = distributeHistoryToBalancedColumns(history, ratios);

      leftCol.innerHTML = "";
      rightCol.innerHTML = "";

      function appendColumn(col, urls) {
        urls.forEach((url) => {
          col.appendChild(buildPhotoHistoryItem(url));
        });
      }

      appendColumn(leftCol, left);
      appendColumn(rightCol, right);
    })
    .catch((err) => {
      console.error("Failed to layout history:", err);
    });
}

/**
 * @param {string} url
 * @returns {HTMLElement}
 */
function buildPhotoHistoryItem(url) {
  const item = document.createElement("div");
  item.className = "history-item history-item--photo";
  item.dataset.historyUrl = url;
  item.innerHTML =
    '<img src="' +
    url +
    '" alt="" />' +
    '<div class="history-overlay">' +
    '<div class="history-overlay-bg"></div>' +
    '<div class="history-overlay-topright">' +
    '<button type="button" class="history-overlay-btn" data-history-action="remove" aria-label="Удалить из истории" title="Удалить из истории">' +
    '<span class="history-delete-icon" aria-hidden="true"></span>' +
    "</button>" +
    "</div>" +
    '<div class="history-overlay-buttons-left">' +
    '<button type="button" class="history-overlay-btn" data-history-action="edit" aria-label="Изменить по описанию" title="Изменить по описанию">' +
    EDIT_ICON_SVG +
    "</button>" +
    '<button type="button" class="history-overlay-btn" data-history-action="upscale" aria-label="Улучшить разрешение" title="Улучшить разрешение">' +
    IMPROVE_ICON_SVG +
    "</button>" +
    "</div>" +
    '<div class="history-overlay-buttons-right">' +
    '<button type="button" class="history-overlay-btn" data-history-action="insert" aria-label="Вставить" title="Вставить">' +
    PASTE_ICON_SVG +
    "</button>" +
    "</div>" +
    "</div>";
  return item;
}

/**
 * @param {string} url
 * @returns {HTMLElement}
 */
function buildIllHistoryItem(url) {
  const item = document.createElement("div");
  item.className = "history-item history-item--photo history-item--ill-history";
  item.dataset.historyUrl = url;
  item.innerHTML =
    '<img src="' +
    url +
    '" alt="" />' +
    '<div class="history-overlay">' +
    '<div class="history-overlay-bg"></div>' +
    '<div class="history-overlay-topright">' +
    '<button type="button" class="history-overlay-btn" data-ill-history-action="remove" aria-label="Удалить из истории" title="Удалить из истории">' +
    '<span class="history-delete-icon" aria-hidden="true"></span>' +
    "</button>" +
    "</div>" +
    '<div class="history-overlay-buttons-left">' +
    '<button type="button" class="history-overlay-btn" data-ill-history-action="remove_bg" aria-label="Удалить фон" title="Удалить фон">' +
    REMOVE_BG_ICON_SVG +
    "</button>" +
    '<button type="button" class="history-overlay-btn" data-ill-history-action="edit" aria-label="Изменить по описанию" title="Изменить по описанию">' +
    EDIT_ICON_SVG +
    "</button>" +
    '<button type="button" class="history-overlay-btn" data-ill-history-action="upscale" aria-label="Улучшить разрешение" title="Улучшить разрешение">' +
    IMPROVE_ICON_SVG +
    "</button>" +
    "</div>" +
    '<div class="history-overlay-buttons-right">' +
    '<button type="button" class="history-overlay-btn" data-ill-history-action="insert" aria-label="Вставить на слайд" title="Вставить на слайд">' +
    PASTE_ICON_SVG +
    "</button>" +
    "</div>" +
    "</div>";
  return item;
}

async function handleHistoryGridClick(e) {
  const btn = e.target.closest("[data-history-action]");
  if (!btn) return;
  const item = btn.closest(".history-item");
  const url = item ? item.dataset.historyUrl : null;
  if (!url) return;

  const action = btn.dataset.historyAction;

  // Удаление из истории — всегда доступно.
  if (action === "remove") {
    removeFromHistory(url);
    return;
  }

  // Вставка работает всегда — даже когда идёт генерация / апскейл.
  if (action === "insert") {
    btn.disabled = true;
    try {
      await insertImage(url, true);
    } catch (err) {
      console.error("Failed to insert history image:", err);
    } finally {
      btn.disabled = false;
    }
    return;
  }

  // Edit / upscale нельзя начать пока активна другая генерация.
  if (generateState === "generating") return;

  if (action === "edit") {
    startPhotoEditMode(url);
    return;
  }

  if (action === "upscale") {
    startPhotoUpscaleMode(url);
    return;
  }
}

/**
 * Оверлей на карточках «Предыдущие генерации» (иллюстрации) — отдельные data-атрибуты от фото.
 */
async function handleIllHistoryGridClick(e) {
  const btn = e.target.closest("[data-ill-history-action]");
  if (!btn) return;
  const item = btn.closest(".history-item");
  const url = item ? item.dataset.historyUrl : null;
  if (!url) return;

  const action = btn.getAttribute("data-ill-history-action");

  if (action === "remove") {
    removeFromIllHistory(url);
    return;
  }

  if (action === "insert") {
    btn.disabled = true;
    try {
      await insertImage(url, true);
    } catch (err) {
      console.error("Failed to insert illustration history image:", err);
    } finally {
      btn.disabled = false;
    }
    return;
  }

  if (illGenerateState === "generating") return;

  if (action === "remove_bg") {
    callN8nIllustration({ action: "remove", sourceImageUrl: url });
    return;
  }

  if (action === "edit") {
    startIllEditMode(url);
    return;
  }

  if (action === "upscale") {
    startIllUpscaleMode(url);
    return;
  }
}

// ========================
// Generation state machine
// ========================

/**
 * @param {"idle"|"generating"|"error"|"result"} state
 * @param {{ preservePhotoUiOnCancel?: boolean }} [opts] — для idle после отмены: не сбрасывать режим фото/референс
 */
function setGenerateState(state, opts) {
  generateState = state;

  const input = document.getElementById("promptInput");
  const mainBtn = document.getElementById("generateMainBtn");
  const box = document.getElementById("generationBox");
  if (!input || !mainBtn || !box) return;

  switch (state) {
    case "idle": {
      const preserve = opts && opts.preservePhotoUiOnCancel;
      input.disabled = false;
      input.classList.remove("generating");
      if (!preserve) {
        resetPhotoUiToGenerate();
        clearPhotoRefSlideHintError();
        clearPhotoReference();
        generatedImageUrl = null;
        generatedImageUrlLight = null;
        generatedImageUrlDark = null;
      }
      updatePhotoRefSlideUi();
      mainBtn.style.display = "";
      setAspectThemeControlsDisabled(false);
      renderPhotoGenBox();
      updateMainButton();
      if (!preserve) {
        renderHistory();
      }
      break;
    }

    case "generating": {
      input.disabled = true;
      input.classList.add("generating");
      mainBtn.style.display = "";
      if (photoUiMode === "generate") {
        generatedImageUrlLight = null;
        generatedImageUrlDark = null;
        generatedImageUrl = null;
      } else {
        generatedImageUrl = null;
      }
      renderPhotoGenBox();
      setAspectThemeControlsDisabled(true);
      updateMainButton();
      break;
    }

    case "error":
      input.disabled = false;
      input.classList.remove("generating");
      mainBtn.style.display = "";
      setAspectThemeControlsDisabled(false);
      updateMainButton();
      break;

    case "result":
      input.disabled = false;
      input.classList.remove("generating");
      mainBtn.style.display = "";
      setAspectThemeControlsDisabled(false);
      updateMainButton();

      if (photoUiMode === "generate") {
        if (generatedImageUrlLight && generatedImageUrlDark) {
          addToHistory(generatedImageUrlLight);
          addToHistory(generatedImageUrlDark);
        } else if (generatedImageUrl) {
          addToHistory(generatedImageUrl);
        }
      } else if (generatedImageUrl) {
        addToHistory(generatedImageUrl);
      }
      renderPhotoGenBox();
      renderHistory();
      break;
  }
  updateHomeGenerationTileStatus();
}

function cancelGeneration() {
  if (generateAbortController) {
    generateAbortController.abort();
    generateAbortController = null;
  }
}

// ========================
// Генерация через n8n (синхронный POST + таймаут)
// ========================

/**
 * @param {Record<string, unknown>} status
 * @returns {string|null}
 */
function extractStatusImageUrl(status) {
  if (!status || typeof status !== "object") return null;
  const direct =
    status.imageUrl || status.result?.imageUrl || status.result?.images?.[0]?.url || null;
  if (typeof direct === "string" && direct.trim()) return direct.trim();
  const r = status.result;
  if (typeof r === "string" && /^https?:\/\//i.test(r)) return r.trim();
  if (r && typeof r === "object") {
    const o = r.output;
    if (typeof o === "string" && /^https?:\/\//i.test(o)) return o.trim();
    if (Array.isArray(o) && typeof o[0] === "string" && /^https?:\/\//i.test(o[0]))
      return o[0].trim();
    if (
      Array.isArray(r.images) &&
      typeof r.images[0] === "string" &&
      /^https?:\/\//i.test(r.images[0])
    ) {
      return r.images[0].trim();
    }
  }
  return null;
}

/**
 * Генерация фото: n8n отдаёт оба URL, пока нет — продолжаем poll.
 * @param {Record<string, unknown>} status
 * @returns {{ light: string, dark: string } | null}
 */
function extractDualImageUrlsIfReady(status) {
  if (!status || typeof status !== "object") return null;
  const L = status.imageUrlLight || (status.result && status.result.imageUrlLight);
  const D = status.imageUrlDark || (status.result && status.result.imageUrlDark);
  if (
    typeof L === "string" &&
    L.trim() &&
    /^https?:\/\//i.test(L) &&
    typeof D === "string" &&
    D.trim() &&
    /^https?:\/\//i.test(D)
  ) {
    return { light: L.trim(), dark: D.trim() };
  }
  return null;
}

/**
 * @param {"light"|"dark"|null} variant
 * @returns {string|null}
 */
function pickGeneratedUrlByVariant(variant) {
  if (variant === "light") return generatedImageUrlLight || null;
  if (variant === "dark") return generatedImageUrlDark || null;
  return generatedImageUrl || null;
}

/**
 * Применяет элементы интерфейса (label, ввод, ref/aspect) под текущий режим экрана.
 */
function applyPhotoUiModeChrome() {
  const labelText = document.getElementById("genPromptLabelText");
  const backBtn = document.getElementById("genPromptBackBtn");
  const wrapper = document.getElementById("genPromptWrapper");
  const alpha = document.getElementById("genAlphaDisclaimer");
  const picSettingsRow = document.getElementById("picSettingsRow");
  const input = document.getElementById("promptInput");

  const showBack = photoUiMode === "edit" || photoUiMode === "upscale";
  if (backBtn) backBtn.classList.toggle("visible", showBack);

  if (photoUiMode === "edit") {
    if (labelText) labelText.textContent = "Описание изменений";
    if (input) input.placeholder = "Опишите, что изменить";
    if (wrapper) wrapper.style.display = "";
    if (alpha) alpha.style.display = "none";
    if (picSettingsRow) picSettingsRow.style.display = "none";
  } else if (photoUiMode === "upscale") {
    if (labelText) labelText.textContent = "Улучшение качества";
    if (wrapper) wrapper.style.display = "none";
    if (alpha) alpha.style.display = "none";
    if (picSettingsRow) picSettingsRow.style.display = "none";
  } else {
    if (labelText) labelText.textContent = "Описание изображения";
    if (input) input.placeholder = "Опишите фотографию, которую вы хотите создать";
    if (wrapper) wrapper.style.display = "";
    if (alpha) alpha.style.display = "";
    if (picSettingsRow) picSettingsRow.style.display = "";
  }
}

function resetPhotoUiToGenerate() {
  photoUiMode = "generate";
  pendingSourceUrl = null;
  applyPhotoUiModeChrome();
}

function scrollGenerateScreenToTop() {
  const screen = document.getElementById("generateScreen");
  if (screen) screen.scrollTop = 0;
  if (typeof window !== "undefined" && typeof window.scrollTo === "function") {
    try {
      window.scrollTo(0, 0);
    } catch {
      /* ignore */
    }
  }
}

/**
 * Войти в режим «Изменить по описанию». Запускать генерацию НЕ нужно — пользователь
 * напечатает промпт и сам нажмёт инлайн-кнопку.
 */
function startPhotoEditMode(sourceUrl) {
  if (!sourceUrl) return;
  photoUiMode = "edit";
  pendingSourceUrl = sourceUrl;
  generatedImageUrl = null;
  generatedImageUrlLight = null;
  generatedImageUrlDark = null;
  generateState = "idle";

  applyPhotoUiModeChrome();
  scrollGenerateScreenToTop();

  const input = document.getElementById("promptInput");
  if (input) {
    input.value = "";
    input.disabled = false;
    input.classList.remove("generating");
    autoResize(input);
    try {
      input.focus();
    } catch {
      /* ignore */
    }
  }

  renderPhotoGenBox();
  updateMainButton();
}

/**
 * Войти в режим «Улучшить разрешение» и сразу же запустить апскейл.
 */
function startPhotoUpscaleMode(sourceUrl) {
  if (!sourceUrl) return;
  photoUiMode = "upscale";
  pendingSourceUrl = sourceUrl;
  generatedImageUrl = null;
  generatedImageUrlLight = null;
  generatedImageUrlDark = null;

  applyPhotoUiModeChrome();
  scrollGenerateScreenToTop();
  callN8nPhoto({ action: "upscale", sourceImageUrl: sourceUrl });
}

async function handleGenerationBoxClick(e) {
  const btn = e.target.closest("[data-result-action]");
  if (!btn) return;
  if (generateState === "generating") return;

  const action = btn.dataset.resultAction;
  const frame = btn.closest(".gen-box-frame");
  const role = frame ? frame.dataset.frameRole : null;
  const variant =
    btn.dataset.variant === "light" || btn.dataset.variant === "dark" ? btn.dataset.variant : null;

  const url = role === "source" ? pendingSourceUrl : pickGeneratedUrlByVariant(variant);
  if (!url) return;

  if (action === "insert") {
    const label = btn.querySelector("span");
    const oldText = label ? label.textContent : "";
    btn.disabled = true;
    if (label) label.textContent = "Вставка…";
    try {
      await insertImage(url, true);
      if (photoUiMode === "generate") {
        setGenerateState("idle");
      } else {
        // В режимах edit / upscale экран не сбрасываем — пользователь может
        // продолжать работу с теми же source + результатом.
        btn.disabled = false;
        if (label) label.textContent = oldText;
      }
    } catch (err) {
      console.error("Insert generated image failed:", err);
      btn.disabled = false;
      if (label) label.textContent = oldText;
    }
    return;
  }

  if (action === "upscale") {
    startPhotoUpscaleMode(url);
    return;
  }

  if (action === "edit") {
    startPhotoEditMode(url);
    return;
  }
}

function scrollIllustrationScreenToTop() {
  const screen = document.getElementById("illustrationGenerateScreen");
  if (screen) screen.scrollTop = 0;
  if (typeof window !== "undefined" && typeof window.scrollTo === "function") {
    try {
      window.scrollTo(0, 0);
    } catch {
      /* ignore */
    }
  }
}

function applyIllUiModeChrome() {
  const labelText = document.getElementById("illPromptLabelText");
  const backBtn = document.getElementById("illPromptBackBtn");
  const wrapper = document.getElementById("illPromptWrapper");
  const settingsRow = document.getElementById("illSettingsRow");
  const alpha = document.getElementById("illAlphaDisclaimer");
  const input = document.getElementById("illPromptInput");
  const showBack = illUiMode === "edit" || illUiMode === "upscale";
  if (backBtn) backBtn.classList.toggle("visible", showBack);

  if (illUiMode === "edit") {
    if (labelText) labelText.textContent = "Описание изменений";
    if (input) input.placeholder = "Опишите, что изменить";
    if (wrapper) wrapper.style.display = "";
    if (settingsRow) settingsRow.style.display = "none";
    if (alpha) alpha.style.display = "none";
  } else if (illUiMode === "upscale") {
    if (labelText) labelText.textContent = "Улучшение качества";
    if (wrapper) wrapper.style.display = "none";
    if (settingsRow) settingsRow.style.display = "none";
    if (alpha) alpha.style.display = "none";
  } else {
    if (labelText) labelText.textContent = "Описание иллюстрации";
    if (input) input.placeholder = "Опишите иллюстрацию, которую вы хотите создать";
    if (wrapper) wrapper.style.display = "";
    if (settingsRow) settingsRow.style.display = "";
    if (alpha) alpha.style.display = "";
  }
}

function resetIllUiToGenerate() {
  cancelIllGeneration();
  illUiMode = "generate";
  illPendingSourceUrl = null;
  illGeneratedImageUrl = null;
  illGenerateState = "idle";
  illGenerateAbortController = null;
  const input = document.getElementById("illPromptInput");
  if (input) {
    input.value = "";
    input.disabled = false;
    input.classList.remove("generating");
    autoResize(input);
  }
  setIllControlsDisabled(false);
  applyIllUiModeChrome();
  updateIllMainButton();
  renderIllGenBox();
}

/**
 * @param {string} sourceUrl
 */
function startIllEditMode(sourceUrl) {
  if (!sourceUrl) return;
  illUiMode = "edit";
  illPendingSourceUrl = sourceUrl;
  illGeneratedImageUrl = null;
  illGenerateState = "idle";

  applyIllUiModeChrome();
  scrollIllustrationScreenToTop();

  const input = document.getElementById("illPromptInput");
  if (input) {
    input.value = "";
    input.disabled = false;
    input.classList.remove("generating");
    autoResize(input);
    try {
      input.focus();
    } catch {
      /* ignore */
    }
  }
  setIllControlsDisabled(false);
  renderIllGenBox();
  updateIllMainButton();
}

/**
 * @param {string} sourceUrl
 */
function startIllUpscaleMode(sourceUrl) {
  if (!sourceUrl) return;
  illUiMode = "upscale";
  illPendingSourceUrl = sourceUrl;
  illGeneratedImageUrl = null;

  applyIllUiModeChrome();
  scrollIllustrationScreenToTop();
  callN8nIllustration({ action: "upscale", sourceImageUrl: sourceUrl });
}

function getPhotoGenLoadingFrameHtml() {
  return (
    '<div class="gen-box-frame loading">' +
    '<div class="gen-box-loading-content">' +
    "<span>Генерация</span>" +
    '<span class="spinner spinner--ring" aria-hidden="true"></span>' +
    "</div>" +
    "</div>"
  );
}

const PHOTO_FRAME_ALL_ACTIONS = ["edit", "upscale", "insert"];
/** Полный набор кнопок на превью иллюстрации (градиент как у фото). */
const ILL_GEN_FRAME_ALL_ACTIONS = ["remove_bg", "edit", "upscale", "insert"];

/**
 * @param {string} url
 * @param {"light"|"dark"|null} variant
 * @param {{ role?: "source"|"result", actions?: Array<"remove_bg"|"edit"|"upscale"|"insert"> }} [options]
 */
function getPhotoGenResultFrameHtml(url, variant, options) {
  const role = (options && options.role) || "result";
  const actions = (options && options.actions) || PHOTO_FRAME_ALL_ACTIONS;
  const variantAttr = variant ? ' data-variant="' + variant + '"' : "";
  const roleAttr = ' data-frame-role="' + role + '"';

  const removeBgBtn =
    actions.indexOf("remove_bg") >= 0
      ? '<button type="button" class="gen-overlay-btn" data-result-action="remove_bg"' +
        variantAttr +
        ">" +
        REMOVE_BG_ICON_SVG +
        "<span>Удалить фон</span>" +
        "</button>"
      : "";
  const editBtn =
    actions.indexOf("edit") >= 0
      ? '<button type="button" class="gen-overlay-btn" data-result-action="edit"' +
        variantAttr +
        ">" +
        EDIT_ICON_SVG +
        "<span>Изменить по описанию</span>" +
        "</button>"
      : "";
  const upscaleBtn =
    actions.indexOf("upscale") >= 0
      ? '<button type="button" class="gen-overlay-btn" data-result-action="upscale"' +
        variantAttr +
        ">" +
        IMPROVE_ICON_SVG +
        "<span>Улучшить разрешение</span>" +
        "</button>"
      : "";
  const insertBtn =
    actions.indexOf("insert") >= 0
      ? '<button type="button" class="gen-overlay-btn" data-result-action="insert"' +
        variantAttr +
        ">" +
        PASTE_ICON_SVG +
        "<span>Вставить</span>" +
        "</button>"
      : "";

  const leftHtml =
    removeBgBtn || editBtn || upscaleBtn
      ? '<div class="gen-result-overlay-buttons-left">' +
        removeBgBtn +
        editBtn +
        upscaleBtn +
        "</div>"
      : "";
  const rightHtml = insertBtn
    ? '<div class="gen-result-overlay-buttons-right">' + insertBtn + "</div>"
    : "";

  return (
    '<div class="gen-box-frame result"' +
    variantAttr +
    roleAttr +
    ">" +
    '<img src="' +
    url +
    '" alt="" />' +
    '<div class="gen-result-overlay">' +
    '<div class="gen-result-overlay-bg"></div>' +
    leftHtml +
    rightHtml +
    "</div>" +
    "</div>"
  );
}

/**
 * @param {string|null} darkUrl
 * @param {string|null} lightUrl
 */
function getPhotoGenDualBoxHtml(darkUrl, lightUrl) {
  const slot = (url, variant) =>
    url ? getPhotoGenResultFrameHtml(url, variant) : getPhotoGenLoadingFrameHtml();
  return '<div class="gen-box-stack">' + slot(darkUrl, "dark") + slot(lightUrl, "light") + "</div>";
}

/**
 * Главный рендерер блока с фотографиями (#generationBox) — учитывает photoUiMode + generateState.
 */
function renderPhotoGenBox() {
  const box = document.getElementById("generationBox");
  if (!box) return;

  const hide = () => {
    box.classList.remove("visible");
    box.innerHTML = "";
  };

  if (photoUiMode === "edit") {
    if (!pendingSourceUrl) {
      hide();
      return;
    }
    let html = '<div class="gen-box-stack">';
    html += getPhotoGenResultFrameHtml(pendingSourceUrl, null, {
      role: "source",
      actions: ["upscale", "insert"],
    });
    if (generateState === "generating") {
      html += getPhotoGenLoadingFrameHtml();
    } else if (generateState === "result" && generatedImageUrl) {
      html += getPhotoGenResultFrameHtml(generatedImageUrl, null, {
        role: "result",
        actions: PHOTO_FRAME_ALL_ACTIONS,
      });
    }
    html += "</div>";
    box.classList.add("visible");
    box.innerHTML = html;
    return;
  }

  if (photoUiMode === "upscale") {
    if (!pendingSourceUrl) {
      hide();
      return;
    }
    let html = '<div class="gen-box-stack">';
    html += getPhotoGenResultFrameHtml(pendingSourceUrl, null, {
      role: "source",
      actions: ["insert"],
    });
    if (generateState === "generating") {
      html += getPhotoGenLoadingFrameHtml();
    } else if (generateState === "result" && generatedImageUrl) {
      html += getPhotoGenResultFrameHtml(generatedImageUrl, null, {
        role: "result",
        actions: PHOTO_FRAME_ALL_ACTIONS,
      });
    }
    html += "</div>";
    box.classList.add("visible");
    box.innerHTML = html;
    return;
  }

  // photoUiMode === "generate"
  if (generateState === "generating") {
    box.classList.add("visible");
    box.innerHTML = getPhotoGenDualBoxHtml(generatedImageUrlDark, generatedImageUrlLight);
    return;
  }

  if (generateState === "result") {
    if (generatedImageUrlLight && generatedImageUrlDark) {
      box.classList.add("visible");
      box.innerHTML = getPhotoGenDualBoxHtml(generatedImageUrlDark, generatedImageUrlLight);
      return;
    }
    if (generatedImageUrl) {
      box.classList.add("visible");
      box.innerHTML =
        '<div class="gen-box-stack">' +
        getPhotoGenResultFrameHtml(generatedImageUrl, null, { role: "result" }) +
        "</div>";
      return;
    }
  }

  hide();
}

function updatePhotoGenProgressiveBox() {
  if (generateState !== "generating") return;
  renderPhotoGenBox();
}

/**
 * Ответ opроса PPT-флоу: сначала тёмный URL (pending: true), затем оба.
 * @param {Record<string, unknown>} j
 * @returns {{ dark: string|null, light: string|null, isComplete: boolean }}
 */
function parsePhotoDualPollPayload(j) {
  if (!j || typeof j !== "object") {
    return { dark: null, light: null, isComplete: false };
  }
  if (j.success === false) {
    if (j.error) throw new Error(String(j.error));
  }
  let d =
    (typeof j.imageUrlDark === "string" &&
      /^https?:\/\//i.test(j.imageUrlDark.trim()) &&
      j.imageUrlDark.trim()) ||
    null;
  const l =
    (typeof j.imageUrlLight === "string" &&
      /^https?:\/\//i.test(j.imageUrlLight.trim()) &&
      j.imageUrlLight.trim()) ||
    null;
  if (
    !d &&
    j.pending &&
    typeof j.imageUrl === "string" &&
    /^https?:\/\//i.test(String(j.imageUrl).trim()) &&
    !l
  ) {
    d = String(j.imageUrl).trim();
  }
  const isComplete = !!(d && l);
  return { dark: d, light: l, isComplete };
}

/**
 * @param {Record<string, unknown>} startData
 * @param {AbortSignal} signal
 */
async function pollN8nUntilPhotoProgressive(startData, signal) {
  const pollBaseUrl = N8N_POLL_URL;
  const taskId = extractN8nTaskId(startData);
  let pollUrl = null;
  if (typeof startData.pollUrl === "string" && startData.pollUrl.trim()) {
    pollUrl = resolveN8nPollUrlFromResponse(startData.pollUrl);
  } else if (taskId) {
    pollUrl = N8N_POLL_USE_POST ? pollBaseUrl : buildN8nDefaultPollUrl(taskId, pollBaseUrl);
  } else {
    throw new Error("Асинхронный ответ без taskId — проверьте узел Respond");
  }
  const deadline = Date.now() + N8N_PHOTO_GENERATE_TIMEOUT_MS;
  let pollRound = 0;
  while (Date.now() < deadline) {
    if (signal.aborted) {
      const e = new Error("aborted");
      e.name = "AbortError";
      throw e;
    }
    const fetchOpts = { signal, headers: {} };
    if (N8N_POLL_USE_POST) {
      fetchOpts.method = "POST";
      fetchOpts.headers["Content-Type"] = "application/json";
      fetchOpts.body = JSON.stringify(taskId ? { taskId } : {});
    } else {
      fetchOpts.method = "GET";
    }
    const res = await fetch(pollUrl, fetchOpts);
    const rawText = await res.text();
    let json = null;
    if (rawText) {
      try {
        json = JSON.parse(rawText);
      } catch {
        json = null;
      }
    }
    if (res.ok && json && typeof json === "object") {
      if (json.success === false && json.error) {
        throw new Error(String(json.error));
      }
      const pr = parsePhotoDualPollPayload(json);
      if (pr.dark) {
        generatedImageUrlDark = pr.dark;
        generatedImageUrl = pr.dark;
        updatePhotoGenProgressiveBox();
      }
      if (pr.light) {
        generatedImageUrlLight = pr.light;
        updatePhotoGenProgressiveBox();
      }
      if (pr.isComplete) return;
    } else if (!res.ok && res.status < 500) {
      throw new Error(
        "Опрос статуса: " +
          res.status +
          (rawText && rawText.length < 200 ? " " + rawText.trim() : "")
      );
    }
    const waitMs =
      N8N_PHOTO_POLL_INTERVALS_MS[Math.min(pollRound, N8N_PHOTO_POLL_INTERVALS_MS.length - 1)];
    pollRound++;
    await new Promise((r) => setTimeout(r, waitMs));
  }
  throw new Error("Превышено время ожидания (10 мин) — упростите запрос или повторите позже");
}

function extractN8nTaskId(data) {
  if (!data || typeof data !== "object") return null;
  const keys = ["taskId", "jobId", "executionId", "pollId", "id"];
  for (let i = 0; i < keys.length; i++) {
    const v = data[keys[i]];
    if (typeof v === "string" && v.trim()) return v.trim();
    if (typeof v === "number" && Number.isFinite(v)) return String(v);
  }
  return null;
}

function resolveN8nPollUrlFromResponse(pollUrlRaw) {
  const p = String(pollUrlRaw || "").trim();
  if (!p) return null;
  if (/^https?:\/\//i.test(p)) return p;
  const base = N8N_BASE.endsWith("/") ? N8N_BASE.slice(0, -1) : N8N_BASE;
  return p.startsWith("/") ? base + p : base + "/" + p;
}

function buildN8nDefaultPollUrl(taskId, pollBaseUrl) {
  const base = pollBaseUrl || N8N_POLL_URL;
  const u = new URL(base);
  u.searchParams.set("taskId", taskId);
  return u.href;
}

function shouldPollN8nResult(data) {
  if (!data || typeof data !== "object") return false;
  if (data.async === true) return true;
  if (extractN8nTaskId(data)) return true;
  if (typeof data.pollUrl === "string" && data.pollUrl.trim()) return true;
  return false;
}

/**
 * Пока нет imageUrl — повторяет запрос к webhook статуса (шлюз n8n Cloud ~20 с не ждёт долгий один POST).
 * @param {Record<string, unknown>} startData — тело быстрого ответа старта
 * @param {AbortSignal} signal
 * @param {{ pollBaseUrl?: string, wantDual?: boolean }} [options]
 * @returns {Promise<string|{ light: string, dark: string }>}
 */
async function pollN8nUntilImage(startData, signal, options) {
  const wantDual = options && options.wantDual === true;
  const pollBaseUrl = options && options.pollBaseUrl ? options.pollBaseUrl : N8N_POLL_URL;
  const taskId = extractN8nTaskId(startData);
  let pollUrl = null;
  if (typeof startData.pollUrl === "string" && startData.pollUrl.trim()) {
    pollUrl = resolveN8nPollUrlFromResponse(startData.pollUrl);
  } else if (taskId) {
    pollUrl = N8N_POLL_USE_POST ? pollBaseUrl : buildN8nDefaultPollUrl(taskId, pollBaseUrl);
  } else {
    throw new Error("Асинхронный ответ без taskId и pollUrl — проверьте узел Respond в n8n");
  }

  const deadline = Date.now() + N8N_GENERATION_TIMEOUT_MS;
  let pollRound = 0;

  while (Date.now() < deadline) {
    if (signal.aborted) {
      const e = new Error("aborted");
      e.name = "AbortError";
      throw e;
    }

    const fetchOpts = {
      signal: signal,
      headers: {},
    };
    if (N8N_POLL_USE_POST) {
      fetchOpts.method = "POST";
      fetchOpts.headers["Content-Type"] = "application/json";
      fetchOpts.body = JSON.stringify(taskId ? { taskId: taskId } : {});
    } else {
      fetchOpts.method = "GET";
    }

    const res = await fetch(pollUrl, fetchOpts);

    const rawText = await res.text();
    let json = null;
    if (rawText) {
      try {
        json = JSON.parse(rawText);
      } catch {
        json = null;
      }
    }

    if (res.ok && json && typeof json === "object") {
      if (json.success === false && json.error) {
        throw new Error(String(json.error));
      }
      if (wantDual) {
        const dual = extractDualImageUrlsIfReady(json);
        if (dual) return dual;
      } else {
        const u =
          extractStatusImageUrl(json) ||
          (typeof json.imageUrl === "string" && json.imageUrl.trim() ? json.imageUrl.trim() : null);
        if (u) return u;
      }
    } else if (!res.ok && res.status < 500) {
      throw new Error(
        "Опрос статуса: " +
          res.status +
          (rawText && rawText.length < 200 ? " " + rawText.trim() : "")
      );
    }

    const waitMs = N8N_POLL_INTERVALS_MS[Math.min(pollRound, N8N_POLL_INTERVALS_MS.length - 1)];
    pollRound++;
    await new Promise((resolve) => setTimeout(resolve, waitMs));
  }

  throw new Error("Превышено время ожидания результата при опросе статуса");
}

/**
 * @param {{ action?: string, prompt?: string, sourceImageUrl?: string }} opts
 */
async function callN8nPhoto(opts) {
  const action = opts.action || "generate";
  const body = {
    action: action,
    serviceId: "yandex_ads",
  };

  if (action === "generate") {
    body.aspect = selectedAspect;
  }

  if (action === "generate" || action === "edit") {
    const trimmed = String(opts.prompt || "").trim();
    if (!trimmed) {
      return;
    }
    body.prompt = trimmed;
  }

  if (action === "generate" && picReferenceBase64) {
    body.sourceImageBase64 = picReferenceBase64;
    body.sourceImageMimeType = picReferenceMimeType || "image/png";
  }

  if (action === "upscale" || action === "edit") {
    const src = opts.sourceImageUrl || generatedImageUrl;
    if (!src) {
      return;
    }
    body.sourceImageUrl = src;
  }

  cancelGeneration();
  if (action === "generate") {
    photoGenerateHomeReady = false;
    updateHomeGenerationTileStatus();
  }
  setGenerateState("generating");

  generateAbortController = new AbortController();
  const signal = generateAbortController.signal;

  const runTimeoutMs =
    action === "generate" ? N8N_PHOTO_GENERATE_TIMEOUT_MS : N8N_GENERATION_TIMEOUT_MS;
  let hitGenerationTimeout = false;
  const timeoutId = setTimeout(() => {
    hitGenerationTimeout = true;
    try {
      generateAbortController.abort();
    } catch (_e) {
      /* ignore */
    }
  }, runTimeoutMs);

  try {
    const startResponse = await fetch(N8N_START_URL, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(body),
      signal: signal,
    });

    const rawText = await startResponse.text();
    let data = null;
    if (rawText) {
      try {
        data = JSON.parse(rawText);
      } catch {
        data = null;
      }
    }

    if (!startResponse.ok) {
      const st = startResponse.status;
      let msg;
      if (st === 504 || st === 502) {
        msg =
          "Таймаут шлюза (код " +
          st +
          '): ответ не пришёл в срок (на n8n Cloud обычно ~20 с) — нужен быстрый ответ webhook с JSON вида { success: true, taskId: "…", async: true } и второй webhook для опроса результата (см. N8N_POLL_URL в taskpane.js), иначе шлюз обрывает долгий один запрос';
      } else if (data && (data.error || data.message)) {
        msg = String(data.error || data.message);
      } else if (rawText && rawText.length < 400 && !data) {
        msg = rawText.trim().replace(/\s+/g, " ");
      } else {
        msg = "Ошибка запроса: " + st;
      }
      throw new Error(msg);
    }

    if (!data || typeof data !== "object") {
      throw new Error(
        "Сервер вернул не JSON (код " +
          startResponse.status +
          "), проверьте URL webhook и что workflow отвечает узлом Respond"
      );
    }

    if (!data.success) {
      throw new Error(data.error || "Генерация не удалась");
    }

    if (action === "generate") {
      const dual0 = extractDualImageUrlsIfReady(data);
      if (dual0) {
        generatedImageUrlLight = dual0.light;
        generatedImageUrlDark = dual0.dark;
        generatedImageUrl = dual0.dark;
        photoGenerateHomeReady = true;
        updateHomeGenerationTileStatus();
        setGenerateState("result");
      } else {
        const pr0 = parsePhotoDualPollPayload(data);
        if (pr0.dark) {
          generatedImageUrlDark = pr0.dark;
          generatedImageUrl = pr0.dark;
          updatePhotoGenProgressiveBox();
        }
        if (pr0.light) {
          generatedImageUrlLight = pr0.light;
          updatePhotoGenProgressiveBox();
        }
        if (pr0.isComplete) {
          photoGenerateHomeReady = true;
          updateHomeGenerationTileStatus();
          setGenerateState("result");
        } else if (shouldPollN8nResult(data)) {
          await pollN8nUntilPhotoProgressive(data, signal);
          if (!generatedImageUrlDark || !generatedImageUrlLight) {
            throw new Error(
              data.error ||
                "Полный результат не пришёл — проверьте Read Pic Status (сначала тёмная, потом светлая) и опрос"
            );
          }
          photoGenerateHomeReady = true;
          updateHomeGenerationTileStatus();
          setGenerateState("result");
        } else {
          throw new Error(
            data.error || "Ожидается { async: true, taskId } и опрос, или оба URL в ответе опроса"
          );
        }
      }
    } else {
      let url =
        extractStatusImageUrl(data) ||
        (typeof data.imageUrl === "string" && data.imageUrl.trim() ? data.imageUrl.trim() : null);

      if (!url && shouldPollN8nResult(data)) {
        url = await pollN8nUntilImage(data, signal, { wantDual: false });
        if (typeof url !== "string" || !url) {
          throw new Error("Ожидался один URL после upscale/редактирования");
        }
      }

      if (!url) {
        throw new Error(
          data.error ||
            "В ответе нет URL изображения — настройте опрос статуса (N8N_POLL_URL) или верните imageUrl"
        );
      }

      generatedImageUrlLight = null;
      generatedImageUrlDark = null;
      generatedImageUrl = url;
      setGenerateState("result");
    }
  } catch (error) {
    if (error.name === "AbortError") {
      if (hitGenerationTimeout) {
        const timeoutMsg =
          action === "generate"
            ? "Превышено время ожидания (10 мин), попробуйте ещё раз или упростите запрос"
            : "Превышено время ожидания (5 мин), попробуйте ещё раз или упростите запрос";
        const box = document.getElementById("generationBox");
        if (box) {
          box.classList.add("visible");
          box.innerHTML = '<div class="error-text">' + timeoutMsg + "</div>";
        }
        setGenerateState("error");
      } else {
        setGenerateState("idle", { preservePhotoUiOnCancel: true });
      }
      return;
    }

    console.error("Image generation failed:", error);

    const msg = formatFetchErrorMessage(error);

    const box = document.getElementById("generationBox");
    if (box) {
      box.classList.add("visible");
      box.innerHTML = '<div class="error-text">' + msg + "</div>";
    }
    setGenerateState("error");
  } finally {
    clearTimeout(timeoutId);
    generateAbortController = null;
  }
}

async function callN8nGenerate(promptText) {
  await callN8nPhoto({ action: "generate", prompt: promptText });
}

// ========================
// Генерация иллюстраций (как в TG Illustration AIDSGN)
// ========================

function setIllControlsDisabled(disabled) {
  ["illChipStyle", "illChipAspect", "illChipReso", "illChipAttach"].forEach((id) => {
    const el = document.getElementById(id);
    if (el) el.disabled = !!disabled;
  });
  const refPreviewClearBtn = document.getElementById("illRefPreviewClearBtn");
  if (refPreviewClearBtn) {
    refPreviewClearBtn.disabled = !!disabled || !illReferenceBase64;
  }
}

function updateIllRefSlideUi() {
  const wrap = document.getElementById("illRefSlidePreviewWrap");
  const img = document.getElementById("illRefSlidePreview");

  if (wrap && img) {
    if (illReferenceBase64) {
      const mime = illReferenceMimeType || "image/png";
      img.src = "data:" + mime + ";base64," + illReferenceBase64;
      wrap.style.display = "";
    } else {
      img.removeAttribute("src");
      wrap.style.display = "none";
    }
  }
}

/** Применяет background-image к иконкам chip-кнопок (один раз). */
let illIconsApplied = false;
function applyIllChipIcons() {
  if (illIconsApplied) return;
  const map = {
    style: assetUrl(illIconStyleUrl),
    aspect: assetUrl(illIconSizeUrl),
    reso: assetUrl(illIconResoUrl),
    attach: assetUrl(illIconAttachUrl),
  };
  document.querySelectorAll(".ill-chip-icon[data-ill-icon]").forEach((el) => {
    const key = el.getAttribute("data-ill-icon");
    const url = map[key];
    if (url) el.style.backgroundImage = `url("${url}")`;
  });
  illIconsApplied = true;
}

/** Обновляет UI чипов согласно текущему состоянию. Чип «Стиль» всегда показывает «Стиль». */
function refreshIllChips() {
  const aspectLabel = document.getElementById("illChipAspectLabel");
  if (aspectLabel) aspectLabel.textContent = illAspect;

  const resoLabel = document.getElementById("illChipResoLabel");
  if (resoLabel) resoLabel.textContent = illMaxSide >= 2880 ? "4K" : "2K";

  // Активность чипа Прикрепить — подсветить, если есть референс или открыт поповер
  const attachChip = document.getElementById("illChipAttach");
  if (attachChip) {
    const hasRef = !!illReferenceBase64;
    const isOpen = illOpenPopover === "attach";
    attachChip.classList.toggle("active", hasRef || isOpen);
  }
}

/** Подсветка активного варианта в поповерах формата и разрешения. */
function refreshIllPopovers() {
  document.querySelectorAll("#illAspectPopover .ill-aspect-card").forEach((b) => {
    b.classList.toggle("active", b.dataset.illAspect === illAspect);
  });
  document.querySelectorAll("#illResoPopover .ill-radio-row").forEach((b) => {
    const v = parseInt(b.dataset.illMax || "0", 10);
    const isActive =
      v === illMaxSide || (v >= 2880 && illMaxSide >= 2880) || (v < 2880 && illMaxSide < 2880);
    b.classList.toggle("active", isActive);
  });
}

/** Отступ поповеров от нижнего края чипа (единообразно для всех). */
const ILL_POPOVER_CHIP_GAP = 8;

/** Позиционирует поповер под чипом и удерживает внутри экрана иллюстраций. */
function positionIllPopover(panelId, chipId, alignRight) {
  const panel = document.getElementById(panelId);
  const chip = document.getElementById(chipId);
  const screen = document.getElementById("illustrationGenerateScreen");
  if (!panel || !chip || !screen) return;
  const screenRect = screen.getBoundingClientRect();
  const chipRect = chip.getBoundingClientRect();
  const margin = 12;
  panel.style.position = "absolute";
  panel.style.top = chipRect.bottom - screenRect.top + ILL_POPOVER_CHIP_GAP + "px";

  if (alignRight) {
    panel.style.right = screenRect.right - chipRect.right + "px";
    panel.style.left = "auto";
  } else {
    panel.style.left = chipRect.left - screenRect.left + "px";
    panel.style.right = "auto";
  }

  void panel.offsetWidth;

  const panelW = panel.offsetWidth;
  const screenInnerW = screenRect.width;

  if (alignRight) {
    let rightPx = screenRect.right - chipRect.right;
    const pr = panel.getBoundingClientRect();
    if (pr.left < screenRect.left + margin) {
      const shift = screenRect.left + margin - pr.left;
      rightPx = Math.max(margin, rightPx - shift);
    }
    panel.style.right = rightPx + "px";
    panel.style.left = "auto";
  } else {
    let leftPx = chipRect.left - screenRect.left;
    const maxLeft = Math.max(margin, screenInnerW - margin - panelW);
    leftPx = Math.min(leftPx, maxLeft);
    leftPx = Math.max(margin, leftPx);
    panel.style.left = leftPx + "px";
    panel.style.right = "auto";
  }
}

/** Позиционирование поповеров под чипами на экране «Генерация фотографий». */
function positionPicPopover(panelId, chipId, alignRight) {
  const panel = document.getElementById(panelId);
  const chip = document.getElementById(chipId);
  const screen = document.getElementById("generateScreen");
  if (!panel || !chip || !screen) return;
  const screenRect = screen.getBoundingClientRect();
  const chipRect = chip.getBoundingClientRect();
  const margin = 12;
  panel.style.position = "absolute";
  panel.style.top = chipRect.bottom - screenRect.top + ILL_POPOVER_CHIP_GAP + "px";

  if (alignRight) {
    panel.style.right = screenRect.right - chipRect.right + "px";
    panel.style.left = "auto";
  } else {
    panel.style.left = chipRect.left - screenRect.left + "px";
    panel.style.right = "auto";
  }

  void panel.offsetWidth;

  const panelW = panel.offsetWidth;
  const screenInnerW = screenRect.width;

  if (alignRight) {
    let rightPx = screenRect.right - chipRect.right;
    const pr = panel.getBoundingClientRect();
    if (pr.left < screenRect.left + margin) {
      const shift = screenRect.left + margin - pr.left;
      rightPx = Math.max(margin, rightPx - shift);
    }
    panel.style.right = rightPx + "px";
    panel.style.left = "auto";
  } else {
    let leftPx = chipRect.left - screenRect.left;
    const maxLeft = Math.max(margin, screenInnerW - margin - panelW);
    leftPx = Math.min(leftPx, maxLeft);
    leftPx = Math.max(margin, leftPx);
    panel.style.left = leftPx + "px";
    panel.style.right = "auto";
  }
}

function refreshPicChips() {
  const aspectLabel = document.getElementById("picChipAspectLabel");
  if (aspectLabel) {
    aspectLabel.textContent =
      selectedAspect === "vertical" ? "9:16" : selectedAspect === "square" ? "1:1" : "16:9";
  }
  const attachChip = document.getElementById("picChipAttach");
  if (attachChip) {
    const hasRef = !!picReferenceBase64;
    const isOpen = picOpenPopover === "attach";
    attachChip.classList.toggle("active", hasRef || isOpen);
  }
}

function refreshPicPopovers() {
  document.querySelectorAll("#picAspectPopover .ill-aspect-card").forEach((b) => {
    b.classList.toggle("active", b.dataset.picAspect === selectedAspect);
  });
}

function closePicPopovers() {
  ["picAspectPopover", "picAttachPopover"].forEach((id) => {
    const el = document.getElementById(id);
    if (el) {
      el.hidden = true;
      el.style.removeProperty("top");
      el.style.removeProperty("left");
      el.style.removeProperty("right");
    }
  });
  ["picChipAspect", "picChipAttach"].forEach((id) => {
    const el = document.getElementById(id);
    if (el) {
      el.setAttribute("aria-expanded", "false");
      if (id !== "picChipAttach") el.classList.remove("active");
    }
  });
  picOpenPopover = null;
  refreshPicChips();
}

function openPicPopover(name) {
  if (picOpenPopover === name) {
    closePicPopovers();
    return;
  }
  closePicPopovers();
  const map = {
    aspect: { panel: "picAspectPopover", chip: "picChipAspect", alignRight: false },
    attach: { panel: "picAttachPopover", chip: "picChipAttach", alignRight: true },
  };
  const ids = map[name];
  if (!ids) return;
  const panel = document.getElementById(ids.panel);
  const chip = document.getElementById(ids.chip);
  if (panel) panel.hidden = false;
  if (chip) {
    chip.setAttribute("aria-expanded", "true");
    chip.classList.add("active");
  }
  positionPicPopover(ids.panel, ids.chip, ids.alignRight);
  picOpenPopover = name;
  refreshPicPopovers();
  refreshPicChips();
}

/** Панель стилей: тот же вертикальный отступ от чипа, что у остальных поповеров; ширина как у поля ввода. */
function positionIllStylePanel() {
  const panel = document.getElementById("illStylePanel");
  const chip = document.getElementById("illChipStyle");
  const screen = document.getElementById("illustrationGenerateScreen");
  const wrap = document.getElementById("illPromptWrapper");
  if (!panel || !chip || !screen) return;
  const screenRect = screen.getBoundingClientRect();
  const chipRect = chip.getBoundingClientRect();
  const wrapRect = wrap ? wrap.getBoundingClientRect() : null;
  panel.style.position = "absolute";
  panel.style.top = chipRect.bottom - screenRect.top + ILL_POPOVER_CHIP_GAP + "px";
  panel.style.boxSizing = "border-box";
  if (wrapRect) {
    panel.style.left = wrapRect.left - screenRect.left + "px";
    panel.style.width = wrapRect.width + "px";
    panel.style.right = "auto";
  } else {
    panel.style.left = "12px";
    panel.style.right = "12px";
    panel.style.width = "auto";
  }
}

function closeIllPopovers() {
  ["illStylePanel", "illAspectPopover", "illResoPopover", "illAttachPopover"].forEach((id) => {
    const el = document.getElementById(id);
    if (el) {
      el.hidden = true;
      el.style.removeProperty("top");
      el.style.removeProperty("left");
      el.style.removeProperty("right");
      el.style.removeProperty("width");
    }
  });
  ["illChipStyle", "illChipAspect", "illChipReso", "illChipAttach"].forEach((id) => {
    const el = document.getElementById(id);
    if (el) {
      el.setAttribute("aria-expanded", "false");
      // Снимаем активную подсветку открытого состояния;
      // attachChip отдельно — подсветка зависит от наличия референса.
      if (id !== "illChipAttach") el.classList.remove("active");
    }
  });
  illOpenPopover = null;
  // Обновим подсветку чипа Прикрепить, если ссылка на референс осталась
  refreshIllChips();
}

function openIllPopover(name) {
  if (illOpenPopover === name) {
    closeIllPopovers();
    return;
  }
  closeIllPopovers();
  const map = {
    style: { panel: "illStylePanel", chip: "illChipStyle", alignRight: false },
    aspect: { panel: "illAspectPopover", chip: "illChipAspect", alignRight: false },
    reso: { panel: "illResoPopover", chip: "illChipReso", alignRight: true },
    attach: { panel: "illAttachPopover", chip: "illChipAttach", alignRight: true },
  };
  const ids = map[name];
  if (!ids) return;
  const panel = document.getElementById(ids.panel);
  const chip = document.getElementById(ids.chip);
  if (panel) panel.hidden = false;
  if (chip) {
    chip.setAttribute("aria-expanded", "true");
    chip.classList.add("active");
  }
  if (name === "style") {
    positionIllStylePanel();
  } else {
    positionIllPopover(ids.panel, ids.chip, ids.alignRight);
  }
  illOpenPopover = name;
  refreshIllChips();
}

/** Рендерит горизонтальную ленту миниатюр в панели выбора стиля. */
function renderIllStyleGrid() {
  const grid = document.getElementById("illStyleGrid");
  if (!grid) return;
  grid.innerHTML = "";
  ILL_STYLE_DEFS.forEach((def) => {
    const card = document.createElement("button");
    card.type = "button";
    card.className = "ill-style-card" + (def.id === illStyleId ? " active" : "");
    card.dataset.illStyleId = def.id;

    const thumb = document.createElement("div");
    thumb.className = "ill-style-card-thumb";
    thumb.style.backgroundImage = `url("${def.thumb}")`;
    card.appendChild(thumb);

    const name = document.createElement("div");
    name.className = "ill-style-card-name";
    name.textContent = def.shortName || def.title;
    card.appendChild(name);

    card.onclick = () => {
      if (illGenerateState === "generating") return;
      illStyleId = def.id;
      renderIllStyleGrid();
      closeIllPopovers();
    };

    grid.appendChild(card);
  });
}

function showIllRefSlideError(message) {
  const hint = document.getElementById("illRefSlideHint");
  if (!hint) return;
  hint.textContent = message;
  hint.classList.add("ill-ref-hint-error");
}

function clearIllRefSlideHintError() {
  const hint = document.getElementById("illRefSlideHint");
  if (!hint) return;
  hint.classList.remove("ill-ref-hint-error");
  hint.textContent = "";
}

/**
 * Рендер выделенной фигуры в PNG (PowerPointApi 1.10+).
 * @returns {Promise<string>} base64 без префикса data URL
 */
async function captureIllustrationRefFromSelectedShape() {
  if (typeof PowerPoint === "undefined") {
    throw new Error("API PowerPoint недоступен");
  }
  return await PowerPoint.run(async (context) => {
    const selectedShapes = context.presentation.getSelectedShapes();
    const countResult = selectedShapes.getCount();
    await context.sync();
    if (countResult.value !== 1) {
      throw new Error("Выделите одно изображение на слайде");
    }
    const shape = selectedShapes.getItemAt(0);
    const imageResult = shape.getImageAsBase64({ format: "Png" });
    await context.sync();
    const b64 = imageResult.value;
    if (!b64 || typeof b64 !== "string" || !b64.trim()) {
      throw new Error("Не удалось получить изображение — попробуйте другую фигуру");
    }
    return b64.trim();
  });
}

function updateIllMainButton() {
  const btn = document.getElementById("illGenerateMainBtn");
  const input = document.getElementById("illPromptInput");
  if (!btn || !input) return;
  if (illGenerateState === "generating") {
    btn.className = "gen-inline-send-btn generating gen-inline-send-btn--cancel";
    btn.disabled = false;
    btn.setAttribute("aria-label", "Отменить генерацию");
    btn.title = "Отменить генерацию";
    return;
  }
  const hasText = !!input.value.trim();
  if (hasText) {
    btn.className = "gen-inline-send-btn active";
    btn.disabled = false;
    btn.setAttribute("aria-label", "Сгенерировать");
    btn.title = "Сгенерировать";
  } else {
    btn.className = "gen-inline-send-btn disabled";
    btn.disabled = true;
    btn.removeAttribute("aria-label");
    btn.removeAttribute("title");
  }
}

function renderIllHistory() {
  const section = document.getElementById("illHistorySection");
  const leftCol = document.getElementById("illHistoryColLeft");
  const rightCol = document.getElementById("illHistoryColRight");
  if (!section || !leftCol || !rightCol) return;

  const history = getIllHistory();

  if (history.length === 0) {
    section.style.display = "none";
    leftCol.innerHTML = "";
    rightCol.innerHTML = "";
    return;
  }

  section.style.display = "block";

  const gen = ++illHistoryLayoutGeneration;

  Promise.all(history.map((url) => loadImageAspectRatio(url)))
    .then((ratios) => {
      if (gen !== illHistoryLayoutGeneration) return;

      const { left, right } = distributeHistoryToBalancedColumns(history, ratios);

      leftCol.innerHTML = "";
      rightCol.innerHTML = "";

      function appendColumn(col, urls) {
        urls.forEach((url) => {
          col.appendChild(buildIllHistoryItem(url));
        });
      }

      appendColumn(leftCol, left);
      appendColumn(rightCol, right);
    })
    .catch((err) => {
      console.error("Failed to layout illustration history:", err);
    });
}

/** Главный рендерер блока с иллюстрацией (#illGenerationBox) — 16:9 фрейм с overlay-кнопками как у фото. */
function renderIllGenBox() {
  const box = document.getElementById("illGenerationBox");
  if (!box) return;

  const hide = () => {
    box.classList.remove("visible");
    box.innerHTML = "";
  };

  if (illUiMode === "edit") {
    if (!illPendingSourceUrl) {
      hide();
      return;
    }
    let html = '<div class="gen-box-stack">';
    html += getPhotoGenResultFrameHtml(illPendingSourceUrl, null, {
      role: "source",
      actions: ["upscale", "insert"],
    });
    if (illGenerateState === "generating") {
      html += getPhotoGenLoadingFrameHtml();
    } else if (illGenerateState === "result" && illGeneratedImageUrl) {
      html += getPhotoGenResultFrameHtml(illGeneratedImageUrl, null, {
        role: "result",
        actions: ILL_GEN_FRAME_ALL_ACTIONS,
      });
    }
    html += "</div>";
    box.classList.add("visible");
    box.innerHTML = html;
    return;
  }

  if (illUiMode === "upscale") {
    if (!illPendingSourceUrl) {
      hide();
      return;
    }
    let html = '<div class="gen-box-stack">';
    html += getPhotoGenResultFrameHtml(illPendingSourceUrl, null, {
      role: "source",
      actions: ["insert"],
    });
    if (illGenerateState === "generating") {
      html += getPhotoGenLoadingFrameHtml();
    } else if (illGenerateState === "result" && illGeneratedImageUrl) {
      html += getPhotoGenResultFrameHtml(illGeneratedImageUrl, null, {
        role: "result",
        actions: ILL_GEN_FRAME_ALL_ACTIONS,
      });
    }
    html += "</div>";
    box.classList.add("visible");
    box.innerHTML = html;
    return;
  }

  if (illGenerateState === "generating") {
    box.classList.add("visible");
    box.innerHTML = getPhotoGenLoadingFrameHtml();
    return;
  }
  if (illGenerateState === "result" && illGeneratedImageUrl) {
    box.classList.add("visible");
    box.innerHTML =
      '<div class="gen-box-stack">' +
      getPhotoGenResultFrameHtml(illGeneratedImageUrl, null, {
        role: "result",
        actions: ILL_GEN_FRAME_ALL_ACTIONS,
      }) +
      "</div>";
    return;
  }
  if (illGenerateState === "error") {
    return;
  }
  hide();
}

/**
 * @param {"idle"|"generating"|"error"|"result"} state
 * @param {{ skipHistoryAdd?: boolean }} [opts] — для result: не дублировать запись в истории (отмена повторной генерации)
 */
function setIllustrationGenerateState(state, opts) {
  illGenerateState = state;

  const input = document.getElementById("illPromptInput");
  if (input) {
    switch (state) {
      case "idle":
        input.disabled = false;
        input.classList.remove("generating");
        clearIllRefSlideHintError();
        illGeneratedImageUrl = null;
        setIllControlsDisabled(false);
        updateIllMainButton();
        renderIllGenBox();
        renderIllHistory();
        break;

      case "generating":
        input.disabled = true;
        input.classList.add("generating");
        setIllControlsDisabled(true);
        updateIllMainButton();
        renderIllGenBox();
        break;

      case "error":
        input.disabled = false;
        input.classList.remove("generating");
        setIllControlsDisabled(false);
        updateIllMainButton();
        // box.innerHTML с ошибкой ставится снаружи (в callN8nIllustration)
        break;

      case "result":
        input.disabled = false;
        input.classList.remove("generating");
        setIllControlsDisabled(false);
        updateIllMainButton();
        if (illGeneratedImageUrl) {
          if (!opts || !opts.skipHistoryAdd) {
            addToIllHistory(illGeneratedImageUrl);
          }
          renderIllGenBox();
          renderIllHistory();
        }
        break;
    }
  }
  updateHomeGenerationTileStatus();
}

function cancelIllGeneration() {
  if (illGenerateAbortController) {
    illGenerateAbortController.abort();
    illGenerateAbortController = null;
  }
}

/**
 * @param {{ action?: string, prompt?: string, sourceImageUrl?: string }} opts
 */
async function callN8nIllustration(opts) {
  const action = opts.action || "generate";
  const body = {
    action: action,
    serviceId: "yandex_ads_illustration",
  };

  if (action === "generate") {
    const def = getIllStyleDef(illStyleId);
    body.kind = def.payload.kind;
    body.style = def.payload.style;
    body.aspect = illAspect;
    body.maxSide = illMaxSide;
    if (illReferenceBase64) {
      body.sourceImageBase64 = illReferenceBase64;
      body.sourceImageMimeType = illReferenceMimeType || "image/png";
    }
  }

  if (action === "generate" || action === "edit") {
    const trimmed = String(opts.prompt || "").trim();
    if (!trimmed) {
      return;
    }
    body.prompt = trimmed;
  }

  if (action === "upscale" || action === "edit" || action === "remove") {
    const src = opts.sourceImageUrl || illGeneratedImageUrl;
    if (!src) {
      return;
    }
    body.sourceImageUrl = src;
  }

  cancelIllGeneration();
  if (action === "generate") {
    illustrationGenerateHomeReady = false;
    updateHomeGenerationTileStatus();
  }
  setIllustrationGenerateState("generating");

  illGenerateAbortController = new AbortController();
  const signal = illGenerateAbortController.signal;

  let hitGenerationTimeout = false;
  const timeoutId = setTimeout(() => {
    hitGenerationTimeout = true;
    try {
      illGenerateAbortController.abort();
    } catch (_e) {
      /* ignore */
    }
  }, N8N_GENERATION_TIMEOUT_MS);

  try {
    const startResponse = await fetch(ILLUSTRATION_N8N_START_URL, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(body),
      signal: signal,
    });

    const rawText = await startResponse.text();
    let data = null;
    if (rawText) {
      try {
        data = JSON.parse(rawText);
      } catch {
        data = null;
      }
    }

    if (!startResponse.ok) {
      const st = startResponse.status;
      let msg;
      if (st === 504 || st === 502) {
        msg =
          "Таймаут шлюза (код " +
          st +
          "): настройте быстрый ответ с taskId и webhook illustration-generate-status (как для фото)";
      } else if (data && (data.error || data.message)) {
        msg = String(data.error || data.message);
      } else if (rawText && rawText.length < 400 && !data) {
        msg = rawText.trim().replace(/\s+/g, " ");
      } else {
        msg = "Ошибка запроса: " + st;
      }
      throw new Error(msg);
    }

    if (!data || typeof data !== "object") {
      throw new Error(
        "Сервер вернул не JSON (код " +
          startResponse.status +
          "), проверьте webhook illustration-generate в n8n"
      );
    }

    if (!data.success) {
      throw new Error(data.error || "Генерация не удалась");
    }

    let url =
      extractStatusImageUrl(data) ||
      (typeof data.imageUrl === "string" && data.imageUrl.trim() ? data.imageUrl.trim() : null);

    if (!url && shouldPollN8nResult(data)) {
      url = await pollN8nUntilImage(data, signal, { pollBaseUrl: ILLUSTRATION_N8N_POLL_URL });
    }

    if (!url) {
      throw new Error(
        data.error ||
          "В ответе нет URL изображения — настройте опрос illustration-generate-status или синхронный Respond"
      );
    }

    illGeneratedImageUrl = url;
    illustrationGenerateHomeReady = true;
    setIllustrationGenerateState("result");
  } catch (error) {
    if (error.name === "AbortError") {
      if (hitGenerationTimeout) {
        const timeoutMsg =
          "Превышено время ожидания (5 мин), попробуйте ещё раз или упростите запрос";
        const box = document.getElementById("illGenerationBox");
        if (box) {
          box.classList.add("visible");
          box.innerHTML = '<div class="error-text">' + timeoutMsg + "</div>";
        }
        setIllustrationGenerateState("error");
      } else if (illGeneratedImageUrl) {
        setIllustrationGenerateState("result", { skipHistoryAdd: true });
      } else {
        setIllustrationGenerateState("idle");
      }
      return;
    }

    console.error("Illustration generation failed:", error);

    const msg = formatFetchErrorMessage(error);

    const box = document.getElementById("illGenerationBox");
    if (box) {
      box.classList.add("visible");
      box.innerHTML = '<div class="error-text">' + msg + "</div>";
    }
    setIllustrationGenerateState("error");
  } finally {
    clearTimeout(timeoutId);
    illGenerateAbortController = null;
  }
}

async function callN8nIllustrationGenerate(promptText) {
  await callN8nIllustration({ action: "generate", prompt: promptText });
}

// ========================
// Slides library helpers
// ========================

function updateTagsBadge() {
  const badge = document.getElementById("tagsBadge");
  const clearIcon = document.querySelector(".tags-icon-clear");
  if (!badge) return;
  const totalSelected = selectedTagsState.type.length;
  badge.textContent = totalSelected;
  badge.classList.toggle("visible", totalSelected > 0);
  if (clearIcon) {
    clearIcon.classList.toggle("visible", totalSelected > 0);
  }
}

function renderTags() {
  Object.keys(allTags).forEach((category) => {
    const container = document.querySelector('.tags-list[data-category="' + category + '"]');
    if (!container) return;
    container.innerHTML = "";

    allTags[category].forEach((tag) => {
      const chip = document.createElement("button");
      chip.className = "tag-chip";
      chip.textContent = category === "type" ? slideTypeLabelRu(tag) : tag;

      const isSelected = selectedTagsState[category].includes(tag);
      if (isSelected) chip.classList.add("selected");

      chip.onclick = () => {
        const index = selectedTagsState[category].indexOf(tag);
        if (index === -1) {
          selectedTagsState[category].push(tag);
          chip.classList.add("selected");
        } else {
          selectedTagsState[category].splice(index, 1);
          chip.classList.remove("selected");
        }
        updateTagsBadge();
        filterSlides();
      };

      container.appendChild(chip);
    });
  });
}

function createSlideCard(slide) {
  const card = document.createElement("div");
  card.className = "slide-card";
  card.dataset.slideId = slide.id;

  const img = document.createElement("img");
  img.src = slide.preview;
  img.className = "slide-preview";
  img.alt = slide.name;
  img.title = slide.name;

  const checkbox = document.createElement("div");
  checkbox.className = "slide-checkbox";
  checkbox.innerHTML =
    '<svg width="12" height="12" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">' +
    '<circle cx="10" cy="10" r="10" fill="white"/>' +
    "</svg>";

  card.appendChild(img);
  card.appendChild(checkbox);

  card.onclick = () => {
    const index = selectedSlides.findIndex((s) => s.id === slide.id);
    if (index === -1) {
      selectedSlides.push(slide);
      card.classList.add("selected");
    } else {
      selectedSlides.splice(index, 1);
      card.classList.remove("selected");
    }
    updateLibraryInsertButton();
  };

  return card;
}

function filterSlides() {
  const searchInput = document.getElementById("librarySearch");
  const searchQuery = (searchInput ? searchInput.value : "").toLowerCase().trim();
  const gallery = document.getElementById("slidesGallery");
  if (!gallery) return;

  gallery.innerHTML = "";

  const hasTypeFilters = selectedTagsState.type.length > 0;

  const filtered = (slidesDataByTheme[selectedSlidesTheme] || []).filter((slide) => {
    const labelRu = slideTypeLabelRu(slide.type).toLowerCase();
    const matchesSearch =
      searchQuery === "" ||
      slide.name.toLowerCase().includes(searchQuery) ||
      slide.type.toLowerCase().includes(searchQuery) ||
      labelRu.includes(searchQuery) ||
      slide.tags.type.some((t) => t.toLowerCase().includes(searchQuery));

    const matchesTypeFilter =
      !hasTypeFilters ||
      selectedTagsState.type.some((selectedTag) => slide.tags.type.includes(selectedTag));

    return matchesSearch && matchesTypeFilter;
  });

  filtered.forEach((slide) => {
    const card = createSlideCard(slide);
    if (selectedSlides.some((s) => s.id === slide.id)) {
      card.classList.add("selected");
    }
    gallery.appendChild(card);
  });
}

function updateSlidesThemeSwatches() {
  document.querySelectorAll(".slide-theme-swatch").forEach((sw) => {
    sw.classList.toggle("active", sw.dataset.theme === selectedSlidesTheme);
  });
}

function loadSlides() {
  const tagsContainer = document.getElementById("tagsContainer");
  const tagsPanel = document.getElementById("tagsPanel");

  if (tagsContainer) {
    tagsContainer.classList.remove("expanded");
  }
  if (tagsPanel) {
    tagsPanel.classList.remove("expanded");
  }

  renderTags();
  filterSlides();
  updateSlidesThemeSwatches();
  updateLibraryInsertButton();
  updateTagsBadge();
}

function clearSlidesSelection() {
  selectedSlides = [];
  document.querySelectorAll("#slidesGallery .slide-card").forEach((card) => {
    card.classList.remove("selected");
  });
  updateLibraryInsertButton();
}

function switchLibraryTab(tab) {
  activeLibraryTab = tab;

  document.querySelectorAll(".library-tab").forEach((el) => {
    el.classList.toggle("active", el.dataset.tab === tab);
  });

  const slidesContent = document.getElementById("librarySlidesContent");
  const photosContent = document.getElementById("libraryPhotosContent");
  const iconsContent = document.getElementById("libraryIconsContent");
  const flagsContent = document.getElementById("libraryFlagsContent");
  const logosContent = document.getElementById("libraryLogosContent");
  const disclaimer = document.getElementById("libraryDisclaimer");

  if (slidesContent) slidesContent.style.display = tab === "slides" ? "" : "none";
  if (photosContent) photosContent.style.display = tab === "photos" ? "" : "none";
  if (iconsContent) iconsContent.style.display = tab === "icons" ? "" : "none";
  if (flagsContent) flagsContent.style.display = tab === "flags" ? "" : "none";
  if (logosContent) logosContent.style.display = tab === "logos" ? "" : "none";
  if (disclaimer) disclaimer.style.display = tab === "slides" ? "" : "none";

  const tagsSlides = document.getElementById("libraryTagsSlides");
  const tagsPhotos = document.getElementById("libraryTagsPhotos");
  const tagsIcons = document.getElementById("libraryTagsIcons");
  const tagsFlags = document.getElementById("libraryTagsFlags");
  const tagsLogos = document.getElementById("libraryTagsLogos");
  if (tagsSlides) tagsSlides.style.display = tab === "slides" ? "block" : "none";
  if (tagsPhotos) tagsPhotos.style.display = tab === "photos" ? "block" : "none";
  if (tagsIcons) tagsIcons.style.display = tab === "icons" ? "block" : "none";
  if (tagsFlags) tagsFlags.style.display = tab === "flags" ? "block" : "none";
  if (tagsLogos) tagsLogos.style.display = tab === "logos" ? "block" : "none";

  if (tab === "slides") {
    selectedImages = [];
    selectedIcons = [];
    selectedFlags = [];
    selectedLogos = [];
    clearGallerySelection();
    clearIconsSelection();
    clearFlagsSelection();
    clearLogosSelection();
    filterSlides();
  } else if (tab === "photos") {
    selectedSlides = [];
    selectedIcons = [];
    selectedFlags = [];
    selectedLogos = [];
    clearSlidesSelection();
    clearIconsSelection();
    clearFlagsSelection();
    clearLogosSelection();
    loadPhotos();
  } else if (tab === "icons") {
    selectedSlides = [];
    selectedImages = [];
    selectedFlags = [];
    selectedLogos = [];
    clearGallerySelection();
    clearSlidesSelection();
    clearFlagsSelection();
    clearLogosSelection();
    loadIcons();
  } else if (tab === "flags") {
    selectedSlides = [];
    selectedImages = [];
    selectedIcons = [];
    selectedLogos = [];
    clearGallerySelection();
    clearSlidesSelection();
    clearIconsSelection();
    clearLogosSelection();
    loadFlags();
  } else if (tab === "logos") {
    selectedSlides = [];
    selectedImages = [];
    selectedIcons = [];
    selectedFlags = [];
    clearGallerySelection();
    clearSlidesSelection();
    clearIconsSelection();
    clearFlagsSelection();
    loadLogos();
  }
  updateLibraryInsertButton();
}

// ========================
// Slides insertion into PowerPoint
// ========================

/**
 * Вставляет слайд из .pptx в презентацию.
 * @param {string} pptxUrl — URL файла .pptx
 * @param {{ targetSlideId?: string }} [options] — targetSlideId: вставить после этого слайда
 */
async function insertSlideFromPPTX(pptxUrl, options = {}) {
  const response = await fetch(pptxUrl);
  if (!response.ok) {
    throw new Error("Failed to fetch slide: " + response.status);
  }

  const blob = await response.blob();
  const base64data = await blobToBase64(blob);

  const insertOptions = options.targetSlideId
    ? { targetSlideId: options.targetSlideId }
    : undefined;
  if (options.targetSlideId) {
    insertOptions.targetSlideId = options.targetSlideId;
  }

  return new Promise((resolve, reject) => {
    PowerPoint.run(async (context) => {
      try {
        context.presentation.insertSlidesFromBase64(base64data, insertOptions);
        await context.sync();
        resolve();
      } catch (error) {
        reject(error);
      }
    });
  });
}

/** Возвращает id выделенного слайда или null, если нет выделения. */
async function getSelectedSlideId() {
  try {
    return await PowerPoint.run(async (context) => {
      const selected = context.presentation.getSelectedSlides();
      const countResult = selected.getCount();
      await context.sync();
      if (countResult.value === 0) return null;
      const slide = selected.getItemAt(0);
      slide.load("id");
      await context.sync();
      return slide.id;
    });
  } catch {
    return null;
  }
}

async function insertSelectedSlides() {
  if (selectedSlides.length === 0) return;

  const btn = document.getElementById("libraryInsertBtn");
  if (btn) {
    btn.disabled = true;
    btn.textContent = "Вставка...";
  }

  const toInsert = [...selectedSlides];

  try {
    const targetSlideId = await getSelectedSlideId();

    // Вставляем в обратном порядке: insertSlidesFromBase64 добавляет слайды в начало (или сразу после targetSlideId)
    const slidesToInsert = toInsert.slice().reverse();
    for (const slide of slidesToInsert) {
      await insertSlideFromPPTX(slide.pptx, targetSlideId ? { targetSlideId } : {});
    }

    clearSlidesSelection();
  } catch (err) {
    console.error("Failed to insert slides:", err);
  }
  updateLibraryInsertButton();
}

// ========================
// Table formatting
// ========================

/** Стиль таблицы: из slides-theme.json (единая точка смены дизайна). */
const TABLE_STYLE = {
  fontName:
    (slidesTheme.table && slidesTheme.table.fontName) || slidesTheme.theme?.fontFamily || "YS Text",
  fontSize: (slidesTheme.table && slidesTheme.table.fontSize) ?? 28,
  headerTextColor:
    (slidesTheme.table && slidesTheme.table.headerTextColor) ||
    slidesTheme.theme?.colors?.textMuted ||
    "#8495B8",
  bodyTextColor:
    (slidesTheme.table && slidesTheme.table.bodyTextColor) ||
    slidesTheme.theme?.colors?.textSecondary ||
    "#46557D",
  headerBottomColor: (slidesTheme.table && slidesTheme.table.headerBottomColor) || "#46557D",
  headerBottomWeight: (slidesTheme.table && slidesTheme.table.headerBottomWeight) ?? 1.5,
  rowSeparatorColor: (slidesTheme.table && slidesTheme.table.rowSeparatorColor) || "#ADBBD5",
  rowSeparatorWeight: (slidesTheme.table && slidesTheme.table.rowSeparatorWeight) ?? 1,
};

/**
 * Форматирует выделенную таблицу в стиле Яндекс Рекламы.
 * Шрифт YS Text 28pt, цвета текста 46557D/8495B8, только горизонтальные линии.
 * @throws {Error} если не выделена ровно одна таблица
 */
async function formatSelectedTable() {
  if (typeof PowerPoint === "undefined") {
    throw new Error("PowerPoint API недоступен");
  }

  await PowerPoint.run(async (context) => {
    const selectedShapes = context.presentation.getSelectedShapes();
    const countResult = selectedShapes.getCount();
    await context.sync();

    if (countResult.value !== 1) {
      throw new Error("Выделите ровно одну таблицу на слайде");
    }

    const shape = selectedShapes.getItemAt(0);
    let table;
    try {
      table = shape.getTable();
    } catch (_e) {
      throw new Error("Выделенный объект не является таблицей — выделите таблицу на слайде");
    }
    await context.sync();

    const rowCountResult = table.rows.getCount();
    const columnCountResult = table.columns.getCount();
    await context.sync();

    const rowCount = rowCountResult.value;
    const columnCount = columnCountResult.value;

    table.style = "NoStyleNoGrid";

    for (let r = 0; r < rowCount; r++) {
      for (let c = 0; c < columnCount; c++) {
        const cell = table.getCellOrNullObject(r, c);
        cell.load("isNullObject");
        await context.sync();
        if (cell.isNullObject) continue;

        const isHeaderRow = r === 0;
        const textColor = isHeaderRow ? TABLE_STYLE.headerTextColor : TABLE_STYLE.bodyTextColor;

        cell.fill.setSolidColor("#FFFFFF");

        cell.font.load("name", "size", "color", "bold");
        await context.sync();

        cell.font.name = TABLE_STYLE.fontName;
        cell.font.size = TABLE_STYLE.fontSize;
        cell.font.color = textColor;
        cell.font.bold = false;
        cell.horizontalAlignment = "Left";

        const borders = cell.borders;
        borders.left.weight = 0;
        borders.right.weight = 0;
        try {
          borders.diagonalDown.weight = 0;
          borders.diagonalUp.weight = 0;
        } catch {
          /* не все сборки поддерживают диагонали */
        }
        if (isHeaderRow) {
          borders.top.weight = 0;
          borders.bottom.dashStyle = "Solid";
          borders.bottom.color = TABLE_STYLE.headerBottomColor;
          borders.bottom.weight = TABLE_STYLE.headerBottomWeight;
        } else if (r === 1) {
          borders.top.dashStyle = "Solid";
          borders.top.color = TABLE_STYLE.headerBottomColor;
          borders.top.weight = TABLE_STYLE.headerBottomWeight;
          borders.bottom.dashStyle = "Solid";
          borders.bottom.color = TABLE_STYLE.rowSeparatorColor;
          borders.bottom.weight = TABLE_STYLE.rowSeparatorWeight;
        } else {
          borders.top.dashStyle = "Solid";
          borders.top.color = TABLE_STYLE.rowSeparatorColor;
          borders.top.weight = TABLE_STYLE.rowSeparatorWeight;
          borders.bottom.weight = 0;
        }
      }
    }

    await context.sync();
  });
}

// ========================
// Initialization
// ========================

let taskpaneUiInitialized = false;
let officeRuntimeReady = false;

function isOfficeRuntimeReady() {
  return officeRuntimeReady && typeof Office !== "undefined";
}

function officeRuntimeUnavailableMessage() {
  if (typeof Office === "undefined") {
    return "Не удалось загрузить Office.js. Проверьте доступ к appsforoffice.microsoft.com и перезапустите PowerPoint.";
  }
  return "PowerPoint ещё инициализирует надстройку. Подождите несколько секунд или перезапустите PowerPoint.";
}

function alertOfficeRuntimeUnavailable() {
  window.alert(officeRuntimeUnavailableMessage());
}

function initializeTaskpaneUi() {
  if (taskpaneUiInitialized) return;
  taskpaneUiInitialized = true;

  try {
    loadImages();
  } catch (err) {
    console.error("Failed to initialize photo library:", err);
  }

  try {
    loadSlides();
  } catch (err) {
    console.error("Failed to initialize slide library:", err);
  }

  const librarySearch = document.getElementById("librarySearch");
  if (librarySearch) {
    librarySearch.addEventListener("input", () => {
      if (activeLibraryTab === "slides") filterSlides();
      else if (activeLibraryTab === "photos") filterImages();
      else if (activeLibraryTab === "icons") filterIcons();
      else if (activeLibraryTab === "flags") filterFlags();
      else if (activeLibraryTab === "logos") filterLogos();
    });
  }

  updateLibraryInsertButton();

  // --- Library tab switches ---
  document.querySelectorAll(".library-tab").forEach((tabEl) => {
    tabEl.onclick = () => {
      if (tabEl.classList.contains("disabled")) return;
      switchLibraryTab(tabEl.dataset.tab);
    };
  });

  // --- Library action bar ---
  const libraryClearBtn = document.getElementById("libraryClearBtn");
  if (libraryClearBtn) {
    libraryClearBtn.onclick = () => {
      if (activeLibraryTab === "slides") {
        clearSlidesSelection();
      } else if (activeLibraryTab === "photos") {
        selectedImages = [];
        clearGallerySelection();
        updateLibraryInsertButton();
      } else if (activeLibraryTab === "icons") {
        clearIconsSelection();
      } else if (activeLibraryTab === "flags") {
        clearFlagsSelection();
      } else if (activeLibraryTab === "logos") {
        clearLogosSelection();
      }
    };
  }

  const libraryInsertBtn = document.getElementById("libraryInsertBtn");
  if (libraryInsertBtn) {
    libraryInsertBtn.onclick = async () => {
      if (!isOfficeRuntimeReady()) {
        alertOfficeRuntimeUnavailable();
        return;
      }
      if (activeLibraryTab === "slides") {
        await insertSelectedSlides();
      } else if (activeLibraryTab === "photos") {
        await insertSelectedImages();
      } else if (activeLibraryTab === "icons") {
        await insertSelectedIcons();
      } else if (activeLibraryTab === "flags") {
        await insertSelectedFlags();
      } else if (activeLibraryTab === "logos") {
        await insertSelectedLogos();
      }
    };
  }

  document.querySelectorAll(".icon-color-swatch").forEach((sw) => {
    sw.onclick = () => {
      iconColor = sw.dataset.color;
      document
        .querySelectorAll(".icon-color-swatch")
        .forEach((s) => s.classList.toggle("active", s.dataset.color === iconColor));
      filterIcons();
    };
  });

  document.querySelectorAll(".slide-theme-swatch").forEach((sw) => {
    sw.onclick = () => {
      selectedSlidesTheme =
        sw.dataset.theme === SLIDE_THEME_LIGHT ? SLIDE_THEME_LIGHT : SLIDE_THEME_DARK;
      clearSlidesSelection();
      updateSlidesThemeSwatches();
      filterSlides();
    };
  });

  const iconsTagsToggleBtn = document.getElementById("iconsTagsToggleBtn");
  const iconsTagsPanel = document.getElementById("iconsTagsPanel");
  const iconsTagsContainer = document.getElementById("iconsTagsContainer");
  if (iconsTagsToggleBtn && iconsTagsPanel && iconsTagsContainer) {
    iconsTagsToggleBtn.onclick = (e) => {
      const clearIcon = e.target.closest(".icons-tags-clear");
      if (clearIcon && selectedIconsTags.length > 0) {
        selectedIconsTags = [];
        updateIconsTagsBadge();
        renderIconsTags();
        filterIcons();
        e.stopPropagation();
        return;
      }
      const isExpanded = iconsTagsPanel.classList.toggle("expanded");
      iconsTagsContainer.classList.toggle("expanded", isExpanded);
    };
  }

  const flagsTagsToggleBtn = document.getElementById("flagsTagsToggleBtn");
  const flagsTagsPanel = document.getElementById("flagsTagsPanel");
  const flagsTagsContainer = document.getElementById("flagsTagsContainer");
  if (flagsTagsToggleBtn && flagsTagsPanel && flagsTagsContainer) {
    flagsTagsToggleBtn.onclick = (e) => {
      const clearIcon = e.target.closest(".flags-tags-clear");
      const hasSelected = selectedFlagsRegion.length > 0 || selectedFlagsPopular !== null;
      if (clearIcon && hasSelected) {
        selectedFlagsRegion = [];
        selectedFlagsPopular = null;
        updateFlagsTagsBadge();
        renderFlagsTags();
        filterFlags();
        e.stopPropagation();
        return;
      }
      const isExpanded = flagsTagsPanel.classList.toggle("expanded");
      flagsTagsContainer.classList.toggle("expanded", isExpanded);
    };
  }

  const logosTagsToggleBtn = document.getElementById("logosTagsToggleBtn");
  const logosTagsPanel = document.getElementById("logosTagsPanel");
  const logosTagsContainer = document.getElementById("logosTagsContainer");
  if (logosTagsToggleBtn && logosTagsPanel && logosTagsContainer) {
    logosTagsToggleBtn.onclick = (e) => {
      const clearIcon = e.target.closest(".logos-tags-clear");
      const hasSelected = selectedLogosCategory.length + selectedLogosForm.length > 0;
      if (clearIcon && hasSelected) {
        selectedLogosCategory = [];
        selectedLogosForm = [];
        updateLogosTagsBadge();
        renderLogosTags();
        filterLogos();
        e.stopPropagation();
        return;
      }
      const isExpanded = logosTagsPanel.classList.toggle("expanded");
      logosTagsContainer.classList.toggle("expanded", isExpanded);
    };
  }

  const photosTagsToggleBtn = document.getElementById("photosTagsToggleBtn");
  const photosTagsPanel = document.getElementById("photosTagsPanel");
  const photosTagsContainer = document.getElementById("photosTagsContainer");
  if (photosTagsToggleBtn && photosTagsPanel && photosTagsContainer) {
    photosTagsToggleBtn.onclick = (e) => {
      const clearIcon = e.target.closest(".photos-tags-clear");
      const hasSelected = selectedPhotosTags.industry.length > 0;
      if (clearIcon && hasSelected) {
        selectedPhotosTags = { industry: [] };
        updatePhotosTagsBadge();
        renderPhotosTags();
        filterImages();
        e.stopPropagation();
        return;
      }
      const isExpanded = photosTagsPanel.classList.toggle("expanded");
      photosTagsContainer.classList.toggle("expanded", isExpanded);
    };
  }

  const generateBackTop = document.getElementById("generateBackTop");
  if (generateBackTop) {
    generateBackTop.onclick = () => {
      closePicPopovers();
      showScreen("homeScreen");
    };
  }

  const illustrationGenerateBackTop = document.getElementById("illustrationGenerateBackTop");
  if (illustrationGenerateBackTop) {
    illustrationGenerateBackTop.onclick = () => {
      // Не сбрасываем состояние — пользователь увидит результат при возврате.
      closeIllPopovers();
      showScreen("homeScreen");
    };
  }

  const generatePhotoBtn = document.getElementById("generatePhotoBtn");
  if (generatePhotoBtn) {
    generatePhotoBtn.onclick = () => {
      cancelIllGeneration();
      if (generateState === "idle" || generateState === "error") {
        resetPhotoUiToGenerate();
        clearPhotoRefSlideHintError();
        clearPhotoReference();
        updatePhotoRefSlideUi();
      } else {
        applyPhotoUiModeChrome();
      }
      applyIllChipIcons();
      closePicPopovers();
      refreshPicChips();
      refreshPicPopovers();
      showScreen("generateScreen");
      renderPhotoGenBox();
      renderHistory();
      updateMainButton();
      const pi = document.getElementById("promptInput");
      if (pi) autoResize(pi);
    };
  }

  const generateIllustrationBtn = document.getElementById("generateIllustrationBtn");
  if (generateIllustrationBtn) {
    generateIllustrationBtn.onclick = () => {
      // НЕ сбрасываем state — позволяем вернуться к текущему результату/прогрессу.
      closePicPopovers();
      applyIllChipIcons();
      showScreen("illustrationGenerateScreen");
      applyIllUiModeChrome();
      refreshIllChips();
      refreshIllPopovers();
      renderIllStyleGrid();
      updateIllRefSlideUi();
      renderIllGenBox();
      renderIllHistory();
      updateIllMainButton();
      const pi = document.getElementById("illPromptInput");
      if (pi) autoResize(pi);
      _illustrationScreenInitialized = true;
    };
  }

  const formatTablesBtn = document.getElementById("formatTablesBtn");
  if (formatTablesBtn) {
    formatTablesBtn.onclick = () => {
      showScreen("formatTablesScreen");
      const tableMsg = document.getElementById("formatTableMessage");
      if (tableMsg) tableMsg.style.display = "none";
    };
  }

  const formatTablesBackBtn = document.getElementById("formatTablesBackBtn");
  if (formatTablesBackBtn) {
    formatTablesBackBtn.onclick = () => showScreen("homeScreen");
  }

  const textChatBtn = document.getElementById("textChatBtn");
  if (textChatBtn) {
    textChatBtn.onclick = () => showScreen("textChatScreen");
  }

  const textChatBackBtn = document.getElementById("textChatBackBtn");
  if (textChatBackBtn) {
    textChatBackBtn.onclick = () => showScreen("homeScreen");
  }

  const textChatClearBtn = document.getElementById("textChatClearBtn");
  if (textChatClearBtn) {
    textChatClearBtn.onclick = () => {
      if (textChatInFlight) return;
      clearTextChat();
    };
  }

  const textChatInput = document.getElementById("textChatInput");
  const textChatSendBtn = document.getElementById("textChatSendBtn");
  if (textChatInput) {
    textChatInput.addEventListener("keydown", (e) => {
      if (e.key === "Enter" && !e.shiftKey) {
        e.preventDefault();
        sendTextChatMessage();
      }
    });
  }
  if (textChatSendBtn) {
    textChatSendBtn.onclick = () => sendTextChatMessage();
  }

  const libraryBtn = document.getElementById("libraryBtn");
  if (libraryBtn) {
    libraryBtn.onclick = () => {
      showScreen("libraryScreen");
      if (activeLibraryTab === "slides") {
        filterSlides();
      } else if (activeLibraryTab === "photos") {
        filterImages();
      } else if (activeLibraryTab === "icons") {
        filterIcons();
      } else if (activeLibraryTab === "flags") {
        filterFlags();
      } else if (activeLibraryTab === "logos") {
        filterLogos();
      }
    };
  }

  const libraryBackBtn = document.getElementById("libraryBackBtn");
  if (libraryBackBtn) {
    libraryBackBtn.onclick = () => showScreen("homeScreen");
  }

  const formatTableBtn = document.getElementById("formatTableBtn");
  if (formatTableBtn) {
    formatTableBtn.onclick = async () => {
      const msgEl = document.getElementById("formatTableMessage");
      const showMsg = (text, isError) => {
        if (msgEl) {
          msgEl.textContent = text;
          msgEl.className = "format-message " + (isError ? "error" : "success");
          msgEl.style.display = "";
        }
      };
      if (!isOfficeRuntimeReady()) {
        showMsg(officeRuntimeUnavailableMessage(), true);
        return;
      }
      try {
        await formatSelectedTable();
        showMsg("Таблица отформатирована", false);
      } catch (err) {
        console.error("Format table error:", err);
        showMsg(err.message || "Не удалось отформатировать таблицу", true);
      }
    };
  }

  // --- Prompt input monitoring ---
  const promptInput = document.getElementById("promptInput");
  if (promptInput) {
    promptInput.addEventListener("input", () => {
      autoResize(promptInput);
      updateMainButton();
    });
  }

  // --- Back-arrow next to "Описание изменений" / "Улучшение качества" ---
  const genPromptBackBtn = document.getElementById("genPromptBackBtn");
  if (genPromptBackBtn) {
    genPromptBackBtn.onclick = () => {
      cancelGeneration();
      closePicPopovers();
      const pi = document.getElementById("promptInput");
      if (pi) {
        pi.value = "";
        autoResize(pi);
      }
      setGenerateState("idle");
    };
  }

  // --- Generate / Edit inline button ---
  const generateMainBtn = document.getElementById("generateMainBtn");
  if (generateMainBtn) {
    generateMainBtn.onclick = () => {
      if (generateState === "generating") {
        cancelGeneration();
        return;
      }
      const pi = document.getElementById("promptInput");
      if (!pi) return;
      const text = String(pi.value || "").trim();
      if (!text) return;
      if (photoUiMode === "edit") {
        if (!pendingSourceUrl) return;
        callN8nPhoto({
          action: "edit",
          prompt: text,
          sourceImageUrl: pendingSourceUrl,
        });
      } else if (photoUiMode === "generate") {
        callN8nGenerate(pi.value);
      }
    };
  }

  // --- Overlay buttons on result frames (event delegation) ---
  const generationBoxEl = document.getElementById("generationBox");
  if (generationBoxEl) {
    generationBoxEl.addEventListener("click", handleGenerationBoxClick);
  }

  // --- History overlay buttons (event delegation) ---
  const historyGridEl = document.getElementById("historyGrid");
  if (historyGridEl) {
    historyGridEl.addEventListener("click", handleHistoryGridClick);
  }

  const picChipAspectBtn = document.getElementById("picChipAspect");
  if (picChipAspectBtn) {
    picChipAspectBtn.onclick = () => {
      if (generateState === "generating") return;
      openPicPopover("aspect");
    };
  }
  const picChipAttachBtn = document.getElementById("picChipAttach");
  if (picChipAttachBtn) {
    picChipAttachBtn.onclick = () => {
      if (generateState === "generating") return;
      openPicPopover("attach");
    };
  }

  document.querySelectorAll("#picAspectPopover .ill-aspect-card").forEach((btn) => {
    btn.onclick = () => {
      if (generateState === "generating") return;
      selectedAspect = btn.dataset.picAspect || "horizontal";
      refreshPicPopovers();
      refreshPicChips();
      closePicPopovers();
    };
  });

  const picRefFileInput = document.getElementById("picRefFileInput");
  const picRefFromFileBtn = document.getElementById("picRefFromFileBtn");
  if (picRefFromFileBtn && picRefFileInput) {
    picRefFromFileBtn.onclick = () => {
      if (generateState === "generating") return;
      closePicPopovers();
      picRefFileInput.click();
    };
  }
  if (picRefFileInput) {
    picRefFileInput.addEventListener("change", async () => {
      if (generateState === "generating") return;
      const file = picRefFileInput.files && picRefFileInput.files[0];
      try {
        if (!file) return;
        clearPhotoRefSlideHintError();
        const data = await readIllustrationRefFromFile(file);
        picReferenceBase64 = data.base64;
        picReferenceMimeType = data.mimeType;
        _picReferenceSource = "file";
        updatePhotoRefSlideUi();
      } catch (err) {
        console.error("photo ref from file:", err);
        showPhotoRefSlideError(err.message || "Не удалось загрузить файл");
      } finally {
        picRefFileInput.value = "";
      }
    });
  }

  const picRefFromSlideBtn = document.getElementById("picRefFromSlideBtn");
  if (picRefFromSlideBtn) {
    picRefFromSlideBtn.onclick = async () => {
      if (generateState === "generating") return;
      if (!isOfficeRuntimeReady()) {
        showPhotoRefSlideError(officeRuntimeUnavailableMessage());
        return;
      }
      closePicPopovers();
      clearPhotoRefSlideHintError();
      picRefFromSlideBtn.disabled = true;
      try {
        const b64 = await captureIllustrationRefFromSelectedShape();
        picReferenceBase64 = b64;
        picReferenceMimeType = "image/png";
        _picReferenceSource = "slide";
        updatePhotoRefSlideUi();
      } catch (err) {
        console.error("photo ref from slide:", err);
        showPhotoRefSlideError(err.message || "Не удалось снять изображение со слайда");
      } finally {
        if (generateState !== "generating") {
          picRefFromSlideBtn.disabled = false;
        }
      }
    };
  }

  const picRefPreviewClearBtn = document.getElementById("picRefPreviewClearBtn");
  if (picRefPreviewClearBtn) {
    picRefPreviewClearBtn.onclick = () => {
      if (generateState === "generating") return;
      clearPhotoRefSlideHintError();
      clearPhotoReference();
      updatePhotoRefSlideUi();
    };
  }

  // --- Illustration screen ---
  const illPromptInput = document.getElementById("illPromptInput");
  if (illPromptInput) {
    illPromptInput.addEventListener("input", () => {
      autoResize(illPromptInput);
      updateIllMainButton();
    });
  }

  const illRefFileInput = document.getElementById("illRefFileInput");
  const illRefFromFileBtn = document.getElementById("illRefFromFileBtn");
  if (illRefFromFileBtn && illRefFileInput) {
    illRefFromFileBtn.onclick = () => {
      if (illGenerateState === "generating") return;
      closeIllPopovers();
      illRefFileInput.click();
    };
  }
  if (illRefFileInput) {
    illRefFileInput.addEventListener("change", async () => {
      if (illGenerateState === "generating") return;
      const file = illRefFileInput.files && illRefFileInput.files[0];
      try {
        if (!file) return;
        clearIllRefSlideHintError();
        const data = await readIllustrationRefFromFile(file);
        illReferenceBase64 = data.base64;
        illReferenceMimeType = data.mimeType;
        _illReferenceSource = "file";
        updateIllRefSlideUi();
        refreshIllChips();
      } catch (err) {
        console.error("illustration ref from file:", err);
        showIllRefSlideError(err.message || "Не удалось загрузить файл");
      } finally {
        illRefFileInput.value = "";
      }
    });
  }

  const illRefFromSlideBtn = document.getElementById("illRefFromSlideBtn");
  if (illRefFromSlideBtn) {
    illRefFromSlideBtn.onclick = async () => {
      if (illGenerateState === "generating") return;
      if (!isOfficeRuntimeReady()) {
        showIllRefSlideError(officeRuntimeUnavailableMessage());
        return;
      }
      closeIllPopovers();
      clearIllRefSlideHintError();
      illRefFromSlideBtn.disabled = true;
      try {
        const b64 = await captureIllustrationRefFromSelectedShape();
        illReferenceBase64 = b64;
        illReferenceMimeType = "image/png";
        _illReferenceSource = "slide";
        updateIllRefSlideUi();
        refreshIllChips();
      } catch (err) {
        console.error("illustration ref from slide:", err);
        showIllRefSlideError(err.message || "Не удалось снять изображение со слайда");
      } finally {
        if (illGenerateState !== "generating") {
          illRefFromSlideBtn.disabled = false;
        }
      }
    };
  }

  const illRefPreviewClearBtn = document.getElementById("illRefPreviewClearBtn");
  if (illRefPreviewClearBtn) {
    illRefPreviewClearBtn.onclick = (e) => {
      e.stopPropagation();
      if (illGenerateState === "generating") return;
      clearIllRefSlideHintError();
      clearIllReference();
      updateIllRefSlideUi();
      refreshIllChips();
    };
  }

  // Chip-кнопки и поповеры
  const illChipStyleBtn = document.getElementById("illChipStyle");
  if (illChipStyleBtn) {
    illChipStyleBtn.onclick = () => {
      if (illGenerateState === "generating") return;
      openIllPopover("style");
    };
  }
  const illChipAspectBtn = document.getElementById("illChipAspect");
  if (illChipAspectBtn) {
    illChipAspectBtn.onclick = () => {
      if (illGenerateState === "generating") return;
      openIllPopover("aspect");
    };
  }
  const illChipResoBtn = document.getElementById("illChipReso");
  if (illChipResoBtn) {
    illChipResoBtn.onclick = () => {
      if (illGenerateState === "generating") return;
      openIllPopover("reso");
    };
  }
  const illChipAttachBtn = document.getElementById("illChipAttach");
  if (illChipAttachBtn) {
    illChipAttachBtn.onclick = () => {
      if (illGenerateState === "generating") return;
      openIllPopover("attach");
    };
  }

  document.querySelectorAll("#illAspectPopover .ill-aspect-card").forEach((btn) => {
    btn.onclick = () => {
      illAspect = btn.dataset.illAspect || "16:9";
      refreshIllChips();
      refreshIllPopovers();
      closeIllPopovers();
    };
  });

  document.querySelectorAll("#illResoPopover .ill-radio-row").forEach((btn) => {
    btn.onclick = () => {
      const v = parseInt(btn.dataset.illMax || "1920", 10);
      illMaxSide = v >= 2880 ? 3840 : 1920;
      refreshIllChips();
      refreshIllPopovers();
      closeIllPopovers();
    };
  });

  // Закрыть панель/поповер по клику вне области
  document.addEventListener("mousedown", (e) => {
    const target = e.target;
    if (!(target instanceof Element)) return;

    if (illOpenPopover) {
      if (
        target.closest("#illStylePanel") ||
        target.closest("#illAspectPopover") ||
        target.closest("#illResoPopover") ||
        target.closest("#illAttachPopover") ||
        target.closest("#illChipStyle") ||
        target.closest("#illChipAspect") ||
        target.closest("#illChipReso") ||
        target.closest("#illChipAttach")
      ) {
        /* keep open */
      } else {
        closeIllPopovers();
      }
    }

    if (picOpenPopover) {
      if (
        target.closest("#picAspectPopover") ||
        target.closest("#picAttachPopover") ||
        target.closest("#picChipAspect") ||
        target.closest("#picChipAttach")
      ) {
        /* keep open */
      } else {
        closePicPopovers();
      }
    }
  });

  // Кнопка генерации
  const illGenerateMainBtn = document.getElementById("illGenerateMainBtn");
  if (illGenerateMainBtn) {
    illGenerateMainBtn.onclick = () => {
      const pi = document.getElementById("illPromptInput");
      if (!pi) return;
      if (illGenerateState === "generating") {
        cancelIllGeneration();
        return;
      }
      if (!pi.value.trim()) return;
      if (illUiMode === "edit") {
        if (!illPendingSourceUrl) return;
        callN8nIllustration({
          action: "edit",
          prompt: pi.value.trim(),
          sourceImageUrl: illPendingSourceUrl,
        });
      } else {
        callN8nIllustrationGenerate(pi.value);
      }
    };
  }

  // Делегированные клики на overlay-кнопках в #illGenerationBox
  const illGenBox = document.getElementById("illGenerationBox");
  if (illGenBox) {
    illGenBox.addEventListener("click", async (e) => {
      const target = e.target instanceof Element ? e.target : null;
      if (!target) return;
      const btn = target.closest("[data-result-action]");
      if (!btn) return;

      const action = btn.getAttribute("data-result-action");
      const frame = btn.closest(".gen-box-frame");
      const role =
        frame && frame.getAttribute("data-frame-role") === "source" ? "source" : "result";

      if (action === "insert") {
        const imgUrl = role === "source" ? illPendingSourceUrl : illGeneratedImageUrl || null;
        if (!imgUrl) return;

        const label = btn.querySelector("span");
        const oldText = label ? label.textContent : "";
        btn.disabled = true;
        if (label) label.textContent = "Вставка…";
        try {
          await insertImage(imgUrl, true);
          if (illUiMode === "generate") {
            illGeneratedImageUrl = null;
            illGenerateState = "idle";
            renderIllGenBox();
          } else {
            btn.disabled = false;
            if (label) label.textContent = oldText;
          }
        } catch (err) {
          console.error("Insert illustration failed:", err);
          btn.disabled = false;
          if (label) label.textContent = oldText;
        }
        return;
      }

      if (illGenerateState === "generating") return;

      const url = role === "source" ? illPendingSourceUrl : illGeneratedImageUrl || null;
      if (!url) return;

      if (action === "remove_bg") {
        callN8nIllustration({ action: "remove", sourceImageUrl: url });
        return;
      }
      if (action === "upscale") {
        startIllUpscaleMode(url);
        return;
      }
      if (action === "edit") {
        startIllEditMode(url);
      }
    });
  }

  const illHistoryGridEl = document.getElementById("illHistoryGrid");
  if (illHistoryGridEl) {
    illHistoryGridEl.addEventListener("click", handleIllHistoryGridClick);
  }

  const illPromptBackBtn = document.getElementById("illPromptBackBtn");
  if (illPromptBackBtn) {
    illPromptBackBtn.onclick = () => {
      resetIllUiToGenerate();
    };
  }

  applyIllChipIcons();
  refreshPicChips();
  refreshPicPopovers();

  // --- Slides tags (in library on home screen) ---
  const tagsToggleBtn = document.getElementById("tagsToggleBtn");
  const tagsPanel = document.getElementById("tagsPanel");
  const tagsContainer = document.getElementById("tagsContainer");
  if (tagsToggleBtn && tagsPanel && tagsContainer) {
    tagsToggleBtn.onclick = (e) => {
      const clearIcon = e.target.closest(".tags-icon-clear");
      const isClearVisible = selectedTagsState.type.length > 0;

      if (clearIcon && isClearVisible) {
        selectedTagsState = { type: [] };
        updateTagsBadge();
        renderTags();
        filterSlides();
        e.stopPropagation();
        return;
      }

      const isExpanded = tagsPanel.classList.toggle("expanded");
      tagsContainer.classList.toggle("expanded", isExpanded);
    };
  }
}

function initializeOfficeRuntime() {
  if (typeof Office === "undefined" || typeof Office.onReady !== "function") {
    console.error("Office.js did not load before taskpane initialization.");
    return;
  }

  try {
    Office.onReady(() => {
      officeRuntimeReady = true;
      initializeTaskpaneUi();
    });
  } catch (err) {
    console.error("Office.onReady failed:", err);
  }
}

window.addEventListener("error", (event) => {
  console.error("Taskpane runtime error:", event.error || event.message);
});

window.addEventListener("unhandledrejection", (event) => {
  console.error("Taskpane unhandled promise rejection:", event.reason);
});

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", initializeTaskpaneUi, { once: true });
} else {
  initializeTaskpaneUi();
}

initializeOfficeRuntime();
